// SP suffix: the text contains both the Singular and Plural form of a word

/* eslint-disable max-len, prettier/prettier */
/* eslint sort-keys: ["error", "asc", {caseSensitive: false, allowLineSeparatedGroups: true}] */
export const en = {
  common: {
    // Actions
    actionCreated: 'created',
    actionCreateInProgress: 'Creating',
    actionProcessInProgress: 'Processing',
    actionRemoved: 'removed',
    actionRemoveInProgress: 'Removing',
    actionUpdated: 'updated',
    actionUpdateInProgress: 'Updating',

    // Action In Progress Messages
    messageAccessCreateInProgress: 'Creating access.',
    messageAccessRemoveInProgress_one: 'Removing access.',
    messageAccessRemoveInProgress_other: 'Removing accesses.',
    messageAccessUpdateInProgress: 'Updating access.',
    messageAddPnbVariationsInProgress: 'Adding PNB variations.',
    messageAddressCreateInProgress: 'Creating address.',
    messageAddressUpdateInProgress: 'Updating address.',
    messageAdminUserCreateInProgress: 'Creating admin user.',
    messageAdminUserRemoveInProgress_one: 'Removing admin user.',
    messageAdminUserRemoveInProgress_other: 'Removing admin users.',
    messageAdminUserUpdateInProgress: 'Updating admin user.',
    messageAllCustomersAllSalesLocationsNotAllowed: 'You are not allowed to send this vendor quote as SPA with all customers and all locations. Choose a specific customer or location.',
    messageAllCustomersSpaNotPermitted: 'You are not allowed to send this vendor quote as SPA to all customers. Choose a project or a specific customer.',
    messageAllowOverrideReplacementCost: 'Shipment type must not be "Stock" to enter replacement cost. Please change the shipment type first.',
    messageApplyCostDiscountInProgress: 'Applying cost discount.',
    messageApprovedVendorRemoveInProgress: 'Removing approved vendor association.',
    messageApprovedVendorUpdateInProgress: 'Updating approved vendor association.',
    messageBomImportPreviewInProgress: 'Starting preview.',
    messageBulkExportSkuPartsBlockers:
      'These vendor quotes must be fixed before they can be exported. Each one shows what is missing:',
    messageBulkExportSkuPartsOmits:
      'These selections will be skipped — they are not imported alternate vendor quotes:',
    messageBulkNoReplacementCostAvailable:
      'None of the selected lines are eligible for replacement cost pricing. Replacement cost pricing requires a non-price-locked line with a ship-and-debit vendor and a replacement cost.',
    messageBulkPriceBasedOnIneligibleLinesQuoted:
      '{{count}} of {{total}} selected lines are price-locked — pricing mode will not be applied to them.\nLines: <strong>{{lines}}</strong>',
    messageBulkPriceBasedOnIneligibleLinesReplacement:
      '{{count}} of {{total}} selected lines are not eligible for replacement cost pricing — pricing mode will not be applied to them. Replacement cost pricing requires a non-price-locked line with a ship-and-debit vendor and a replacement cost.\nLines: <strong>{{lines}}</strong>',
    messageBulkResendAsSpaSuccess_one: '{{count}} vendor quote update sent as SPA.',
    messageBulkResendAsSpaSuccess_other: '{{count}} vendor quote updates sent as SPA.',
    messageBulkSendAsSpaAlreadySent:
      'These vendor quotes were sent as SPA and have not changed since. They will be skipped:',
    messageBulkSendAsSpaBlockers:
      'These vendor quotes must be fixed before they can be sent. Each one shows what is missing:',
    messageBulkSendAsSpaDropped_one:
      '{{count}} vendor quote could not be prepared for resending and was not sent. Please try again.',
    messageBulkSendAsSpaDropped_other:
      '{{count}} vendor quotes could not be prepared for resending and were not sent. Please try again.',
    messageBulkSendAsSpaError: 'Failed to send the selected vendor quotes as SPA. Please try again.',
    messageBulkSendAsSpaErrorAtStep:
      'Failed to send the selected vendor quotes as SPA at the {{step}} step. Please try again.',
    messageBulkSendAsSpaInProgress: 'Sending selected vendor quotes as SPA.',
    messageBulkSendAsSpaLead_one: 'You are about to send {{count}} vendor quote as SPA.',
    messageBulkSendAsSpaLead_other: 'You are about to send {{count}} vendor quotes as SPA.',
    messageBulkSendAsSpaLockFailed_one:
      '{{count}} vendor quote was not sent: another send of it as SPA is in progress. Please try again shortly.',
    messageBulkSendAsSpaLockFailed_other:
      '{{count}} vendor quotes were not sent: another send of them as SPA is in progress. Please try again shortly.',
    messageBulkSendAsSpaOmits:
      'These selections will be skipped — they are not imported alternate vendor quotes:',
    messageBulkSendAsSpaPastValidUntil:
      'These quotes have a Valid Until date in the past: {{quotes}}. Send them anyway?',
    messageBulkSendAsSpaResends:
      'These vendor quotes changed after they were sent as SPA. Their updates are sent as SPA and replace the agreements sent before:',
    messageBulkSendAsSpaSkippedByOtherSend_one:
      'Skipped: {{count}} vendor quote already sent by another send.',
    messageBulkSendAsSpaSkippedByOtherSend_other:
      'Skipped: {{count}} vendor quotes already sent by another send.',
    messageBulkSendAsSpaStatusWriteFailed_one: 'Vendor quote {{quotes}}: {{message}}',
    messageBulkSendAsSpaStatusWriteFailed_other: 'Vendor quotes {{quotes}}: {{message}}',
    messageBulkSendAsSpaSuccess_one: '{{count}} vendor quote sent as SPA.',
    messageBulkSendAsSpaSuccess_other: '{{count}} vendor quotes sent as SPA.',
    messageBulkSetUpPartsSubtitle_one: '{{count}} part selected — its company part is created if it does not exist yet, or updated if it does.',
    messageBulkSetUpPartsSubtitle_other: '{{count}} parts selected — each company part is created if it does not exist yet, or updated if it does.',
    messageBulkUomConversionsSubtitle_one: '{{count}} part selected. The conversion below is added to it.',
    messageBulkUomConversionsSubtitle_other: '{{count}} parts selected. The conversion below is added to each.',
    messageBulkUpdateUomsHint:
      'Tick only the units you want to change. Anything left unticked keeps its current value on every selected part.',
    messageBulkUpdateUomsSubtitle_one: '{{count}} part selected.',
    messageBulkUpdateUomsSubtitle_other: '{{count}} parts selected.',
    messageCacheDetails_apcu_acl: 'Each signed-in user\'s list of what they are allowed to see and do, worked out once and then held for ten minutes. Clear it after changing someone\'s rank or permissions so the change applies on their next click instead of after the wait.',
    messageCacheDetails_apcu_category: 'The field definitions behind each part category — which fields exist, their units of measure and their allowed values. Clear it after editing a category\'s fields so the new setup appears immediately rather than on the next natural refresh.',
    messageCacheDetails_file_table_metadata: 'A description of the database\'s own structure — its tables and their columns — kept so the application does not have to ask the database about its own shape on every query. Clear it after a database change, such as a new column, if the application does not seem to see it.',
    messageCacheDetails_integration_inventory: 'Stock levels fetched from a customer\'s own inventory system, kept for one hour per company and request. Clearing forces a live call on the next inventory lookup.',
    messageCacheDetails_integration_part_search: 'Search results from a customer\'s own part catalogue, kept for fifteen minutes. Clearing means the next search goes out to that system live.',
    messageCacheDetails_integration_pricing: 'Prices returned by a customer\'s own pricing system, kept for one hour per company and request. Clearing means the next quote or price check calls that system again — slower, and it counts against whatever rate limit the customer has.',
    messageCacheDetails_integration_sales_order_history: 'Past order information pulled from a customer\'s own system, kept for one hour. Clearing means the next history view is fetched live.',
    messageCacheDetails_redis_access_token: 'The sign-in tokens the application holds for talking to external systems. Clearing them makes it sign in again on the next call. Harmless, but only worth doing when an integration is failing to authenticate.',
    messageCacheDetails_redis_bom_boms_by_part: 'The finished "BOMs by part" report — the top parts ranked by how many bills of materials they appear in — held per company, as-of date and filter combination. The report is slow to build, so the next person to open it waits for a full rebuild.',
    messageCacheDetails_redis_bom_lines_by_part: 'The finished "lines by part" report — the top parts ranked by how often they occur on BOM lines — held per company, as-of date and filter combination. The report is slow to build, so the next person to open it waits for a full rebuild.',
    messageCacheDetails_redis_bom_summary: 'The finished BOM summary figures, held per company, as-of date and filter combination. Slow to recompute, so the next person to open the summary waits for it.',
    messageCacheDetails_redis_manufacturer: 'Manufacturer records held by id, so a name or detail does not need a database lookup every time a part is shown or searched. Clearing is cheap — they are read back from the database as they are needed.',
    messageCacheDetails_redis_part_availability: 'Availability answers for a given company, part, manufacturer and location that were already looked up once. Clearing makes the next availability check ask the source again.',
    messageCacheDetails_redis_quote_dashboard: 'The totals and counts on the quote dashboard, recalculated at most every thirty minutes because they are expensive to work out. Clear it to force the dashboard to show up-to-the-minute numbers.',
    messageCacheDetails_redis_shipment_type: 'The shipment type an external system reported for a part at a given shipping location, kept for one hour. Clearing makes the next order line ask that system again.',
    messageCacheExpiry_apcu_acl: '10 minutes.',
    messageCacheExpiry_apcu_category: 'Never on its own. It is written without a lifetime, so entries stay until they are cleared here or the web server restarts.',
    messageCacheExpiry_file_table_metadata: '1 hour.',
    messageCacheExpiry_integration_inventory: '1 hour.',
    messageCacheExpiry_integration_part_search: '15 minutes.',
    messageCacheExpiry_integration_pricing: '1 hour.',
    messageCacheExpiry_integration_sales_order_history: '1 hour.',
    messageCacheExpiry_redis_access_token: 'With the token itself — the entry is given whatever life the external system left on it, less a 60-second safety margin.',
    messageCacheExpiry_redis_bom_boms_by_part: '24 hours.',
    messageCacheExpiry_redis_bom_lines_by_part: '24 hours.',
    messageCacheExpiry_redis_bom_summary: '24 hours.',
    messageCacheExpiry_redis_manufacturer: 'Never on its own. Entries are written without a lifetime, so they stay until they are cleared.',
    messageCacheExpiry_redis_part_availability: 'Never on its own. Entries are written without a lifetime, so they stay until they are cleared.',
    messageCacheExpiry_redis_quote_dashboard: '30 minutes.',
    messageCacheExpiry_redis_shipment_type: '1 hour.',
    messageCacheGroupHelp_apcu: 'Held in memory by the web server process, which serves every environment on this machine — so clearing reaches all of them, not just this one. Other web servers keep their own copy until it expires.',
    messageCacheGroupHelp_file: 'Files in this environment\'s own cache directory. The only group here that stops at this environment — nothing else is affected.',
    messageCacheGroupHelp_integration: 'Anything rebuilt by calling an outside system. Held in Redis like the group above and shared by every environment in this deployment, but clearing here forces a fresh call on the next request — slow, and it counts against whatever rate limit that system applies.',
    messageCacheGroupHelp_redis: 'Rebuilt from our own database, so clearing costs a burst of queries and nothing more. One Redis serves every environment in this deployment, so it takes effect everywhere at once.',
    messageCacheLoadError: 'The list of clearable caches could not be loaded.',
    messageCalculatePricesInProgress: 'Calculating prices.',
    messageCalculatePricingInProgress: 'Calculating cost and price.',
    messageCancelConsumerJobsConfirm_one: 'Cancel the selected job? If a live consumer is running it, that consumer is stopped too and comes back automatically within a minute.',
    messageCancelConsumerJobsConfirm_other: 'Cancel the {{count}} selected jobs? Any that a live consumer is running will stop that consumer too, and it comes back automatically within a minute.',
    messageCancelConsumerJobsConfirmIdle_one:
      'Cancel the selected job? No consumer is running it, so nothing is interrupted — it is only marked canceled.',
    messageCancelConsumerJobsConfirmIdle_other:
      'Cancel the {{count}} selected jobs? No consumer is running them, so nothing is interrupted — they are only marked canceled.',
    messageCancelConsumerJobsFailed_one: '1 could not be canceled.',
    messageCancelConsumerJobsFailed_other: '{{count}} could not be canceled.',
    messageCancelConsumerJobsInProgress: 'Canceling jobs.',
    messageCancelConsumerJobsKilled_one: '1 consumer was stopped.',
    messageCancelConsumerJobsKilled_other: '{{count}} consumers were stopped.',
    messageCancelConsumerJobsNone: 'Nothing was canceled — the selected jobs had already finished.',
    messageCancelConsumerJobsSkipped_one: '1 had already finished.',
    messageCancelConsumerJobsSkipped_other: '{{count}} had already finished.',
    messageCancelConsumerJobsSuccess_one: 'Canceled 1 job.',
    messageCancelConsumerJobsSuccess_other: 'Canceled {{count}} jobs.',
    messageCheckActiveOverlappingCostInProgress: 'Checking for overlapping costs.',
    messageCheckActiveOverlappingPriceInProgress: 'Checking for overlapping prices.',
    messageClearCacheConfirm: 'Clear the {{cache}} cache? It will be rebuilt as it is needed again.',
    messageClearCacheConfirmHighImpact: 'Clear the {{cache}} cache? The next request for this data has to call the external system again, which is slow and may be rate limited.',
    messageClearCacheInProgress: 'Clearing cache.',
    messageClearCacheRejected: 'That cache could not be cleared.',
    messageClearCacheSuccess: 'Cache cleared.',
    messageClearCacheSuccessCounted_one: 'Cache cleared — 1 entry removed.',
    messageClearCacheSuccessCounted_other: 'Cache cleared — {{count}} entries removed.',
    messageCompanyPartUpdateInProgress: 'Updating company part.',
    messageComponentCreateInProgress: 'Creating component.',
    messageComponentsCreateInProgress_one: 'Creating component.',
    messageComponentsCreateInProgress_other: 'Creating components.',
    messageComponentsUpdateInProgress_one: 'Updating component.',
    messageComponentsUpdateInProgress_other: 'Updating components.',
    messageComponentTemplateCreateInProgress: 'Creating component template line.',
    messageComponentTemplatesRemoveInProgress_one: 'Removing component template line.',
    messageComponentTemplatesRemoveInProgress_other: 'Removing {{count}} component template lines.',
    messageComponentTemplateUpdateInProgress: 'Updating component template line.',
    messageComponentTemplateValidateInProgress: 'Validating part.',
    messageComponentUpdateInProgress: 'Updating component.',
    messageConsumerJobsRefreshing: 'Refreshing…',
    messageConsumerJobsRefreshingIn: 'Refreshing in {{seconds}}s',
    messageConsumerJobsRefreshStalled: 'Not refreshing — the last update failed',
    messageConsumerRestartConfirm_one: 'Restarting {{env}} will stop 1 job that is currently running. It will be marked as failed and will not resume: {{jobs}}',
    messageConsumerRestartConfirm_other: 'Restarting {{env}} will stop {{count}} jobs that are currently running. They will be marked as failed and will not resume: {{jobs}}',
    messageConsumerRestartConfirmIdle: 'Restart the consumers for {{env}}? They will be stopped and respawned. No job is currently running on this environment.',
    messageConsumerRestartInProgress: 'Restarting consumers.',
    messageConsumerRestartJobsError: 'The job list could not be loaded, so this page cannot show what a restart would interrupt.',
    messageConsumerRestartJobsHelp: 'Jobs waiting to run or currently running across this server. Environment is only known for jobs a live consumer has picked up.',
    messageConsumerRestartNoJobs: 'No queued or running CLI jobs.',
    messageConsumerRestartNoTargets: 'No environments are configured for consumer restart on this deployment.',
    messageConsumerRestartTargetsError: 'The list of restartable environments could not be loaded.',
    messageConsumerRestartTargetsHelp:
      'Each button stops and respawns that environment’s consumers. The count is live consumers against the number expected.',
    messageConsumerRestartTypeToConfirm: '{{env}} is a shared environment. Type its name to confirm.',
    messageContactCreateInProgress: 'Creating contact.',
    messageContactGroupAddressMergeInProgress: 'Merging locations.',
    messageContactGroupAddressRemoveInProgress: 'Removing location.',
    messageContactGroupAddressSaveInProgress: 'Saving location.',
    messageContactGroupAddressUpdateInProgress: 'Updating location.',
    messageContactGroupCreateInProgress: 'Creating company.',
    messageContactGroupMergeInProgress: 'Merging companies.',
    messageContactGroupUpdateInProgress: 'Updating company.',
    messageContactOwnerUpdateInProgress: 'Updating contact owner.',
    messageContactRemoveInProgress: 'Removing contact.',
    messageContactRestoreInProgress: 'Restoring contact.',
    messageContactSalesRepForAccess: 'Contact your Sales Rep for access',
    messageContactUpdateInProgress: 'Updating contact.',
    messageCopyMoveNotAllowed: 'All the components/parts already belong to the selected element.',
    messageCorporateUserVersionChangeInProgress: 'Changing version.',
    messageCostingCalculationCreateInProgress: 'Creating costing calculation.',
    messageCostingCalculationsRemoveInProgress_one: 'Removing costing calculation.',
    messageCostingCalculationsRemoveInProgress_other: 'Removing costing calculations.',
    messageCostingCalculationUpdateInProgress: 'Updating costing calculation.',
    messageCostingCalculationUpsertInProgress: 'Saving costing calculation.',
    messageCostingProfileCreateInProgress: 'Creating costing profile.',
    messageCostingProfilesRemoveInProgress_one: 'Removing costing profile.',
    messageCostingProfilesRemoveInProgress_other: 'Removing costing profiles.',
    messageCostingProfilesUpdateInProgress: 'Updating costing profiles.',
    messageCostingProfileUpdateInProgress: 'Updating costing profile.',
    messageCostLockedByContract: 'Cost is locked by contract and cannot be overwritten.',
    messageCostValidUntilMissing: 'Valid until is missing.',
    messageCreateImportPartManufacturersInProgress: 'Saving manufacturers.',
    messageCreateProspectQuoteInProgress: 'Creating prospect quote.',
    messageCreateProspectQuoteSuccess: 'Prospect quote created.',
    messageCustomTableFilterCreateInProgress: 'Creating custom table filter set.',
    messageCustomTableFilterRemoveInProgress: 'Removing custom table filter set.',
    messageCustomTableFilterUpdateInProgress: 'Updating custom table filter set.',
    messageCustomTableLayoutCreateInProgress: 'Creating custom table layout.',
    messageCustomTableLayoutRemoveInProgress: 'Removing custom table layout.',
    messageCustomTableLayoutUpdateInProgress: 'Updating custom table layout.',
    messageDataExtractingInProgress: 'Extracting data.',
    messageDataImportingInProgress: 'Importing data.',
    messageDefaultDatasheetUpdateInProgress: 'Updating default datasheet.',
    messageDefaultImageUpdateInProgress: 'Updating default image.',
    messageDetachVendorQuoteInProgress_one: 'Detaching quote.',
    messageDetachVendorQuoteInProgress_other: 'Detaching quotes.',
    messageDiscountedPartsFetchInProgress: 'Checking for discounted parts.',
    messageElementComponentNoteCreateInProgress: 'Creating element component note.',
    messageElementComponentNotesCreateInProgress_one: 'Creating element component note.',
    messageElementComponentNotesCreateInProgress_other: 'Creating element component notes.',
    messageElementComponentNotesRemoveInProgress_one: 'Removing element component note.',
    messageElementComponentNotesRemoveInProgress_other: 'Removing element component notes.',
    messageElementComponentNotesUpdateInProgress_one: 'Updating element component note.',
    messageElementComponentNotesUpdateInProgress_other: 'Updating element component notes.',
    messageElementComponentNoteUpdateInProgress: 'Updating element component note.',
    messageElementCreateInProgress: 'Creating element.',
    messageElementSaveAsTemplateInProgress: 'Saving element as template.',
    messageElementTemplateAddToJobInProgress: 'Adding element template to job.',
    messageElementTemplateCreateInProgress: 'Creating element template.',
    messageElementTemplateUpdateInProgress: 'Updating element template.',
    messageElementUpdateInProgress: 'Updating element.',
    messageEmployeeWarning: 'The ISR and OSR could be changed by the bill to address changes. Please verify the current ISR and OSR for accuracy.',
    messageExpiredCostingResetInProgress: 'Resetting outdated costing.',
    messageExportJobLogInProgress: 'Generating time log export file.',
    messageExportLostTrack: 'We lost track of the download. Start it again if the file did not arrive.',
    messageExportSkuPartsFileMissing: 'No file was returned for the SKU Parts export.',
    messageExportSkuPartsProjectAlreadyDisabledByCustomers: 'Customer(s) already selected. Clear them to choose a project instead.',
    messageExportSkuPartsProjectOrCustomerRequired: 'Select either a project or at least one customer (not both).',
    messageExportSkuPartsSalesLocationRequired: 'Select at least one sales location or All Locations.',
    messageExtractorVendorMappingCreateInProgress: 'Creating mapping.',
    messageExtractorVendorMappingRemoveInProgress_one: 'Removing mapping.',
    messageExtractorVendorMappingRemoveInProgress_other: 'Removing mappings.',
    messageExtractorVendorMappingUpdateInProgress: 'Updating mapping.',
    messageFileUploadInProgress: 'Uploading file.',
    messageGenerateExportFileInProgress: 'Generating export file.',
    messageGenerateExportFileTypeInProgress: 'Generating {{fileType}} file.',
    messageGenerateExportInProgress: 'Generating export.',
    messageGenerateExportSkuPartsInProgress: 'Generating Export SKU Parts file.',
    messageGenerateJobLogExportInProgress: 'Generating time log export file...',
    messageGeneratePartExportFileInProgress: 'Generating {{fileType}} file...',
    messageGeneratePartsDatasheetArchiveInProgress: 'Generating datasheet archive.',
    messageGuidedSearchSuggestion: 'Try Guided Search to find the part number you need',
    messageHintAddNewPartLine: 'Enter a part number, add a new one, or simply enter a description with no part number.',
    messageHintAddNewVariation: 'You can simply copy and paste the rows with the lengths and quantities into this table.',
    messageHintResetPricing: 'You have made a change that may impact the calculated cost or price. Would you like to recalculate your cost or price?',
    messageImpersonateUserInProgress: 'Impersonating user.',
    messageImportPartsInProgress: 'Importing parts started.',
    messageImportPartsStatusInProgress: 'Imported {{ imported }} out of total {{ total }} parts.',
    messageInvalidDateRangeMaxDays: 'To must be on or after From, within {{maxDays}} days',
    messageInvalidUrlFormat: 'Invalid URL format',
    messageInvitationRevokeInProgress: 'Revoking access.',
    messageInvitationSendInProgress: 'Sending invitation.',
    messageJobCreateInProgress: 'Creating job.',
    messageJobFileAttachInProgress: 'Attaching file.',
    messageJobFileAttachSuccess: 'File has been successfully attached.',
    messageJobFileDetachInProgress: 'Detaching file.',
    messageJobFileDetachSuccess: 'File has been successfully detached.',
    messageJobImportCreateInProgress: 'Reading file.',
    messageJobNameUpdateInProgress: 'Updating the job name.',
    messageJobPartComponentAddInProgress: 'Adding component name.',
    messageJobPartComponentRemoveInProgress: 'Removing component name.',
    messageJobPartComponentUpdateInProgress: 'Updating component name.',
    messageJobPartLineCalculatePricesInProgress: 'Calculating prices.',
    messageJobPartLineCreateInProgress: 'Creating line.',
    messageJobPartLinesRemoveInProgress_one: 'Removing selected line.',
    messageJobPartLinesRemoveInProgress_other: 'Removing selected lines.',
    messageJobPartLinesRestoreInProgress_one: 'Restoring line.',
    messageJobPartLinesRestoreInProgress_other: 'Restoring lines.',
    messageJobPartLineUpdateInProgress: 'Updating line.',
    messageJobPartLineValidateInProgress: 'Validating part.',
    messageJobPartNoteCreateInProgress: 'Creating note.',
    messageJobPartNotesCreateInProgress: 'Creating notes.',
    messageJobPartNotesRemoveInProgress_one: 'Removing note.',
    messageJobPartNotesRemoveInProgress_other: 'Removing notes.',
    messageJobPartNoteUpdateInProgress: 'Updating note.',
    messageJobPartsAddToJobInProgress_one: 'Adding part to job.',
    messageJobPartsAddToJobInProgress_other: 'Adding parts to job.',
    messageJobUpdateInProgress_one: 'Updating job.',
    messageJobUpdateInProgress_other: 'Updating jobs.',
    messageLastMaxQuantityMustBeEmpty: 'Last maximum quantity must be empty.',
    messageLineChangeInProgress: 'Changing line.',
    messageLineCreatingInProgress: 'Creating line.',
    messageLineDuplicateInProgress_one: 'Duplicating line.',
    messageLineDuplicateInProgress_other: 'Duplicating lines.',
    messageLineNoteCreateInProgress: 'Creating line note.',
    messageLineNoteRemoveInProgress: 'Removing line note.',
    messageLineNotesCreateInProgress_one: 'Creating line note.',
    messageLineNotesCreateInProgress_other: 'Creating line notes.',
    messageLineNotesRemoveInProgress_one: 'Removing line note.',
    messageLineNotesRemoveInProgress_other: 'Removing line notes.',
    messageLineNoteUpdateInProgress: 'Updating line note.',
    messageLineNotSaved: 'The line could not be saved. Try again.',
    messageLinesMoveToInProgress_one: 'Moving line.',
    messageLinesMoveToInProgress_other: 'Moving lines.',
    messageLinesRemoveInProgress_one: 'Removing line',
    messageLinesRemoveInProgress_other: 'Removing lines',
    messageLinesReorderInProgress: 'Reordering lines.',
    messageLinesUpdateInProgress_one: 'Updating line.',
    messageLinesUpdateInProgress_other: 'Updating lines.',
    messageLoading: 'Loading...',
    messageLoadingLeadTimeSuggestions: 'Loading lead time suggestions.',
    messageLogCreateInProgress: 'Log time has been successfully created.',
    messageLogsCreateInProgress_one: 'Creating log time.',
    messageLogsCreateInProgress_other: 'Creating log times.',
    messageLogsRemoveInProgress_one: 'Removing log time.',
    messageLogsRemoveInProgress_other: 'Removing log times.',
    messageLogsUpdateInProgress_one: 'Updating log time.',
    messageLogsUpdateInProgress_other: 'Updating log times.',
    messageLogUpdateInProgress: 'Updating log time.',
    messageMultiplierMustBePositive: 'The multiplier must be greater than zero.',
    messageNoteSaveInProgress: 'Adding note...',
    messageNoUomConversionGaps: 'No UOM conversion gaps in this date range.',
    messageOrderCreateInProgress: 'Creating order.',
    messageOrderSubmitInProgress: 'Submitting order.',
    messagePartBomCreateInProgress: 'Creating Part BOM...',
    messagePartBomItemCreateInProgress: 'Creating Part BOM line...',
    messagePartBomItemNoteCreateInProgress: 'Adding Part BOM line note...',
    messagePartBomItemNotesRemoveInProgress_one: 'Removing Part BOM line note...',
    messagePartBomItemNotesRemoveInProgress_other: 'Removing Part BOM line notes...',
    messagePartBomItemNoteUpdateInProgress: 'Updating Part BOM line note...',
    messagePartBomItemsRemoveInProgress_one: 'Removing Part BOM line.',
    messagePartBomItemsRemoveInProgress_other: 'Removing Part BOM lines.',
    messagePartBomItemUpdateInProgress: 'Updating Part BOM line...',
    messagePartBomItemValidateInProgress: 'Validating Part BOM line...',
    messagePartBomRemoveInProgress: 'Removing Part BOM...',
    messagePartBomUpdateInProgress: 'Updating Part BOM...',
    messagePartCopyInProgress: 'Copying part...',
    messagePartCostCreateInProgress: 'Creating part cost...',
    messagePartCostsRemoveInProgress_one: 'Removing part cost...',
    messagePartCostsRemoveInProgress_other: 'Removing part costs...',
    messagePartCostUpdateInProgress: 'Updating part cost...',
    messagePartFinderAttributeSaveInProgress: 'Saving value list...',
    messagePartFinderAttributesPublishInProgress_one: 'Publishing value list...',
    messagePartFinderAttributesPublishInProgress_other: 'Publishing {{count}} value lists...',
    messagePartFinderAttributesPublishSuccess_one: 'Value list published.',
    messagePartFinderAttributesPublishSuccess_other: '{{count}} value lists published.',
    messagePartFinderAttributesRemoveInProgress_one: 'Removing value list...',
    messagePartFinderAttributesRemoveInProgress_other: 'Removing {{count}} value lists...',
    messagePartFinderFamiliesPublishInProgress_one: 'Publishing family...',
    messagePartFinderFamiliesPublishInProgress_other: 'Publishing {{count}} families...',
    messagePartFinderFamiliesRemoveInProgress_one: 'Removing family...',
    messagePartFinderFamiliesRemoveInProgress_other: 'Removing {{count}} families...',
    messagePartFinderFamiliesUnpublishInProgress_one: 'Unpublishing family...',
    messagePartFinderFamiliesUnpublishInProgress_other: 'Unpublishing {{count}} families...',
    messagePartFinderFamilySaveInProgress: 'Saving family...',
    messagePartFinderProductTypeSaveInProgress: 'Saving product type...',
    messagePartFinderProductTypesPublishInProgress_one: 'Publishing product type...',
    messagePartFinderProductTypesPublishInProgress_other: 'Publishing {{count}} product types...',
    messagePartFinderProductTypesPublishSuccess_one: 'Product type published.',
    messagePartFinderProductTypesPublishSuccess_other: '{{count}} product types published.',
    messagePartFinderProductTypesRemoveInProgress_one: 'Removing product type...',
    messagePartFinderProductTypesRemoveInProgress_other: 'Removing {{count}} product types...',
    messagePartFinderReelsLoadingFamily: 'Loading the family: {{loaded, number}} of {{total, number}} parts.',
    messagePartFinderReelsLoadingMatches: 'Loading the matching parts: {{loaded, number}} of {{total, number}}.',
    messagePartFinderReelsLoadStopped:
      'Loading stopped at {{loaded, number}} of {{total, number}} parts. Reload the page to load the rest of the family.',
    messagePartFinderReelsMatchesLoaded_one:
      'The matching part is loaded. Loading the rest of the family: {{loaded, number}} of {{total, number}} parts.',
    messagePartFinderReelsMatchesLoaded_other:
      'All {{count, number}} matching parts are loaded. Loading the rest of the family: {{loaded, number}} of {{total, number}} parts.',
    messagePartFinderReelsTruncated: 'Showing reels for the first {{count, number}} matching parts. Narrow the search to see the rest.',
    messagePartFinderReelsTruncatedMatchesFirst_one:
      'Showing the matching part, then other parts of the family up to {{limit, number}}. Removing a filter may not list every part.',
    messagePartFinderReelsTruncatedMatchesFirst_other:
      'Showing all {{count, number}} matching parts, then other parts of the family up to {{limit, number}}. Removing a filter may not list every part.',
    messagePartFinderReelsUnavailable: 'Reel data is not available for this company right now.',
    messagePartMediaFileDescriptionUpdateInProgress: 'Updating file description.',
    messagePartMediaFileRemoveInProgress: 'Removing file.',
    messagePartMoveInProgress: 'Moving part...',
    messagePartNotSetUp: 'Part has not been set up yet.',
    messagePartNumbersRemoveInProgress_one: 'Removing fixed price.',
    messagePartNumbersRemoveInProgress_other: 'Removing fixed prices.',
    messagePartNumbersUpsertInProgress: 'Saving fixed price.',
    messagePartParticularsSaveInProgress: 'Saving part particulars.',
    messagePartPriceCreateInProgress: 'Creating part price...',
    messagePartPricesRemoveInProgress_one: 'Removing part price...',
    messagePartPricesRemoveInProgress_other: 'Removing part prices...',
    messagePartPriceUpdateInProgress: 'Updating part price...',
    messagePartsAddingInProgress_one: 'Adding part.',
    messagePartsAddingInProgress_other: 'Adding parts.',
    messagePartSaveInProgress: 'Saving part...',
    messagePartValidationInProgress: 'Validating part...',
    messagePartVideoRemoveInProgress: 'Removing video.',
    messagePartVideoSaveInProgress: 'Saving video.',
    messagePreviewCsvEmpty: 'The file is empty.',
    messagePreviewCsvError: 'Could not load the preview.',
    messagePreviewCsvRowCount_one: '{{count}} row',
    messagePreviewCsvRowCount_other: '{{count}} rows',
    messagePricingProfileDocumentRemoveInProgress: 'Removing pricing profile document.',
    messagePricingProfileDocumentSaveInProgress: 'Uploading pricing profile document.',
    messagePricingProfileRuleCreateInProgress: 'Creating pricing profile rule.',
    messagePricingProfileRulesRemoveInProgress_one: 'Removing pricing profile rule.',
    messagePricingProfileRulesRemoveInProgress_other: 'Removing pricing profile rules.',
    messagePricingProfileRuleUpdateInProgress: 'Updating pricing profile rule.',
    messagePricingProfileRuleUpsertInProgress: 'Saving pricing profile rule.',
    messagePricingProfilesRemoveInProgress_one: 'Removing pricing profile.',
    messagePricingProfilesRemoveInProgress_other: 'Removing pricing profiles.',
    messageProjectCreateInProgress: 'Creating project.',
    messageProjectUpdateInProgress: 'Updating project.',
    messageProjectUserSaveInProgress: 'Saving user.',
    messageProjectUsersRemoveInProgress_one: 'Removing user.',
    messageProjectUsersRemoveInProgress_other: 'Removing users.',
    messageProjectUserUpdateInProgress: 'Updating user.',
    messageProspectQuoteCompanyMatched:
      'Company matched by email domain. The contact will be added to this company.',
    messageProspectQuoteEmailNotVerified:
      'This email could not be verified. Edit it to try again.',
    messageQuantityRangesCannotHaveGap: 'Quantity ranges cannot have a gap between them.',
    messageQuantityRangesOverlap: 'Quantity ranges must not overlap.',
    messageQuoteCreateInProgress: 'Creating {{entityType}}.',
    messageQuoteDraftVersionInitializeInProgress: 'Loading draft version.',
    messageQuoteDuplicateInProgress: 'Duplicating {{entityType}}.',
    messageQuoteFileAttachInProgress: 'Attaching {{entityType}} file.',
    messageQuoteFileDetachInProgress: 'Detaching {{entityType}} file.',
    messageQuoteImportCreateInProgress: 'Reading file.',
    messageQuoteNoteCreateInProgress: 'Creating {{entityType}} note.',
    messageQuoteNoteSaveInProgress: 'Saving {{entityType}} note.',
    messageQuoteNoteUpdateInProgress: 'Updating {{entityType}} note.',
    messageQuotePartAddToPricingProfileInProgress_one: 'Adding {{entityType}} part to pricing profile.',
    messageQuotePartAddToPricingProfileInProgress_other: 'Adding {{entityType}} parts to pricing profile.',
    messageQuotesArchiveInProgress_one: 'Archiving {{entityType}}.',
    messageQuotesArchiveInProgress_other: 'Archiving {{entityType}}s.',
    messageQuotesCreateInProgress: 'Creating {{entityType}}s.',
    messageQuoteSendToFileNetInProgress: 'Sending quote to FileNet.',
    messageQuoteSendToVendorInProgress: 'Sending quote to Vendor.',
    messageQuotesReassignInProgress_one: 'Reassigning {{entityType}}.',
    messageQuotesReassignInProgress_other: 'Reassigning {{entityType}}s.',
    messageQuotesRestoreInProgress_one: 'Restoring {{entityType}}.',
    messageQuotesRestoreInProgress_other: 'Restoring {{entityType}}s.',
    messageQuotesUpdateInProgress_one: 'Updating {{entityType}}.',
    messageQuotesUpdateInProgress_other: 'Updating {{entityType}}s.',
    messageQuoteToProjectAttachInProgress: 'Attaching quote to project.',
    messageQuoteToQuoteAttachInProgress_one: 'Attaching quote.',
    messageQuoteToQuoteAttachInProgress_other: 'Attaching quotes.',
    messageQuoteUpdateInProgress: 'Updating {{entityType}}.',
    messageQuoteVersionDataCreateInProgress: 'Creating {{entityType}} freight.',
    messageQuoteVersionDataSaveInProgress: 'Saving {{entityType}} freight.',
    messageQuoteVersionDataUpdateInProgress: 'Updating {{entityType}} freight.',
    messageQuoteVersionResetInProgress: 'Resetting {{entityType}} version.',
    messageReattachVendorQuoteInProgress_one: 'Reattaching quote.',
    messageReattachVendorQuoteInProgress_other: 'Reattaching quotes.',
    messageReleaseQuoteInProgress: 'Releasing {{entityType}}.',
    messageRequiredForOrderSubmission: 'Required for order submission.',
    messageResetPricingTypeInProgress: 'Resetting {{type}}.',
    messageSignInInProgress: 'Signing in.',
    messageUnsavedChangesLost: 'You have unsaved changes. If you leave this page now, they will be lost.',
    messageUomConversionAuditBulkConversionSuccess_one: '{{count}} UOM conversion added.',
    messageUomConversionAuditBulkConversionSuccess_other: '{{count}} UOM conversions added.',
    messageUomConversionAuditBulkSetUpInProgress: 'Setting up company parts.',
    messageUomConversionAuditBulkUpdateInProgress: 'Updating UOMs.',
    messageUomConversionAuditReportError:
      'The UOM conversion audit for the selected window could not be read. Retry, or adjust the dates.',
    messageUomConversionCreatingInProgress: 'Creating UOM conversion.',
    messageUomConversionsRemovingInProgress: 'Removing UOM conversions.',
    messageUomConversionUpdatingInProgress: 'Updating UOM conversion.',
    messageUomsValidated: 'All parts have valid units of measurement.',
    messageUomsValidating: 'Validating parts units of measurement.',
    messageUseReplacementCostDisabledPriceLocked:
      'Replacement cost pricing cannot be selected because the price is locked.',
    messageUserSettingSaveInProgress: 'Saving user setting.',
    messageVendorQuoteDetailsUpdateInProgress: 'Updating quote details.',
    messageVendorQuoteImportCreatingInProgress: 'Reading file.',
    messageVendorQuoteImportInProgress: 'Importing vendor quote.',
    messageVendorQuoteImportStartInProgress: 'Starting import vendor quote.',
    messageVendorQuoteLogReportError:
      'The vendor quote import log for the selected date range could not be read. Retry, or pick another range.',
    messageVendorQuotesAttachInProgress_one: 'Attaching vendor quote.',
    messageVendorQuotesAttachInProgress_other: 'Attaching vendor quotes.',
    messageVendorQuotesDetachFromProjectInProgress_one: 'Detaching vendor quote from project.',
    messageVendorQuotesDetachFromProjectInProgress_other: 'Detaching vendor quotes from project.',
    messageVendorQuotesDetachInProgress_one: 'Detaching vendor quote.',
    messageVendorQuotesDetachInProgress_other: 'Detaching vendor quotes.',

    // Warnings
    warningExternalPricingWindowClosed:
      'Prices are not calculated during the nightly accrual window, 10:55 pm to 3:00 am Eastern. Recalculate later.',
    warningExternalUomConversionMissing:
      'No UOM conversion — this line will be excluded from external pricing, so no external cost will be returned. Add a conversion for this UOM to price it.',
    warningImportVendorQuoteNumber:
      'Only manually entered vendor quote costs will be updated with the vendor quote number.',
    warningPricingProfileReadOnly:
      "<wrapper>This pricing profile could be used for many customers on many quotes. Please make changes on the <linkWrapper>Pricing Profile's page</linkWrapper>.</wrapper>",
    warningUomMismatch: 'UOM does not match your saved cost UOM. Double click to change it.',
    warningValidatedByUser: 'Validated by user',
    warningValidationBuyerNoteTooLong: 'Buyer Note is too long',
    warningValidationDisallowedManufacturer: 'Disallowed manufacturer',
    warningValidationExternalPartStatus: 'Abandoned part number',
    warningValidationExternalUomConversion: 'Missing UOM conversion',
    warningValidationGpm: 'GPM out of range',
    warningValidationMissingCost: 'Cost not entered',
    warningValidationMissingDescription: 'Description not entered',
    warningValidationMissingManufacturer: 'Manufacturer not assigned',
    warningValidationMissingPrice: 'Price not entered',
    warningValidationMissingShipmentType: 'Shipment Type not entered',
    warningValidationMoq: 'Quantity below MOQ',
    warningValidationOrderIncrement: 'Invalid increment',
    warningValidationPartNumberTooLong: 'Part number is too long',
    warningValidationPickerNoteTooLong: 'Picker Note is too long',
    warningValidationQuantityBelowMinimum: 'Quantity is less than MOQ of {{minimum}}.',
    warningValidationQuantityDecimal: 'Quantity must be a whole number',
    warningValidationQuantityNotMultipleOfIncrement: 'Quantity should be increments of {{increment}}.',
    warningValidationQuantityUom: 'Check quantity vs UOM',
    warningValidationReplacementCostInfo: 'Missing Replacement Cost Info',
    warningValidationShippingLocation: 'Shipping Location is not valid',
    warningValidationShippingLocationNotSet: 'Shipping Location is not set',
    warningValidationSupshipNoteTooLong: 'Supplier PO Shipping Note too long',
    warningValidationTaxonomy: 'Taxonomy not assigned',
    warningValidationUom: 'UOM mismatch',
    warningValidationVendor: 'Vendor not assigned',
    warningValidationVendorQuoteNumber: 'Missing Vendor Quote Number',

    // Errors
    errorActivityTimeRequiredAtLeastOne: 'Add at least one activity time.',
    errorApplyCostDiscount: 'An error occurred while applying cost discount',
    errorBillToLocationMustHaveArNumber: 'Bill To Location must have an AR number.',
    errorCloseConfidenceOutOfBounds: 'Close Confidence must be between 0 and 100',
    errorCompanyRequired: 'Please enter the company name.',
    errorComputedPurchaseCostBaseAndAdderRequired: 'Purchase Cost Base and Puchase Cost Adder are required either neither or both.',
    errorCopyPart: 'An error occurred while copying part: {{error}}.',
    errorCorporateUserVersionChange: 'An error occurred while changing the version.',
    errorCostValidUntilBeforeValidSince: 'Valid until cannot be before valid since.',
    errorCustomerNumberDigitsOnly: 'Customer number must be 6 characters long, digits only.',
    errorDateNotBeforeToday: '{{label}} must be today or a future date.',
    errorDateNotValid: '{{label}} is not a valid date.',
    errorDisciplineRequired: 'Please select at least one discipline.',
    errorDiscountedPartsFetch: 'An error occurred while checking for discounted parts',
    errorElementRequired: 'Element cannot be empty.',
    errorEmailDomainInvalid: 'Email domain is invalid.',
    errorExactlyOneDefaultVendor: 'Exactly one default vendor is required.',
    errorExportingJobLog: 'An error occurred while exporting job log.',
    errorFamilyPartNoManufacturer: 'This part has no manufacturer, so it cannot join a family.',
    errorFieldCannotBeEmpty: '{{field}} cannot be empty.',
    errorFieldMaxLength: '{{field}} must be {{length}} characters or less.',
    errorFieldSelectRequired: 'Select a field to update',
    errorFirstNameRequired: 'Please enter your first name.',
    errorFreightPercentageBellowMinimum: 'The freight percentage is below the minimum of {{minimum}}.',
    errorFreightTotalBellowMinimum: 'The freight total is below the minimum of {{minimum}}.',
    errorFromToRange: 'From value must be less than To value',
    errorFromToRequired: 'Please enter both From and To values',
    errorImportLogTrace: 'The log trace for this import could not be loaded.',
    errorInvalidBillToLocation: 'Invalid Bill To Location.',
    errorInvalidCliJob: 'Invalid job.',
    errorInvalidCost: 'Cost may be expired',
    errorInvalidFileType: 'File type not supported.',
    errorInvalidIncrements: 'Increments must be a value greater than 0',
    errorInvalidPostalCodeFormat: 'Invalid zip/postal code format.',
    errorInvalidQuantity: 'Quantity must be a value greater than 0',
    errorInvalidReordering: 'Invalid reordering',
    errorInvalidShipToLocation: 'Invalid Ship To Location.',
    errorLastNameRequired: 'Please enter your last name.',
    errorLineRequired: 'At least one line is required.',
    errorLinesReordering: 'An error occurred while reordering: {{error}}',
    errorMarginBaseAndAdderRequired: 'Margin Base and Margin Adder are required either neither or both.',
    errorMaxPriceDecimals: 'Price decimals must be less than or equal to 5.',
    errorMovePart: 'An error occurred while moving part: {{error}}.',
    errorMustBeExactlyDigitsOrEmpty: 'Must be exactly {{count}} digits or empty',
    errorNoDataFound: 'No data found.',
    errorNonSsoSignIn: 'You must sign on using your SSO email address.',
    errorNoPartsProvidedForDatasheetExport: 'No part provided for data sheets export.',
    errorNoteContentRequired: 'Note cannot be empty.',
    errorNoteRequired: 'At least one note is required.',
    errorNoteTypeRequired: 'At least one note type is required.',
    errorPartBomSourceRequired: 'Please select a Part Number to copy.',
    errorPartFinderAttributeColorHexInvalid: 'Enter the colour as a hex code, for example #1A73E8.',
    errorPartFinderAttributeRangeIncrementInvalid: 'Increment must be greater than 0.',
    errorPartFinderAttributeRangeMinAboveMax: 'Min cannot be greater than Max.',
    errorPartFinderAttributeRangeNumberInvalid: 'Enter a number.',
    errorPartFinderAttributeValueExists: 'This value is already in the list.',
    errorPartFinderAttributeValuesRequired: 'Add at least one value before publishing.',
    errorPartFinderFamilyGroupNameTaken: 'A group with this name already exists in the family',
    errorPartFinderFamilyNotFound: 'This family does not exist or was removed.',
    errorPartFinderFamilyPartAlreadyAdded: '{{number}} is already in this family.',
    errorPartFinderFamilyPartsLoad: "The family's parts could not be loaded. Close it and try again.",
    errorPartFinderProductTypeAttributeExists: 'An attribute with this name is already on this product type.',
    errorPartFinderProductTypeAttributeListTypeMismatch: "The value list's type doesn't match the attribute's type.",
    errorPartFinderProductTypeAttributesRequired: 'Add at least one attribute before publishing.',
    errorPartFinderProductTypeAttributeValuesRequired: "'{{name}}' needs at least one value before publishing.",
    errorPartsAdding_one: 'An error occurred while adding the part.',
    errorPartsAdding_other: 'An error occurred while adding the parts.',
    errorPasswordsDoNotMatch: 'Passwords do not match.',
    errorPostalCodeDigits: 'Postal code must be digits only.',
    errorPostalCodeLength: 'Postal code must be 5 characters long.',
    errorPreviewBomImportHeadersRequired: 'Either the part number or the description header must be present.',
    errorPriceCannotBeCalculated: 'Price cannot be calculated.',
    errorPriceCannotBeCalculatedByType: '{{type}} Price cannot be calculated.',
    errorPricingDateMustBeFuture:
      'Pricing date must be a future date. Leave empty to use the current date.',
    errorPricingProfileAccessAllNotAllowed: 'You must choose at least one Custom Option.',
    errorPricingProfilePartNumberEmptyCost: 'Standard cost is required when a purchase cost is set.',
    errorPricingProfilePartNumberEmptyPurchaseCost:
      'Purchase cost is required when a standard cost is set.',
    errorProspectQuoteContactExists:
      'A contact with this email already exists. Use Add Quote instead.',
    errorPurchaseOrderNumberTooLong: 'Purchase Order Number cannot exceed {{max}} characters.',
    errorQuantityRequired: 'Quantity cannot be empty.',
    errorReCaptchaRequired: 'Please solve the reCAPTCHA.',
    errorReorderingFailed: 'Reordering failed',
    errorRequestedBeforeEarliestDate:
      'Required on site date cannot be earlier than the earliest acceptable date.',
    errorRequestedDate2Days: 'Requested date should be at least 2 days from now.',
    errorRequiredAtLeastOneField: 'At least one field must be selected',
    errorRequiredField: '{{field}} is required',
    errorResendEmailVerificationLinkWithButton: '{{ error }} If you would like us to resend the email click <linkText>here</linkText>.',
    errorSaveNote: 'An error occurred while adding the note: {{error}}.',
    errorSavePart: 'An error occurred while saving part: {{error}}.',
    errorSaveQuoteNote: 'An error occurred while saving the note.',
    errorSelectPriceMarginCost: 'Please choose at least one of the following: prices, margins, costs.',
    errorSigningIn: 'An error occurred while signing in',
    errorSignUpInfo: 'We have sent an email to <0>{{email}}</0>. Please follow the link in the email to complete your account set up.',
    errorSupportRequestTypeRequired: 'Support request type cannot be empty.',
    errorTaxonomyLevelBellowMinimum: 'The taxonomy level is below the minimum taxonomy level of {{minimum}}.',
    errorTitleAccessCreate: 'An error occurred while creating access.',
    errorTitleAccessRemove_one: 'An error occurred while removing access.',
    errorTitleAccessRemove_other: 'An error occurred while removing accesses.',
    errorTitleAccessUpdate: 'An error occurred while updating access.',
    errorTitleAddPnbVariations: 'An error occurred while adding PNB variations',
    errorTitleAddressCreate: 'An error occurred while creating address!',
    errorTitleAddressUpdate: 'An error occurred while updating address!',
    errorTitleAddToPricingProfile_one: 'An error occurred while adding the quote part to the pricing profile',
    errorTitleAddToPricingProfile_other: 'An error occurred while adding the quote parts to the pricing profile',
    errorTitleAdminUserCreate: 'An error occurred while creating admin user.',
    errorTitleAdminUserRemove_one: 'An error occurred while removing admin user.',
    errorTitleAdminUserRemove_other: 'An error occurred while removing admin users.',
    errorTitleAdminUserUpdate: 'An error occurred while updating admin user.',
    errorTitleApprovedVendorRemove: 'An error occurred while removing approved vendor association',
    errorTitleApprovedVendorUpdate: 'An error occurred while updating approved vendor association',
    errorTitleAttributesSave: 'An error occurred while saving the attributes.',
    errorTitleBellNotificationUpdate: 'An error occurred while updating notifications.',
    errorTitleBomImportPreview: 'An error occurred while creating the import preview!',
    errorTitleBomImportUpdateParts: 'An error occurred while updating the import parts!',
    errorTitleCacheLoad: 'Could not load the cache list',
    errorTitleCalculatePrices: 'An error occurred while calculating prices!',
    errorTitleCancelConsumerJobs: 'An error occurred while canceling the jobs!',
    errorTitleCheckActiveOverlappingCost:
      'An error occurred while checking the active overlapping cost.',
    errorTitleCheckActiveOverlappingPrice:
      'An error occurred while checking the active overlapping price.',
    errorTitleClearCache: 'An error occurred while clearing the cache!',
    errorTitleCompanyPartUpdate: 'An error occurred while updating the company part!',
    errorTitleComponentCreate: 'An error occurred while creating component.',
    errorTitleComponentsCreate_one: 'An error occurred while creating component.',
    errorTitleComponentsCreate_other: 'An error occurred while creating components.',
    errorTitleComponentsUpdate_one: 'An error occurred while updating component.',
    errorTitleComponentsUpdate_other: 'An error occurred while updating components.',
    errorTitleComponentTemplateCreate: 'An error occurred while creating component template line.',
    errorTitleComponentTemplatesRemove_one: 'An error occurred while removing component template line.',
    errorTitleComponentTemplatesRemove_other: 'An error occurred while removing component template lines.',
    errorTitleComponentTemplateUpdate: 'An error occurred while updating component template line.',
    errorTitleComponentTemplateValidate: 'An error occurred while validating part.',
    errorTitleComponentUpdate: 'An error occurred while updating component.',
    errorTitleConsumerDataLoad: 'Could not load consumer data',
    errorTitleConsumerRestart: 'An error occurred while restarting consumers!',
    errorTitleContactCreate: 'An error occurred while creating contact!',
    errorTitleContactGroupAddressMerge: 'An error occurred while merging locations!',
    errorTitleContactGroupAddressRemove: 'An error occurred while removing location!',
    errorTitleContactGroupAddressSave: 'An error occurred while saving location!',
    errorTitleContactGroupAddressUpdate: 'An error occurred while updating location!',
    errorTitleContactGroupCreate: 'An error occurred while creating company!',
    errorTitleContactGroupDefaultPricingUpdate: 'An error occurred while updating default pricing',
    errorTitleContactGroupMerge: 'An error occurred while merging companies!',
    errorTitleContactGroupUpdate: 'An error occurred while updating the company!',
    errorTitleContactOwnerUpdate: 'An error occurred while updating contact owner!',
    errorTitleContactRemove: 'An error occurred while removing contact!',
    errorTitleContactRestore: 'An error occurred while restoring contact!',
    errorTitleContactUpdate: 'An error occurred while updating contact!',
    errorTitleCostingCalculationCreate: 'An error occurred while creating the costing calculation!',
    errorTitleCostingCalculationsRemove_one: 'An error occurred while removing the costing calculation!',
    errorTitleCostingCalculationsRemove_other: 'An error occurred while removing the costing calculations!',
    errorTitleCostingCalculationUpdate: 'An error occurred while updating the costing calculation!',
    errorTitleCostingCalculationUpsert: 'An error occurred while saving the costing calculation!',
    errorTitleCostingProfileCreate: 'An error occurred while creating the costing profile',
    errorTitleCostingProfileSave: 'An error occurred while saving the costing profile!',
    errorTitleCostingProfilesRemove_one: 'An error occurred while removing the costing profile!',
    errorTitleCostingProfilesRemove_other: 'An error occurred while removing the costing profiles!',
    errorTitleCostingProfilesUpdate: 'An error occurred while updating the costing profiles',
    errorTitleCostingProfileUpdate: 'An error occurred while updating the costing profile',
    errorTitleCreateImportPartManufacturers: 'An error occurred while saving manufacturers!',
    errorTitleCreateProspectQuote: 'An error occurred while creating the prospect quote!',
    errorTitleCustomerCreate: 'An error occurred while creating customer',
    errorTitleCustomersRemove_one: 'An error occurred while removing customer',
    errorTitleCustomersRemove_other: 'An error occurred while removing customers',
    errorTitleCustomerUpdate: 'An error occurred while updating customer',
    errorTitleDataExtracting: 'An error occurred while extracting the data!',
    errorTitleDataImporting: 'An error occurred while importing the data!',
    errorTitleDataLoading: 'An error occurred while loading the data!',
    errorTitleDefaultDatasheetUpdate: 'An error occurred while updating the default datasheet.',
    errorTitleDefaultImageUpdate: 'An error occurred while updating the default image.',
    errorTitleDefaultVendorListFetch:
      'An error occurred while fetching the default vendor list!',
    errorTitleDetachVendorQuote_one: 'An error occurred while detaching quote!',
    errorTitleDetachVendorQuote_other: 'An error occurred while detaching quotes!',
    errorTitleDetachVendorQuoteFromProject_one: 'An error occurred while detaching quote from project!',
    errorTitleDetachVendorQuoteFromProject_other: 'An error occurred while detaching quotes from project!',
    errorTitleElementComponentNoteCreate: 'An error occurred while creating element component note.',
    errorTitleElementComponentNotesCreate_one: 'An error occurred while creating element component note.',
    errorTitleElementComponentNotesCreate_other: 'An error occurred while creating element component notes.',
    errorTitleElementComponentNotesRemove_one: 'An error occurred while removing element component note.',
    errorTitleElementComponentNotesRemove_other: 'An error occurred while removing element component notes.',
    errorTitleElementComponentNotesUpdate_one: 'An error occurred while updating element component note.',
    errorTitleElementComponentNotesUpdate_other: 'An error occurred while updating element component notes.',
    errorTitleElementComponentNoteUpdate: 'An error occurred while updating element component note.',
    errorTitleElementCreate: 'An error ocurred while creating an element.',
    errorTitleElementSaveAsTemplate: 'An error occurred while saving element as template.',
    errorTitleElementTemplateAddToJob: 'An error occurred while adding the element template to job.',
    errorTitleElementTemplateCreate: 'An error occurred while creating the element template.',
    errorTitleElementTemplatesRemove_one: 'An error occurred while removing the element template.',
    errorTitleElementTemplatesRemove_other: 'An error occurred while removing element templates.',
    errorTitleElementTemplateUpdate: 'An error occurred while updating the element template.',
    errorTitleElementUpdate: 'An error ocurred while updating an element.',
    errorTitleExpiredCostingReset: 'An error ocurred while resetting outdated costing.',
    errorTitleExternalPricing: 'An error occurred while fetching external pricing!',
    errorTitleExtractorVendorMappingCreate: 'An error occurred while creating the mapping!',
    errorTitleExtractorVendorMappingRemove: 'An error occurred while removing the mapping!',
    errorTitleExtractorVendorMappingUpdate: 'An error occurred while updating the mapping!',
    errorTitleFileUpload: 'An error occurred while uploading the file!',
    errorTitleImpersonateUser: 'An error occurred while impersonating user!',
    errorTitleImportFailedRowsFetch: 'An error occurred while fetching the failed import rows!',
    errorTitleImportParts: 'An error occurred while importing parts!',
    errorTitleInventoryLoad: 'The inventory could not be loaded!',
    errorTitleInvitationRevoke: 'An error occurred while revoking access!',
    errorTitleInvitationSend: 'An error occurred while sending invitation!',
    errorTitleJobCreate: 'An error occurred while creating the job!',
    errorTitleJobFileAttach: 'An error occurred while attaching file!',
    errorTitleJobFileDetach: 'An error occurred while detaching file!',
    errorTitleJobImportCreating: 'An error occurred while reading the file!',
    errorTitleJobNameUpdating: 'An error occurred while updating the job name!',
    errorTitleJobPartComponentAdd: 'An error occurred while adding component name.',
    errorTitleJobPartComponentRemove: 'An error occurred while removing component name.',
    errorTitleJobPartComponentUpdate: 'An error occurred while updating component name.',
    errorTitleJobPartLineCalculatePrices: 'An error occurred while calculating prices.',
    errorTitleJobPartLineCreate: 'An error occurred while creating line.',
    errorTitleJobPartLinesRemove_one: 'An error occurred while removing selected lines.',
    errorTitleJobPartLinesRemove_other: 'An error occurred while removing selected lines.',
    errorTitleJobPartLinesRestore_one: 'An error occurred while restoring line.',
    errorTitleJobPartLinesRestore_other: 'An error occurred while restoring lines.',
    errorTitleJobPartLineUpdate: 'An error occurred while updating line.',
    errorTitleJobPartLineValidate: 'An error occurred while validating part.',
    errorTitleJobPartNoteCreate: 'An error occurred while creating note.',
    errorTitleJobPartNotesCreate: 'An error occurred while creating notes.',
    errorTitleJobPartNotesRemove_one: 'An error occurred while removing note.',
    errorTitleJobPartNotesRemove_other: 'An error occurred while removing notes.',
    errorTitleJobPartNoteUpdate: 'An error occurred while updating note.',
    errorTitleJobPartsAddToJob_one: 'An error occurred while adding part to job.',
    errorTitleJobPartsAddToJob_other: 'An error occurred while adding parts to job.',
    errorTitleJobUpdate_one: 'An error occurred while updating the job!',
    errorTitleJobUpdate_other: 'An error occurred while updating the jobs!',
    errorTitleLeadTimeSuggestionsLoading: 'An error occurred while loading the lead time suggestions!',
    errorTitleLineChange: 'An error occurred while changing line!',
    errorTitleLineCreating: 'An error occurred while creating line!',
    errorTitleLineDuplicate_one: 'An error occurred while duplicating line',
    errorTitleLineDuplicate_other: 'An error occurred while duplicating lines',
    errorTitleLineNoteCreate: 'An error occurred while creating note',
    errorTitleLineNoteRemove: 'An error occurred while removing line note',
    errorTitleLineNotesCreate_one: 'An error occurred while creating line note',
    errorTitleLineNotesCreate_other: 'An error occurred while creating line notes',
    errorTitleLineNotesRemove_one: 'An error occurred while removing line note',
    errorTitleLineNotesRemove_other: 'An error occurred while removing line notes',
    errorTitleLineNotesRequired: 'Line notes cannot be empty.',
    errorTitleLineNoteUpdate: 'An error occurred while updating note',
    errorTitleLinesMoveTo_one: 'An error occurred while moving line',
    errorTitleLinesMoveTo_other: 'An error occurred while moving lines',
    errorTitleLinesRemove_one: 'An error occurred while removing line',
    errorTitleLinesRemove_other: 'An error occurred while removing lines',
    errorTitleLinesReorder: 'An error occurred while reordering lines!',
    errorTitleLinesUpdate_one: 'An error occurred while updating line',
    errorTitleLinesUpdate_other: 'An error occurred while updating lines',
    errorTitleLogCreate: 'An error occurred while creating log time!',
    errorTitleLogsCreate_one: 'An error occurred while creating log time!',
    errorTitleLogsCreate_other: 'An error occurred while creating log times!',
    errorTitleLogsRemove_one: 'An error occurred while removing log time!',
    errorTitleLogsRemove_other: 'An error occurred while removing log times!',
    errorTitleLogsUpdate: 'An error occurred while updating log times!',
    errorTitleLogsUpdate_one: 'An error occurred while updating log time!',
    errorTitleLogsUpdate_other: 'An error occurred while updating log times!',
    errorTitleLogUpdate: 'An error occurred while updating log time!',
    errorTitleOrderCreate: 'An error occurred while creating order!',
    errorTitleOrderSubmit: 'An error occurred while submitting order!',
    errorTitlePartBomCreate: 'An error occurred while creating Part BOM.',
    errorTitlePartBomItemCreate: 'An error occurred while creating Part BOM line.',
    errorTitlePartBomItemNoteCreate: 'An error occurred while creating Part BOM line note.',
    errorTitlePartBomItemNotesRemove_one: 'An error occurred while removing Part BOM line note.',
    errorTitlePartBomItemNotesRemove_other: 'An error occurred while removing Part BOM line notes.',
    errorTitlePartBomItemNoteUpdate: 'An error occurred while updating Part BOM line note.',
    errorTitlePartBomItemsRemove_one: 'An error occurred while removing Part BOM line.',
    errorTitlePartBomItemsRemove_other: 'An error occurred while removing Part BOM lines.',
    errorTitlePartBomItemUpdate: 'An error occurred while updating Part BOM line.',
    errorTitlePartBomItemValidate: 'An error occurred while validating Part BOM line.',
    errorTitlePartBomRemove: 'An error occurred while removing Part BOM.',
    errorTitlePartBomUpdate: 'An error occurred while updating Part BOM.',
    errorTitlePartCostCreate: 'An error occurred while creating part cost.',
    errorTitlePartCostsRemove_one: 'An error occurred while removing part cost.',
    errorTitlePartCostsRemove_other: 'An error occurred while removing part costs.',
    errorTitlePartCostUpdate: 'An error occurred while updating part cost.',
    errorTitlePartFieldConfigsFetch: 'An error occurred while loading the part field configuration.',
    errorTitlePartFinderAttributeCompare: 'An error occurred while comparing the versions',
    errorTitlePartFinderAttributeSave: 'An error occurred while saving the value list',
    errorTitlePartFinderAttributesPublish_one: 'An error occurred while publishing the value list',
    errorTitlePartFinderAttributesPublish_other: 'An error occurred while publishing the value lists',
    errorTitlePartFinderAttributesRemove_one: 'An error occurred while removing the value list',
    errorTitlePartFinderAttributesRemove_other: 'An error occurred while removing the value lists',
    errorTitlePartFinderAttributeVersionsFetch: 'An error occurred while loading the version history',
    errorTitlePartFinderFamiliesPublish_one: 'An error occurred while publishing the family',
    errorTitlePartFinderFamiliesPublish_other: 'An error occurred while publishing the families',
    errorTitlePartFinderFamiliesRemove_one: 'An error occurred while removing the family',
    errorTitlePartFinderFamiliesRemove_other: 'An error occurred while removing the families',
    errorTitlePartFinderFamiliesUnpublish_one: 'An error occurred while unpublishing the family',
    errorTitlePartFinderFamiliesUnpublish_other: 'An error occurred while unpublishing the families',
    errorTitlePartFinderFamilyCompare: 'An error occurred while comparing the versions',
    errorTitlePartFinderFamilyPartResolve: 'An error occurred while adding the part',
    errorTitlePartFinderFamilySave: 'An error occurred while saving the family',
    errorTitlePartFinderFamilyVersionsFetch: 'An error occurred while loading the version history',
    errorTitlePartFinderProductTypeCompare: 'An error occurred while comparing the versions',
    errorTitlePartFinderProductTypeSave: 'An error occurred while saving the product type',
    errorTitlePartFinderProductTypesPublish_one: 'An error occurred while publishing the product type',
    errorTitlePartFinderProductTypesPublish_other: 'An error occurred while publishing the product types',
    errorTitlePartFinderProductTypesRemove_one: 'An error occurred while removing the product type',
    errorTitlePartFinderProductTypesRemove_other: 'An error occurred while removing the product types',
    errorTitlePartFinderProductTypeVersionsFetch: 'An error occurred while loading the version history',
    errorTitlePartMediaFileDescriptionUpdate:
      'An error occurred while updating the file description.',
    errorTitlePartMediaFileRemove: 'An error occurred while removing the file.',
    errorTitlePartNumbersRemove_one: 'An error occurred while removing fixed price.',
    errorTitlePartNumbersRemove_other: 'An error occurred while removing fixed prices.',
    errorTitlePartNumbersUpsert: 'An error occurred while saving fixed price.',
    errorTitlePartParticularsSave: 'An error occurred while saving part particulars.',
    errorTitlePartPriceCreate: 'An error occurred while creating part price.',
    errorTitlePartPricesRemove_one: 'An error occurred while removing part price.',
    errorTitlePartPricesRemove_other: 'An error occurred while removing part prices.',
    errorTitlePartPriceUpdate: 'An error occurred while updating part price.',
    errorTitlePartSave: 'An error occurred while saving the part.',
    errorTitlePartValidation: 'An error occurred while validating part!',
    errorTitlePartVideoRemove: 'An error occurred while removing the video.',
    errorTitlePartVideoSave: 'An error occurred while saving the video.',
    errorTitlePayloadCopy: 'The request payload could not be copied!',
    errorTitlePricingProfileCreate: 'An error occurred while creating the pricing profile',
    errorTitlePricingProfileDocumentRemove: 'An error occurred while removing pricing profile document',
    errorTitlePricingProfileDocumentSave: 'An error occurred while uploading pricing profile document',
    errorTitlePricingProfileRuleCreate: 'An error occurred while creating the pricing profile rule',
    errorTitlePricingProfileRulesRemove_one: 'An error occurred while removing the pricing profile rule',
    errorTitlePricingProfileRulesRemove_other: 'An error occurred while removing the pricing profile rules',
    errorTitlePricingProfileRuleUpdate: 'An error occurred while updating the pricing profile rule',
    errorTitlePricingProfileRuleUpsert: 'An error occurred while saving the pricing profile rule',
    errorTitlePricingProfileSave: 'An error occurred while saving the pricing profile.',
    errorTitlePricingProfilesRemove_one: 'An error occurred while removing the pricing profile',
    errorTitlePricingProfilesRemove_other: 'An error occurred while removing the pricing profiles',
    errorTitlePricingProfilesUpdate: 'An error occurred while updating the pricing profiles',
    errorTitlePricingProfileUpdate: 'An error occurred while updating the pricing profile',
    errorTitleProjectCreate: 'An error occurred while creating the project!',
    errorTitleProjectCustomerAdd: 'An error occurred while adding the customer!',
    errorTitleProjectCustomerRemove: 'An error occurred while removing the customer!',
    errorTitleProjectPricingProfileAdd: 'An error occurred while adding the pricing profile to project!',
    errorTitleProjectPricingProfileCreate: 'An error occurred while creating the pricing profile!',
    errorTitleProjectPricingProfileRemove_one: 'An error occurred while removing the pricing profile from project!',
    errorTitleProjectPricingProfileRemove_other: 'An error occurred while removing the pricing profiles from project!',
    errorTitleProjectUpdate: 'An error occurred while updating the project!',
    errorTitleProjectUserSave: 'An error occurred while saving the user!',
    errorTitleProjectUsersRemove_one: 'An error occurred while removing the user!',
    errorTitleProjectUsersRemove_other: 'An error occurred while removing the users!',
    errorTitleProjectUserUpdate: 'An error occurred while updating the user!',
    errorTitleQuoteCreate: 'An error occurred while creating {{entityType}}!',
    errorTitleQuoteDuplicate: 'An error occurred while duplicating {{entityType}}!',
    errorTitleQuoteFileAttach: 'An error occurred while attaching {{entityType}} file!',
    errorTitleQuoteFileDetach: 'An error occurred while detaching {{entityType}} file!',
    errorTitleQuoteImportCreating: 'An error occurred while reading the file!',
    errorTitleQuoteNoteCreate: 'An error occurred while creating {{entityType}} note!',
    errorTitleQuoteNoteUpdate: 'An error occurred while updating {{entityType}} note!',
    errorTitleQuotePartsUpdate_one: 'An error occurred while updating quote part!',
    errorTitleQuotePartsUpdate_other: 'An error occurred while updating quote parts!',
    errorTitleQuotesArchive_one: 'An error occurred while archiving the {{entityType}}!',
    errorTitleQuotesArchive_other: 'An error occurred while archiving the {{entityType}}s!',
    errorTitleQuotesCreate: 'An error occurred while creating {{entityType}}s!',
    errorTitleQuoteSendToFileNet: 'An error occurred while sending quote to FileNet!',
    errorTitleQuoteSendToVendor: 'An error occurred while sending quote to Vendor!',
    errorTitleQuotesReassign_one: 'An error occurred while reassigning the {{entityType}}!',
    errorTitleQuotesReassign_other: 'An error occurred while reassigning the {{entityType}}s!',
    errorTitleQuotesRestore_one: 'An error occurred while restoring the {{entityType}}!',
    errorTitleQuotesRestore_other: 'An error occurred while restoring the {{entityType}}s!',
    errorTitleQuoteSubmitOrder: 'An error occurred while submitting order!',
    errorTitleQuotesUpdate_one: 'An error occurred while updating the {{entityType}}!',
    errorTitleQuotesUpdate_other: 'An error occurred while updating the {{entityType}}s!',
    errorTitleQuoteToProjectAttach: 'An error occurred while attaching quote to project!',
    errorTitleQuoteToQuoteAttach_one: 'An error occurred while attaching quote!',
    errorTitleQuoteToQuoteAttach_other: 'An error occurred while attaching quotes!',
    errorTitleQuoteUpdate: 'An error occurred while updating {{entityType}}!',
    errorTitleQuoteVersionDataCreate: 'An error occurred while creating {{entityType}} freight!',
    errorTitleQuoteVersionDataSave: 'An error occurred while saving {{entityType}} freight.',
    errorTitleQuoteVersionDataUpdate: 'An error occurred while updating {{entityType}} freight!',
    errorTitleReattachVendorQuote_one: 'An error occurred while reattaching quote!',
    errorTitleReattachVendorQuote_other: 'An error occurred while reattaching quotes!',
    errorTitleResetPricingType: 'An error occurred while resetting {{type}}',
    errorTitleSalesHistoryLoad: 'The sales history could not be loaded!',
    errorTitleSaveUoms: 'An error occurred while saving the units of measurement!',
    errorTitleSelectedSpaApply: 'Applying the selected SPA to the eligible lines was interrupted!',
    errorTitleSubmitOrderLogReport: 'The submit order log could not be loaded!',
    errorTitleSubmitOrderPayload: 'The request payload could not be loaded!',
    errorTitleToggleAllCustomers: 'An error occurred while updating customer settings!',
    errorTitleTradeAgreementsFetch: 'The SPA costs could not be loaded!',
    errorTitleUomConversionAuditBulkSetUp: 'An error occurred while setting up the company parts!',
    errorTitleUomConversionAuditBulkUpdate: 'An error occurred while updating the UOMs!',
    errorTitleUomConversionAuditReport: 'The UOM conversion audit could not be loaded!',
    errorTitleUomConversionCreating: 'An error occurred while creating UOM conversion!',
    errorTitleUomConversionsRemoving: 'An error occurred while removing UOM conversions!',
    errorTitleUomConversionUpdating: 'An error occurred while updating UOM conversion!',
    errorTitleVendorCreate: 'An error occurred while creating vendor!',
    errorTitleVendorQuoteDetailsUpdate: 'An error occurred while updating the quote details!',
    errorTitleVendorQuoteImport: 'An error occurred while importing vendor quote!',
    errorTitleVendorQuoteImportCreating: 'An error occurred while reading the file!',
    errorTitleVendorQuoteLogReport: 'The import log could not be loaded!',
    errorTitleVendorQuotesAttach_one: 'An error occurred while attaching vendor quote.',
    errorTitleVendorQuotesAttach_other: 'An error occurred while attaching vendor quotes.',
    errorTitleVendorQuotesDetach_one: 'An error occurred while detaching vendor quote.',
    errorTitleVendorQuotesDetach_other: 'An error occurred while detaching vendor quotes.',
    errorTitleVendorsRemove_one: 'An error occurred while removing vendor!',
    errorTitleVendorsRemove_other: 'An error occurred while removing vendors!',
    errorTitleVendorUpdate: 'An error occurred while updating vendor!',
    errorTradeAgreementStartDateAfterValidUntil:
      'SPA start date cannot be after the vendor quote valid until date: {{validUntil}}.',
    errorTradeAgreementStartDateRequired: 'SPA start date is required.',
    errorUnknownExportType: 'Unknown export type.',
    errorUnknownInputType: 'Unknown input type {{type}}.',
    errorUserRequired: 'Please select the user to impersonate.',
    errorUserSettingSave: 'An error occurred while saving user setting',
    errorValidSinceAfterUntil: 'The valid since date must be before the valid until date.',
    errorVariationBothLengthAndQuantityRequired: 'Both length and quantity are required, for each variation.',
    errorVariationRequiredAtLeastOne: 'At least one variation is required.',
    serverError: 'Server error.',

    // Error - Prefixes
    errorGenerateExportFilePrefix:
      'An error occurred while generating the export file: {{ errorMessage}}',
    errorGenerateExportPrefix: 'An error occurred while generating the export: {{ errorMessage}}',

    // Button Labels
    buttonLabelAdd: 'Add',
    buttonLabelAddAccess: 'Add Access',
    buttonLabelAddAdminUser: 'Add Admin User',
    buttonLabelAddAlternateLine: 'Add Alternate',
    buttonLabelAddAnotherVendor: 'Add Another Vendor',
    buttonLabelAddAttributes: 'Add Attributes',
    buttonLabelAddCompanyPartSpecificationCriteria: 'Add Company Part Specification Criteria',
    buttonLabelAddComponent: 'Add Component',
    buttonLabelAddComponentName: 'Add Component Name',
    buttonLabelAddContact: 'Add Contact',
    buttonLabelAddCostingCalculation: 'Add Costing Calculation',
    buttonLabelAddCostNote: 'Add Cost Note',
    buttonLabelAddCustomer: 'Add Customer',
    buttonLabelAddDiscountRule: 'Add Discount Rule',
    buttonLabelAddElement: 'Add Element',
    buttonLabelAddElementTemplate: 'Add Element Template',
    buttonLabelAddExtractorVendorMapping: 'Add Mapping',
    buttonLabelAddFilter: 'Save as a New Filter Set',
    buttonLabelAddJob: 'Add Job',
    buttonLabelAddLine: 'Add Line',
    buttonLabelAddLocation: 'Add Location',
    buttonLabelAddLog: 'Log Time',
    buttonLabelAddLogs: 'Log Time',
    buttonLabelAddManufacturer: 'Add Manufacturer',
    buttonLabelAddMarginRule: 'Add Margin Rule',
    buttonLabelAddNewLine: 'Add New Line',
    buttonLabelAddNote: 'Add Note',
    buttonLabelAddNotes: 'Add Notes',
    buttonLabelAddNumberRange: 'Add Number & Range',
    buttonLabelAddPartBom: 'Add Part BOM',
    buttonLabelAddPartBomItem: 'Add Part Number',
    buttonLabelAddPartCost: 'Add Part Cost',
    buttonLabelAddPartFinderAttribute: 'Add Value List',
    buttonLabelAddPartFinderFamily: 'Add Part Finder Family',
    buttonLabelAddPartFinderProductType: 'Add Product Type',
    buttonLabelAddPartNumber: 'Add Part Number',
    buttonLabelAddPartNumbers: 'Add Part Numbers',
    buttonLabelAddPartPrice: 'Add Part Price',
    buttonLabelAddParts: 'Add Parts',
    buttonLabelAddPartSpecificationCriteria: 'Add Part specification Criteria',
    buttonLabelAddPricingProfilePartNumber: 'Add Part Number Based',
    buttonLabelAddProject: 'Add Project',
    buttonLabelAddProjectPricingProfile: 'Add Pricing Profile',
    buttonLabelAddProjectUser: 'Add User',
    buttonLabelAddQuantity: 'Add Quantity',
    buttonLabelAddQuote: 'Add {{entityType}}',
    buttonLabelAddRegion: 'Add Region',
    buttonLabelAddRequest: 'Enter the Request Details',
    buttonLabelAddTo: 'Add To...',
    buttonLabelAddToCustomerQuote: 'Add to Customer {{entityType}}',
    buttonLabelAddToJob: 'Add to Job',
    buttonLabelAddToPricingProfile: 'Add to Pricing Profile',
    buttonLabelAddToPricingProfileAll: 'Add All',
    buttonLabelAddToPricingProfileNew: 'Add New',
    buttonLabelAddToQuote: 'Add to {{entityType}}',
    buttonLabelAddToVendorQuote: 'Add to Vendor {{entityType}}',
    buttonLabelAddUomConversion: 'Add UOM Conversion',
    buttonLabelAddUomConversions: 'Add UOM Conversions',
    buttonLabelAddUser: 'Add User',
    buttonLabelAddValue: 'Add Value',
    buttonLabelAddVariations: 'Add Variations',
    buttonLabelAddVendor: 'Add Vendor',
    buttonLabelAllFilters: 'All Filters',
    buttonLabelApply: 'Apply',
    buttonLabelApplyCostDiscount: 'Discount Cost',
    buttonLabelArchive: 'Archive',
    buttonLabelAssignManufacturer: 'Assign Manufacturer',
    buttonLabelAssignSelectedTo: 'Assign Selected to',
    buttonLabelAssignVendor: 'Assign Vendor',
    buttonLabelAttachExistingVendorQuotes: 'Attach Existing Vendor Quotes',
    buttonLabelAttachSelectedParts_one: 'Attach Selected Part',
    buttonLabelAttachSelectedParts_other: 'Attach Selected Parts',
    buttonLabelAttachSelectedVendorQuotes_one: 'Attach Selected Vendor Quote',
    buttonLabelAttachSelectedVendorQuotes_other: 'Attach Selected Vendor Quotes',
    buttonLabelBack: 'Back',
    buttonLabelBillOfMaterials: 'Bill of Materials',
    buttonLabelBillTo: 'Bill To',
    buttonLabelBlock: 'Block',
    buttonLabelBlockIp: 'Block IP',
    buttonLabelBulkExportSkuParts_one: 'Export {{count}} quote',
    buttonLabelBulkExportSkuParts_other: 'Export {{count}} quotes',
    buttonLabelBulkResendAsSpa_one: 'Resend {{count}} quote',
    buttonLabelBulkResendAsSpa_other: 'Resend {{count}} quotes',
    buttonLabelBulkSendAndResendAsSpa_one: 'Send and resend {{count}} quote',
    buttonLabelBulkSendAndResendAsSpa_other: 'Send and resend {{count}} quotes',
    buttonLabelBulkSendAsSpa_one: 'Send {{count}} quote',
    buttonLabelBulkSendAsSpa_other: 'Send {{count}} quotes',
    buttonLabelCancel: 'Cancel',
    buttonLabelCancelImport: 'Cancel Import',
    buttonLabelCancelResetQuotePartExpiredCosting: 'No, return to {{quoteEntityType}}.',
    buttonLabelChangeAssignedCompany: 'Change Assigned Company',
    buttonLabelChangeContactGrouping: 'Change Contact Group',
    buttonLabelChangeFreight: 'Change Freight',
    buttonLabelChangeIsrOsr: 'Change ISR/OSR',
    buttonLabelChangeOwner: 'Change Owner',
    buttonLabelChangePricingToManual: 'Change Pricing to "Manual"',
    buttonLabelChangeSelectedTo: 'Change Selected to',
    buttonLabelChangeSpa: 'Change SPA',
    buttonLabelChangeToViewByElement: 'Change to View By Element',
    buttonLabelClear: 'Clear',
    buttonLabelClearAll: 'Clear all',
    buttonLabelClearHeaders: 'Clear Headers',
    buttonLabelClickEditShipToAddress: 'Click here to Edit the Ship to Address',
    buttonLabelClose: 'Close',
    buttonLabelCompare: 'Compare',
    buttonLabelCompleteAndAddToMyQuote: 'Complete and Add to My Quote',
    buttonLabelConfigureTheAttributes: 'Configure the Attributes',
    buttonLabelConfirm: 'Confirm',
    buttonLabelConfirmMapping: 'Confirm Mapping',
    buttonLabelConfirmMergeContactGroups: 'Confirm Merge Companies',
    buttonLabelConfirmOrderIncludePricing: 'Confirm / Include no cost lines',
    buttonLabelConfirmOrderOmitPricing: 'Confirm / Omit no cost lines',
    buttonLabelConfirmResetQuotePartExpiredCosting: 'Yes, recalculate costs.',
    buttonLabelContinue: 'Continue',
    buttonLabelCopied: 'Copied!',
    buttonLabelCopy: 'Copy',
    buttonLabelCopyLink: 'Copy link',
    buttonLabelCopyMoveToElement: 'Copy or Move to Element',
    buttonLabelCopyOrMove: 'Copy Or Move',
    buttonLabelCopyRequest: 'Copy Request',
    buttonLabelCopyResponse: 'Copy Response',
    buttonLabelCopyToCustomerQuote: 'Copy to Customer Quote',
    buttonLabelCopyToElement: 'Copy to Element',
    buttonLabelCreate: 'Create',
    buttonLabelCreateBom: 'Create a Job BoM',
    buttonLabelCreateCostingProfile: 'Create Costing Profile',
    buttonLabelCreateElementTemplate: 'Create Element Template',
    buttonLabelCreateJob: 'Create Job',
    buttonLabelCreateLocation: 'Create Location',
    buttonLabelCreateNew: 'Create New',
    buttonLabelCreateNewCustomerQuote: 'Create New Customer {{entityType}}',
    buttonLabelCreateNewJob: 'Create New Job',
    buttonLabelCreateNewSupportRequest: 'New Request',
    buttonLabelCreateNewVendorQuote: 'Create New Vendor {{entityType}}',
    buttonLabelCreateOrder: 'Create Order',
    buttonLabelCreatePricingProfile: 'Create Pricing Profile',
    buttonLabelCreateProject: 'Create Project',
    buttonLabelCreateQuote: 'Create a Quote',
    buttonLabelCreateRank: 'Create Rank',
    buttonLabelDefineAttributesOrder: 'Define Attributes Order',
    buttonLabelDefineValuesOrder: 'Define Values Order',
    buttonLabelDelete: 'Delete',
    buttonLabelDetach: 'Detach',
    buttonLabelDetachFromGroup: 'Detach from group',
    buttonLabelDiscardChanges: 'Discard Changes',
    buttonLabelDone: 'Done',
    buttonLabelDoNotAssignManufacturer: 'Do Not Assign Manufacturer',
    buttonLabelDownload: 'Download',
    buttonLabelDownloadCsv: 'Download CSV',
    buttonLabelDownloadDataSheets: 'Download All Data Sheets',
    buttonLabelDownloadPdf: 'Download PDF',
    buttonLabelDownloadXls: 'Download XLS',
    buttonLabelDuplicate: 'Duplicate',
    buttonLabelDuplicateQuote: 'Duplicate {{entityType}}',
    buttonLabelEdit: 'Edit',
    buttonLabelEditBaseInformation: 'Edit Base Information',
    buttonLabelEditCompanyPartDetails: 'Edit Company Part Details',
    buttonLabelEditComponentName: 'Edit Component Name',
    buttonLabelEditContact: 'Edit Contact',
    buttonLabelEditElement: 'Edit Element',
    buttonLabelEditJobName: 'Edit Name',
    buttonLabelEditJobPartLine: 'Edit Line',
    buttonLabelEditLines: 'Edit',
    buttonLabelEditLocation: 'Edit Location',
    buttonLabelEditPartBomItem: 'Edit Part BOM Line',
    buttonLabelEditParticulars: 'Edit Particulars',
    buttonLabelEditProfileDetails: 'Edit Profile Details',
    buttonLabelEditQuote: 'Edit {{entityType}}',
    buttonLabelEditRank: 'Edit Rank',
    buttonLabelEditShipToAddress: 'Edit Ship To Address',
    buttonLabelEditVendor: 'Edit Vendor',
    buttonLabelEnd: 'End',
    buttonLabelExportCompanyParts: 'Export Company Parts',
    buttonLabelExportJobLog: 'Export Time Log',
    buttonLabelExportLog: 'Export Time Log',
    buttonLabelExportQuoteParts: 'Export Quote Parts',
    buttonLabelExportQuotes: 'Export Quotes',
    buttonLabelExportSkuParts: 'Export SKU Parts',
    buttonLabelExportUomConversions: 'Export UOM Conversions',
    buttonLabelExternalOrder: 'External Order',
    buttonLabelFilters: 'Filters',
    buttonLabelGetStarted: 'Get Started',
    buttonLabelGoToHomepage: 'Go to Homepage',
    buttonLabelGoToTheNextStep: 'Go to the Next Step',
    buttonLabelGroup: 'Group',
    buttonLabelGroupBy: 'Group By',
    buttonLabelGroupByApplied_one: 'Grouped By 1 field',
    buttonLabelGroupByApplied_other: 'Grouped By {{ count }} fields',
    buttonLabelHide: 'Hide',
    buttonLabelImpersonate: 'Impersonate Now',
    buttonLabelImport: 'Import',
    buttonLabelImportBom: 'Import Bill Of Materials',
    buttonLabelImportParts: 'Import Parts',
    buttonLabelImportUpdatedVendorQuote: 'Import Updated Vendor Quote',
    buttonLabelImportVendorQuote: 'Import Vendor Quote',
    buttonLabelJobDetails: 'Job Details',
    buttonLabelKeepDraftVersion: 'Keep Draft',
    buttonLabelLaborSchedule: 'Labor Schedule',
    buttonLabelLeavePage: 'Leave Page',
    buttonLabelLoad: 'Load',
    buttonLabelLoadMore: 'Load more',
    buttonLabelLock: 'Lock',
    buttonLabelManageAttributes: 'Manage Attributes',
    buttonLabelManageDomains: 'Manage Domains',
    buttonLabelManageElements: 'Manage Elements',
    buttonLabelManageEmailDomains: 'Manage Email Domains',
    buttonLabelManageFilters: 'Manage Filters',
    buttonLabelManageNotes: 'Manage Notes',
    buttonLabelMarkAllAsRead: 'Mark all as read',
    buttonLabelMarkAsRead: 'Mark as read',
    buttonLabelMarkAsUnread: 'Mark as unread',
    buttonLabelMergeContactGroups: 'Merge Companies',
    buttonLabelMergeLocations: 'Merge Locations',
    buttonLabelMonthToDate: 'Month to Date',
    buttonLabelMoreInfo: 'More Info',
    buttonLabelMove: 'Move',
    buttonLabelMoveCopy: 'Move / Copy',
    buttonLabelMoveDown: 'Move down',
    buttonLabelMoveTo: 'Move to',
    buttonLabelMoveToElement: 'Move to Element',
    buttonLabelMoveToGroup: 'Move to group',
    buttonLabelMoveUp: 'Move up',
    buttonLabelNext: 'Next',
    buttonLabelNextLine: 'Next Line',
    buttonLabelNoQuote: 'No Quote',
    buttonLabelOmitSelected: 'Omit Selected',
    buttonLabelOrder: 'Order',
    buttonLabelOrderAll: 'Order All',
    buttonLabelOrderNumber: 'Order #{{displayNumber}}',
    buttonLabelOwnedJobs: 'My Jobs',
    buttonLabelPartFamilyDetails: 'Part Family Details',
    buttonLabelPreview: 'Preview',
    buttonLabelPreviewDataSheet: 'Preview Data Sheet',
    buttonLabelPrevious: 'Previous',
    buttonLabelPreviousMonth: 'Previous Month',
    buttonLabelPreviousYear: 'Previous Year',
    buttonLabelPricingActions: 'Pricing Actions',
    buttonLabelProjectDetails: 'Project Details',
    buttonLabelProspectQuote: 'Prospect Quote',
    buttonLabelPublish: 'Publish',
    buttonLabelQuote: 'Quote',
    buttonLabelQuoteDetails: '{{entityType}} Details',
    buttonLabelReassign: 'Reassign',
    buttonLabelReattach: 'Reattach',
    buttonLabelRegenerate: 'Re-generate',
    buttonLabelRelease: 'Release',
    buttonLabelReleaseNoEmail: 'Release - No Email',
    buttonLabelRemove: 'Remove',
    buttonLabelRemoveActivePartPrice: 'Remove Active Price',
    buttonLabelRemoveAssignedCompany: 'Remove Assigned Company',
    buttonLabelRemoveComponentName: 'Remove Component Name',
    buttonLabelRemoveLocation: 'Remove Location',
    buttonLabelRemoveLogs_one: 'Remove Log',
    buttonLabelRemoveLogs_other: 'Remove Logs',
    buttonLabelRemoveNotes: 'Remove Notes',
    buttonLabelRemovePartBomItems_one: 'Remove line',
    buttonLabelRemovePartBomItems_other: 'Remove lines',
    buttonLabelRemovePartCost: 'Remove Part Cost',
    buttonLabelRemovePartPrice: 'Remove Part Price',
    buttonLabelRemovePricingProfileAccess: 'Remove Access',
    buttonLabelRemovePricingProfileCostingCalculation: 'Remove Costing Calculation',
    buttonLabelRemovePricingProfilePartNumber: 'Remove Fixed Price',
    buttonLabelRemovePricingProfileRule: 'Remove Rule',
    buttonLabelRemoveProjectUser: 'Remove User',
    buttonLabelRemoveRank: 'Remove Rank',
    buttonLabelRemoveSelectedSpa: 'Remove Selected SPA',
    buttonLabelRemoveSet: 'Remove Set',
    buttonLabelRemoveUomConversion: 'Remove UOM Conversion',
    buttonLabelRenameJob: 'Rename Job',
    buttonLabelResend: 'Resend',
    buttonLabelResendAsSpa: 'Resend as SPA',
    buttonLabelReset: 'Reset',
    buttonLabelResetAll: 'Reset All',
    buttonLabelResetAllFilters: 'Reset All Filters',
    buttonLabelResetChanges: 'Reset Changes',
    buttonLabelResetDefaultFilters: 'Reset to Default Filters',
    buttonLabelResetExpiredCosts: 'Reset Outdated Costs ({{count}})',
    buttonLabelResetLayoutToDefault: 'Reset to Default Layout',
    buttonLabelResetLayoutToSaved: 'Reset to Saved Layout',
    buttonLabelResetPricing: 'Reset Cost/Price',
    buttonLabelResetVersion: 'Reset Version',
    buttonLabelRestore: 'Restore',
    buttonLabelRetry: 'Retry',
    buttonLabelReturnToQuote: 'Return to {{entityType}}',
    buttonLabelReusePrice: 'Reuse price',
    buttonLabelReviewAccess: 'Review/Add Access',
    buttonLabelRevokeAccess: 'Revoke Access',
    buttonLabelSave: 'Save',
    buttonLabelSaveAndAddNext: 'Save & Add Next',
    buttonLabelSaveAndClose: 'Save & Close',
    buttonLabelSaveAndNew: 'Save & New',
    buttonLabelSaveAndPublish: 'Save and Publish',
    buttonLabelSaveAsDraft: 'Save as Draft',
    buttonLabelSaveAsTemplate: 'Save as Template',
    buttonLabelSaveAttributes: 'Save Attributes',
    buttonLabelSaveChanges: 'Save Changes',
    buttonLabelSaveCustomerQuoteNote: 'Save Customer {{entityType}} Note',
    buttonLabelSaveInternalQuoteNote: 'Save Internal {{entityType}} Note',
    buttonLabelSaveJobs: 'Save Jobs',
    buttonLabelSaveLayout: 'Save Layout',
    buttonLabelSaveQuoteNote: 'Save {{entityType}} Note',
    buttonLabelSaveToDraft: 'Save to Draft',
    buttonLabelSearch: 'Search',
    buttonLabelSeeAllOptions: 'See all {{count}} options →',
    buttonLabelSeeElementTemplate: 'See Element Template',
    buttonLabelSeeErrorMessage: 'See Error Message',
    buttonLabelSeeExternalOrder: 'See External Order',
    buttonLabelSeeJob: 'See Job',
    buttonLabelSeeLess: 'See less',
    buttonLabelSeeQuote: 'See {{entityType}}',
    buttonLabelSelectHeaderRow: 'Select Header Row',
    buttonLabelSelectSpa: 'Select SPA',
    buttonLabelSend: 'Send',
    buttonLabelSendAsSpa: 'Send as SPA',
    buttonLabelSendInvitation: 'Send Invitation',
    buttonLabelSendRelease: 'Send / Release',
    buttonLabelSendToFileNet: 'Send to FileNet',
    buttonLabelSendToVendor: 'Send to Vendor',
    buttonLabelSetTime: 'Set Time',
    buttonLabelSetUpAccount: 'Set Up Account',
    buttonLabelSetupCustomer: 'Setup a Customer',
    buttonLabelSetUpPart: 'Set Up Part',
    buttonLabelShowAllPartNumbers: 'Show All Part Numbers',
    buttonLabelShowPartDetails: 'Show Part Details',
    buttonLabelShowPartNumbersCount_one: 'Show {{count, number}} Part Number',
    buttonLabelShowPartNumbersCount_other: 'Show {{count, number}} Part Numbers',
    buttonLabelShowSelectedLines: 'Show Selected Lines',
    buttonLabelSignIn: 'Sign In',
    buttonLabelSignInWithSso: 'Sign In with SSO',
    buttonLabelSignUp: 'Create Account Now',
    buttonLabelStayOnPage: 'Stay on Page',
    buttonLabelSubmit: 'Submit',
    buttonLabelSubmitInvalidUoms: 'Confirm Invalid UOMs',
    buttonLabelSubmitOrder: 'Submit Order',
    buttonLabelSubmitSupportRequest: 'Submit Request',
    buttonLabelSubmitUnknownManufacturers: 'Confirm Identified Manufacturers',
    buttonLabelSupportRequestEditJobs: 'Edit Jobs',
    buttonLabelSupportRequestProspect: 'Prospect (no customer number)',
    buttonLabelTryAdvancedSearch: 'Try Advanced Search',
    buttonLabelUnblock: 'Unblock',
    buttonLabelUnblockIp: 'Unblock IP',
    buttonLabelUngroup: 'Ungroup',
    buttonLabelUnlock: 'Unlock',
    buttonLabelUnpublish: 'Unpublish',
    buttonLabelUpdate: 'Update',
    buttonLabelUpdateAttributes: 'Update Attributes',
    buttonLabelUpdateCompanyPart: 'Update Company Part',
    buttonLabelUpdateCustomer: 'Update Customer',
    buttonLabelUpdateFile: 'Update File',
    buttonLabelUpdateJob: 'Update Job',
    buttonLabelUpdateJobDetails: 'Update Job Details',
    buttonLabelUpdateLine: 'Update Line',
    buttonLabelUpdateLocation: 'Update Location',
    buttonLabelUpdateLog: 'Update Log Time',
    buttonLabelUpdateOrderLocation: 'Update Sales Location',
    buttonLabelUpdatePart: 'Update Part',
    buttonLabelUpdatePricing: 'Update Pricing',
    buttonLabelUpdateProjectUser: 'Update User',
    buttonLabelUpdateQuote: 'Update Quote',
    buttonLabelUpdateQuoteLocation: 'Update Quoted Location',
    buttonLabelUpdateSupportRequest: 'Update Request',
    buttonLabelUpdateUoms: 'Update UOMs',
    buttonLabelUpdateVendor: 'Update Vendor',
    buttonLabelUpdateVideo: 'Update Video',
    buttonLabelUpload: 'Upload',
    buttonLabelUploadDifferentFile: 'Upload a different file',
    buttonLabelUseAIToCreateBom: 'Use AI to Create BoM',
    buttonLabelUseDefaultSpa: 'Use default SPA',
    buttonLabelUseExistingVendorQuote: 'Use Existing Vendor Quote',
    buttonLabelUseInThisFamily: 'Use in this Family',
    buttonLabelUsePartBom: 'Use This Part BOM',
    buttonLabelUsePartNumber: 'Use This Part Number',
    buttonLabelUseSpa: 'Use SPA',
    buttonLabelUseThisBom: 'Use this BOM',
    buttonLabelUseThisSpa: 'Use this SPA',
    buttonLabelValidate: 'Validate',
    buttonLabelView: 'View',
    buttonLabelViewByElement: 'View By Element',
    buttonLabelViewByPartNumber: 'View By Part Number',
    buttonLabelViewExistingVendorQuote: 'View Existing Vendor Quote',
    buttonLabelViewPreviousPrices: 'View previous prices',
    buttonLabelViewReleaseVersion: 'View Release (Read Only)',
    buttonLabelYearToDate: 'Year to Date',
    buttonUpdateRequirements: 'Update Requirements',

    // Labels
    labelAbandoned: 'Abandoned',
    labelAccept: 'Accept',
    labelAccess: 'Access',
    labelAccessItems: 'Access Items',
    labelAccessType: 'Access Type',
    labelAccountNumber: 'Account #',
    labelAccountNumberLong: 'Account Number',
    labelAccountsPayableId: 'Accounts Payable ID',
    labelAccountsPayableIdShort: 'Accts. Payable ID',
    labelAccountsReceivableId: 'Account #{{number}}',
    labelAcctsReceivableId: 'Accts. Receivable ID',
    labelActive: 'Active',
    labelActivityDate: 'Activity Date',
    labelActivityTime: 'Activity Time',
    labelAddAllAsNewLines: 'Add all as new lines',
    labelAddCompanyPart: 'Add Company Part',
    labelAddContact: 'Add Contact',
    labelAdderMargin: 'Adder Margin',
    labelAdderPrice: 'Adder Price',
    labelAdderPurchaseCost: 'Adder Purchase Cost',
    labelAdderStandardCost: 'Adder Standard Cost',
    labelAddFile: 'Add File',
    labelAddLine: 'Add Line',
    labelAddNewCustomer: 'Add New Customer',
    labelAddOption: 'Add "{{option}}"',
    labelAddRank: 'Add Rank',
    labelAddress: 'Address',
    labelAddressLine1: 'Address Line 1',
    labelAddressLine2: 'Address Line 2',
    labelAddTo: 'Add to',
    labelAddToExistingCompany: 'Add to Existing Company',
    labelAddValue: 'Add Value',
    labelAddVariation: 'Add Variation',
    labelAdminUsers: 'Admin Users',
    labelAdvancedFilter: 'Advanced Filter',
    labelAgreementId: 'Agreement ID',
    labelAgreeTermsAndConditions: 'I agree to the Terms and Conditions',
    labelAll: 'All',
    labelAllCategories: 'All Categories',
    labelAllConfigurators: 'All Configurators',
    labelAllCustomers: 'All Customers',
    labelAllElements: 'All Elements',
    labelAllFileTypes: 'All File Types',
    labelAllLocations: 'All Locations',
    labelAllManufacturers: 'All Manufacturers',
    labelAllParts: 'All Parts',
    labelAllRegions: 'All Regions',
    labelAllSources: 'All Sources',
    labelAllTypes: 'All Types',
    labelAllUsers: 'All Users',
    labelAlternate: 'Alternate',
    labelAlternateSales: 'Alternate Sales',
    labelAlternateSalesUom: 'Alternate Sales UOM',
    labelAlternateUom: 'Alternate UOM',
    labelAlternateVendorId: 'Alternate Vendor ID',
    labelAlternateVendorName: 'Alternate Vendor Name',
    labelAlternateVendorPartNumber: 'SKU',
    labelAlternateVersionType: 'Unified',
    labelAnomalies: 'Anomalies',
    labelAnyLocations: 'Any Locations',
    labelAPNumber: 'AP Number',
    labelApplied: '({{ count }} applied)',
    labelAppliedFilter_one: '{{ count }} filter applied',
    labelAppliedFilter_other: '{{ count }} filters applied',
    labelApply: 'Apply',
    labelApplyBaseAndAdderToLinesWithSameBase: 'Apply Base and Adder to all lines with the same base part number',
    labelApplyDiscountTo: 'Apply Discount To',
    labelApplyGrossProfitMarginTo: 'Apply Gross Profit Margin to',
    labelApplyTo: 'Apply To',
    labelApplyToAllCustomers: 'Apply to All Customers',
    labelApprovedVendors: 'Approved Vendors',
    labelArchived: 'Archived',
    labelARNumber: 'AR Number',
    labelARNumberOnly: 'Only Active Locations',
    labelAssigned: 'Assigned',
    labelAssignedCompany: 'Assigned Company',
    labelAssignedTo: 'Assigned to',
    labelAssociationTypeViaProject: '{{type}} - via project',
    labelAttachAsVendorQuote: 'Attach as Vendor Quote',
    labelAttachedToCostingProfile: 'Costing Profile',
    labelAttachedToJob: 'Job',
    labelAttachedToProject: 'Project',
    labelAttachedToQuote: 'Quote',
    labelAttachPdf: 'Attach PDF',
    labelAttachTo: 'Attach To',
    labelAttachXls: 'Attach XLS',
    labelAttribute: 'Attribute',
    labelAttributeInUse: 'In Use',
    labelAttributeParts: 'Parts',
    labelAttributes: 'Attributes',
    labelAttributesNoLongerUsed: 'No longer used ({{count}})',
    labelAttributesNowUsed: 'Now used ({{count}})',
    labelAttributesRegrouped: 'Groups changed ({{count}})',
    labelAttributesReordered: 'Attributes reordered',
    labelAttributesSelected_one: '1 Attribute selected',
    labelAttributesSelected_other: '{{count}} Attributes selected',
    labelAttributeStatusDraft: 'Draft',
    labelAttributeStatusModified: 'Modified',
    labelAttributeStatusPublished: 'Published',
    labelAttributeStatusUnpublished: 'Unpublished',
    labelAttributeStatusUnpublishedModified: 'Unpublished (Modified)',
    labelAttributeStatusVersion: '{{status}} • v{{number}}',
    labelAttributeTypeColour: 'Color',
    labelAttributeTypeNumberRange: 'Number & Range',
    labelAttributeTypeValues: 'Values',
    labelAttributeValueNew: 'New',
    labelAuthorAndTime: '{{author}} · {{time}}',
    labelAutoLeadTimeEnabled: 'Auto Leadtime',
    labelAutomatedPricing: 'Auto Pricing',
    labelAvailableEmailDomains: 'Available Email Domains',
    labelAverageDailyCases: 'Average Daily Cases',
    labelAvgTimeToResult: 'Avg Time to Result',
    labelBackToMainMenu: 'Back to Main Menu',
    labelBase: 'Base',
    labelBaseCode: 'Base Code',
    labelBaseDiscount: 'Base Discount',
    labelBaseDiscountWithValue: '-{{value}} Base Discount',
    labelBasedOnCost: 'based on {{cost}}',
    labelBaseInformation: 'Base Information',
    labelBaseMargin: 'Base Margin',
    labelBaseMarginWithValue: '+{{value}} Base Margin',
    labelBasePrice: 'Base Price',
    labelBasePurchaseCost: 'Base Purchase Cost',
    labelBaseStandardCost: 'Base Standard Cost',
    labelBaseUom: 'Base UOM',
    labelBeginsWith: 'Begins With',
    labelBellNotificationError: 'Error',
    labelBellNotificationExternalOrder: 'External order',
    labelBellNotificationExternalStatusChangedTo: 'to',
    labelBellNotificationPurchaseOrder: 'PO',
    labelBillTo: 'Bill To',
    labelBillToCustomer: 'Bill To Customer',
    labelBillToLocation: 'Bill To Location',
    labelBlockUser: 'Block User',
    labelBlockUserIp: 'Block User IP',
    labelBomImports: 'Imported bill of materials',
    labelBomPriceDecimals: 'BoM Price Decimals',
    labelBomTotal: 'BoM Total',
    labelBrowse: 'Browse',
    labelBulkSendAsSpaFirstSends_one: '{{count}} sent for the first time',
    labelBulkSendAsSpaFirstSends_other: '{{count}} sent for the first time',
    labelBulkSendAsSpaResends_one: '{{count}} update of an agreement sent before',
    labelBulkSendAsSpaResends_other: '{{count}} updates of an agreement sent before',
    labelBulkSendAsSpaStatusCount: '{{count}} as {{status}}',
    labelBy: 'By',
    labelCache_apcu_acl: 'Permissions (ACL)',
    labelCache_apcu_category: 'Category data',
    labelCache_file_table_metadata: 'Database table metadata',
    labelCache_integration_inventory: 'Inventory',
    labelCache_integration_part_search: 'Part search',
    labelCache_integration_pricing: 'Pricing',
    labelCache_integration_sales_order_history: 'Sales order history',
    labelCache_redis_access_token: 'API access tokens',
    labelCache_redis_bom_boms_by_part: 'BOM report — BOMs by part',
    labelCache_redis_bom_lines_by_part: 'BOM report — lines by part',
    labelCache_redis_bom_summary: 'BOM report — summary',
    labelCache_redis_manufacturer: 'Manufacturers',
    labelCache_redis_part_availability: 'Part availability',
    labelCache_redis_quote_dashboard: 'Quote dashboard',
    labelCache_redis_shipment_type: 'Shipment types',
    labelCacheExpiry: 'Expires',
    labelCacheImpact_high: 'High impact',
    labelCacheImpact_low: 'Low impact',
    labelCacheImpact_medium: 'Medium impact',
    labelCalculated: 'Calculated',
    labelCalculatedFamily: 'CALCULATED - FAMILY',
    labelCalculatedFloorPrice: 'Calculated Floor Price',
    labelCalculatedListPrice: 'Calculated List Price',
    labelCalculatedStandardCost: 'Calculated standard cost',
    labelCancelSelectedJobs_one: 'Cancel 1 job',
    labelCancelSelectedJobs_other: 'Cancel {{count}} jobs',
    labelCaseLastMonth: 'Case Last Month',
    labelCases: 'Cases',
    labelCasesByEngineer: 'Cases by Engineer',
    labelCasesByPart: 'Cases by Part',
    labelCasesByTheater: 'Cases by Theater',
    labelCasesYesterday: 'Cases Yesterday',
    labelCategories: 'Categories',
    labelCategory: 'Category',
    labelChangeAssignedCompany: 'Change Assigned Company',
    labelChooseElement: 'Choose Element',
    labelCity: 'City',
    labelClass: 'Class',
    labelClassName: 'Class Name',
    labelClearAllNotificationsConfirm: 'Clear all notifications?',
    labelClickToSeeInventory: 'Click to see the inventory',
    labelCloseConfidence: 'Close Confidence',
    labelCloseDate: 'Close Date',
    labelColorName: 'Color name',
    labelColors: 'Colors',
    labelColumns: 'Columns',
    labelCombineDuplicateRows: 'Combine duplicate rows in this file',
    labelCompanies: 'Companies',
    labelCompany: 'Company',
    labelCompanyConfigurators: 'Company Configurators',
    labelCompanyElements: 'Company Elements',
    labelCompanyId: '#{{id}}',
    labelCompanyIdWithName: '{{name}} (#{{id}})',
    labelCompanyManufacturerId: 'Company Manufacturer ID',
    labelCompanyManufacturerName: 'Company Manufacturer Name',
    labelCompanyName: 'Company Name',
    labelCompanyPartNumber: 'Company Part Number',
    labelCompanyParts: 'Company Parts',
    labelCompanyPartSpecificationCriteria: 'Company Part Specification Criteria',
    labelCompanyPartStatus: 'Company Part Status',
    labelCompanyPurchaseCostWithValue: 'Company Purchase Cost: {{value}}',
    labelCompanySettings: 'Company Settings',
    labelCompanyStandardCostWithValue: 'Company Standard Cost: {{value}} ({{spread}})',
    labelCompareVolumes: 'Compare Volumes',
    labelCompetitors: 'Competitors',
    labelCompletedDate: 'Completed Date',
    labelComponent: 'Component',
    labelConfidence: 'Confidence',
    labelConfirmPassword: 'Confirm Password',
    labelConsumerHealth: '{{count}} of {{expected}} consumers running',
    labelConsumerJobCount: '{{count}} pending jobs',
    labelConsumerJobStatus_queued: 'Queued',
    labelConsumerJobStatus_running: 'Running',
    labelContact: 'Contact',
    labelContactEmail: 'Contact Email',
    labelContactGroupAutoLeadTimeEnabled: 'Auto Leadtime',
    labelContactGroupAutomatedPricing: 'Auto Pricing',
    labelContactGroupDiscount: 'Discount',
    labelContactGroupDomains: 'Domains',
    labelContactGroupDomainsEmpty: 'No domains available',
    labelContactGroupFreightEnabled: 'Freight',
    labelContactGrouping: 'Contact Grouping',
    labelContactGroupIsCustomer: 'Customer',
    labelContactGroupIsVendor: 'Vendor',
    labelContactGroupMargin: 'Margin',
    labelContactGroupMarginDiscount: 'Margin / Discount',
    labelContactGroupName: 'Company Name',
    labelContactGroups: 'Companies',
    labelContactGroupShowInventory: 'Inventory Visibility',
    labelContactName: 'Contact Name',
    labelContactPhone: 'Contact Phone',
    labelContacts: 'Contacts',
    labelContains: 'Contains',
    labelConvertToFamilySpecific: 'Convert to family-specific',
    labelConvertToFamilySpecificHint: 'Keeps current values, no longer synced with Product Type',
    labelCopy: 'Copy',
    labelCopyShipToFromQuote: 'Copy Ship To from quote',
    labelCorporateLocation: 'Shipping Location',
    labelCost: 'Cost',
    labelCostDiscount: 'Cost Discount',
    labelCosting: 'Costing',
    labelCostingCalculation: 'Costing Calculation',
    labelCostingCalculations: 'Costing Calculations',
    labelCostingProfileRemoved: 'costing profile removed',
    labelCostingProfiles: 'Costing Profiles',
    labelCostItems: 'Cost Items',
    labelCostNotes: 'Cost Notes',
    labelCostPrice: 'Cost/Price',
    labelCostQuantities: 'Cost Quantities',
    labelCosts: 'Costs',
    labelCostSource: 'Cost Source',
    labelCostSourceTypeCorporateLong: 'company parts',
    labelCostSourceTypeCorporateLongQtyDiscounts: 'quantity discount',
    labelCostSourceTypeCorporateShort: 'CP',
    labelCostSourceTypeCorporateShortQtyDiscounts: 'QD',
    labelCostSourceTypeCustomerCorporateLong: 'vendor quote',
    labelCostSourceTypeCustomerCorporateShort: 'VD',
    labelCostSourceTypeCustomerQuoteLong: 'this quote',
    labelCostSourceTypeCustomerQuoteShort: 'CQ',
    labelCostSourceTypeCustomLong: 'manually entered',
    labelCostSourceTypeCustomShort: 'ME',
    labelCostSourceTypeDefaultLong: 'costing profile',
    labelCostSourceTypeDefaultShort: 'PC',
    labelCostSourceTypeExternalLong: 'external',
    labelCostSourceTypeExternalShort: 'EXT',
    labelCostSourceTypeFamilyLong: 'configurator',
    labelCostSourceTypeFamilyShort: 'PB',
    labelCostSourceTypeProjectLong: 'project profile',
    labelCostSourceTypeProjectShort: 'PP',
    labelCostSourceTypeSelectedSpaLong: 'selected SPA',
    labelCostSourceTypeSelectedSpaShort: 'SPA',
    labelCostSourceTypeVendorLong: 'vendor quote',
    labelCostSourceTypeVendorShort: 'VQ',
    labelCostUom: 'Cost UOM',
    labelCostWithCurrency: 'Cost ($)',
    labelCountry: 'Country',
    labelCreateAccount: 'Create Account',
    labelCreateAttributeName: 'Create “{{name}}”',
    labelCreateBuyer: 'Buyer Internal',
    labelCreateBuyerNote: 'Buyer Internal Note',
    labelCreated: 'Created',
    labelCreatedAt: 'Created At',
    labelCreatedByUser: 'Created By',
    labelCreatedByUserEmployeeId: 'Created By User - Employee ID',
    labelCreatedByUserLocation: 'Created By User - Location',
    labelCreatedDate: 'Created Date',
    labelCreateDefault: 'Note',
    labelCreateDefaultNote: 'Note',
    labelCreateElementNote: 'Element Note',
    labelCreateInternal: 'Internal',
    labelCreateInternalNote: 'Internal Note',
    labelCreateJob: 'Create Job',
    labelCreateLeadTime: 'Lead Time',
    labelCreateLeadTimeNote: 'Lead Time Note',
    labelCreateLocation: 'Create Location',
    labelCreateNewCompany: 'Create New Company',
    labelCreateNewPricingProfile: 'Create New Pricing Profile',
    labelCreateNote: 'Create Note',
    labelCreatePartCost: 'Create Part Cost',
    labelCreatePartPrice: 'Create Part Price',
    labelCreatePicker: 'Whse - Internal Packer Line',
    labelCreatePickerNote: 'Whse - Internal Packer Line Note',
    labelCreateProject: 'Create Project',
    labelCreateRank: 'Create Rank',
    labelCreateSupship: 'Supplier PO Shipping',
    labelCreateSupshipNote: 'Supplier PO Shipping Note',
    labelCreateUndiscardableItemNote: 'This item is non-cancelable and non-returnable',
    labelCreateUndiscardableItemNoteStrong: '<strong>This item is non-cancelable and non-returnable</strong>',
    labelCreateUomConversion: 'Create UOM Conversion',
    labelCurrentDate: 'Current Date',
    labelCurrentInventory: 'Current Inventory',
    labelCurrentQty: 'Current Qty',
    labelCurrentYear: 'Current year',
    labelCurrentYearCases: 'Current Year Cases',
    labelCurrentYearLines: 'Current Year Lines',
    labelCustom: 'Custom',
    labelCustomCustomers: 'Custom Customers',
    labelCustomer: 'Customer',
    labelCustomerAccountNumber: 'Customer Account Number',
    labelCustomerBillTo: 'Customer Bill To',
    labelCustomerCompany: 'Customer Company',
    labelCustomerCompanyName: 'Customer Company Name',
    labelCustomerContact: 'Customer Contact',
    labelCustomerContacts: 'Customers',
    labelCustomerCost: 'Customer Cost',
    labelCustomerEditAllowed: 'Edit Customers',
    labelCustomerEmail: 'Customer Email',
    labelCustomerEntity: 'Customer {{entityType}}',
    labelCustomerFirstName: 'Customer First Name',
    labelCustomerLastName: 'Customer Last Name',
    labelCustomerName: 'Customer Name',
    labelCustomerNumber: 'Customer Number',
    labelCustomerNumberType: 'Customer Number Type',
    labelCustomerOrders: 'Customer Orders',
    labelCustomerQuote: 'Customer Quote',
    labelCustomerQuoteCustomer: 'Contact',
    labelCustomerQuoteNumberShort: 'Customer {{entityType}} #',
    labelCustomerQuotes: 'Customer Quotes',
    labelCustomerQuotesAndOrders: 'Customer Quotes and Orders',
    labelCustomers: 'Customers',
    labelCustomerWithValue: 'Customer: {{value}}',
    labelCustomIdentifier: 'Identifier',
    labelCustomLocations: 'Custom Locations',
    labelCustomMargin: 'Custom Margin',
    labelCustomRegions: 'Custom Regions',
    labelCustomUsers: 'Custom Users',
    labelDashboard: 'Dashboard',
    labelDatasheet: 'Datasheet',
    labelDatasheetDefaultFileName: 'Datasheet-{{part}}',
    labelDate: 'Date',
    labelDateFrom: 'From',
    labelDateTo: 'To',
    labelDayCount_one: '{{count}} day',
    labelDayCount_other: '{{count}} days',
    labelDayToDay: 'Day to Day',
    labelDeactivated: 'Deactivated',
    labelDefault: 'Default',
    labelDefaultAddress: 'Default Address',
    labelDefaultBillTo: 'Default Bill To',
    labelDefaultDatasheet: 'Default Datasheet',
    labelDefaultFilter: 'Use this Filter Set by Default',
    labelDefaultImage: 'Default Image',
    labelDefaultPricing: 'Default Pricing',
    labelDefaultPricingDate: 'Default Pricing Date',
    labelDefaultPricingStrategy: 'Default Pricing Strategy',
    labelDefaultShippingLocation: 'Default Shipping Location',
    labelDefaultShipTo: 'Default Ship To',
    labelDefaultSoldTo: 'Default Sold To',
    labelDeleted: 'Deleted',
    labelDeleteTheseAttributes: 'Delete these attributes',
    labelDeleteTheseAttributesHint: 'Values will be lost',
    labelDeprecated: 'Deprecated',
    labelDescription: 'Description',
    labelDetails: 'Details',
    labelDevEnvironments: 'Dev environments',
    labelDisabled: 'Disabled',
    labelDiscipline: 'Discipline',
    labelDisciplineName: 'Discipline Name',
    labelDisciplines: 'Disciplines',
    labelDisciplineSP: 'Discipline(s)',
    labelDiscount: 'Discount',
    labelDiscountItemsOnly: 'Discount items only',
    labelDiscountTypeBaseCodeLong: 'base code price',
    labelDiscountTypeBaseCodeShort: 'BC',
    labelDiscountTypeBaseCodeVendorQuotePartLong: 'base code price',
    labelDiscountTypeBaseCodeVendorQuotePartShort: 'BC',
    labelDiscountTypeCurrentQuotePartDiscountOffListPriceLong: 'this quote part specific discount off list price',
    labelDiscountTypeCurrentQuotePartDiscountOffListPriceShort: 'JL',
    labelDiscountTypeCurrentQuotePartDiscountOffStdCostLong: 'this quote part specific discount off standard cost',
    labelDiscountTypeCurrentQuotePartDiscountOffStdCostShort: 'JS',
    labelDiscountTypeCurrentQuotePricingGroupDiscountOffListPriceLong: 'this quote pricing group discount off list price',
    labelDiscountTypeCurrentQuotePricingGroupDiscountOffListPriceShort: 'HL',
    labelDiscountTypeCurrentQuotePricingGroupDiscountOffStdCostLong: 'this quote pricing group discount off standard cost',
    labelDiscountTypeCurrentQuotePricingGroupDiscountOffStdCostShort: 'HS',
    labelDiscountTypeDiscountOffListPriceLong: 'discount off list price',
    labelDiscountTypeDiscountOffListPriceShort: 'DL',
    labelDiscountTypeDiscountOffStdCostLong: 'discount off standard cost',
    labelDiscountTypeDiscountOffStdCostShort: 'DS',
    labelDiscountTypeFixedCostLong: 'fixed cost',
    labelDiscountTypeFixedCostShort: 'FC',
    labelDiscountTypeVendorQuotePartDiscountOffListPriceLong: 'vendor quote part specific discount off list price',
    labelDiscountTypeVendorQuotePartDiscountOffListPriceShort: 'PL',
    labelDiscountTypeVendorQuotePartDiscountOffStdCostLong: 'vendor quote part specific discount off standard cost',
    labelDiscountTypeVendorQuotePartDiscountOffStdCostShort: 'PS',
    labelDiscountTypeVendorQuotePartLong: 'vendor quote part price',
    labelDiscountTypeVendorQuotePartShort: 'PN',
    labelDiscountTypeVendorQuotePricingGroupDiscountOffListPriceLong: 'vendor quote pricing group discount off list price',
    labelDiscountTypeVendorQuotePricingGroupDiscountOffListPriceShort: 'GL',
    labelDiscountTypeVendorQuotePricingGroupDiscountOffStdCostLong: 'vendor quote pricing group discount off standard cost',
    labelDiscountTypeVendorQuotePricingGroupDiscountOffStdCostShort: 'GS',
    labelDistinctCustomers: 'Distinct Customers',
    labelDocument: 'Document',
    labelDocuments: 'Documents',
    labelDomains: 'Domains',
    labelDone: 'Done',
    labelDoublePersist: 'Double persist',
    labelDownload: 'Download',
    labelDownloaded: 'Downloaded',
    labelDueDate: 'Due Date',
    labelDurationHours: 'Time (hrs)',
    labelDurationMinutesSeconds: '{{minutes}}m {{seconds}}s',
    labelDurationMs: '{{milliseconds}} ms',
    labelDurationSeconds: '{{seconds}}s',
    labelEarliestAcceptableDate: 'Earliest Acceptable Date',
    labelEditNote: 'Edit Note',
    labelEditRank: 'Edit Rank',
    labelElement: 'Element',
    labelElementLine: 'Element Line',
    labelElementName: 'Element Name',
    labelElementNote: 'Element Note',
    labelElements: 'Elements',
    labelElementTemplate: 'Element Template',
    labelElementTemplates: 'Element Templates',
    labelEmail: 'Email',
    labelEmailAddress: 'Email Address',
    labelEmailDomains: 'Email Domains',
    labelEmailTemplates: 'Email Templates',
    labelEmployeeId: 'Employee ID',
    labelEmpty: 'Blanks',
    labelEmptyDiscipline: 'No Discipline',
    labelEmptyQuotePartsMessage: 'There is nothing here yet, to get started you need to add a Line or Import Bill of Materials',
    labelEnabled: 'Enabled',
    labelEnabledForSelectedSpa: 'Enabled for Selected SPA',
    labelEndActivePartCost: 'End Active Cost',
    labelEndActivePartPrice: 'End Active Price',
    labelEndDate: 'End Date',
    labelEngineeringNumber: 'Engineering Number',
    labelEnteredCost: 'Entered Cost',
    labelEntryCount_one: '{{count}} entry',
    labelEntryCount_other: '{{count}} entries',
    labelEnvironment: 'Environment',
    labelEquals: 'Equals',
    labelErrorMessage: 'Error Message',
    labelEstimatedCloseDate: 'Estimated Close Date',
    labelEstimatedValue: 'Estimated Value',
    labelExcludeManuallyEntered: 'Exclude Manually Entered',
    labelExcludeManuallyEnteredAndSelectedSpa: 'Exclude Manually Entered and Selected SPA',
    labelExistingPartBomChoice: 'Copy from existing Part BoM',
    labelExists: 'Exists',
    labelExpires: 'Expires',
    labelExternalCostLocked: 'Locked by Contract',
    labelExternalCostShort: 'Ext Cost',
    labelExternalCustomerNumber: '{{customerNumber}} - {{prefix}} Customer Number',
    labelExternalCustomers: 'Ext Customers',
    labelExternalErp: 'External/ERP',
    labelExternalErpUom: 'External/ERP UOM',
    labelExternalLocationCountry: 'Location Country',
    labelExternalLocationId: 'External Location ID',
    labelExternalOrderErrorMessage: 'External Order Error Message',
    labelExternalOrderNumber: 'External Order Number',
    labelExternalOrderStatusCancelled: 'Cancelled',
    labelExternalOrderStatusClosed: 'Closed',
    labelExternalOrderStatusDraft: 'Draft',
    labelExternalOrderStatusOpen: 'Open',
    labelExternalOrderStatusSubmitted: 'Submitted',
    labelExternalPartNumber: 'External Part Number',
    labelExternalParts: 'External Parts',
    labelExternalPendingOrderNumber: 'External Pending Order Number',
    labelExternalPrice: 'External price',
    labelExternalPriceLocked: 'Locked',
    labelExternalProgramName: 'External Program Name',
    labelExternalProgramNameShort: 'Ext. Program Name',
    labelExternalProgramNumber: 'External Program #',
    labelExternalProgramNumberShort: 'Ext. Program #',
    labelExternalProjectApprovedFundingAmountShort: 'Ext. Approved Funding',
    labelExternalProjectConsumedFundingAmountShort: 'Ext. Consumed Funding',
    labelExternalProjectName: 'External Project Name',
    labelExternalProjectNameShort: 'Ext. Project Name',
    labelExternalProjectNumber: 'External Project #',
    labelExternalProjectNumberShort: 'Ext. Project #',
    labelExternalProjectRecordTypeShort: 'Ext. Type',
    labelExternalProjectRequestedFundingAmountShort: 'Ext. Requested Funding',
    labelExternalSellPriceEndDate: 'Sell Price End Date',
    labelExternalSellPriceSource: 'Sell Price Source',
    labelExternalSellPriceSourceName: 'Sell Price Source Name',
    labelExternalSource: 'External Source',
    labelExternalSpaCost: 'SPA Purchase Cost',
    labelExternalSpaCostEndDate: 'SPA Cost End Date',
    labelExternalSpaCostEndDateShort: 'End Date',
    labelExternalSpaCostRegistrationNum: 'SPA Cost Reg Number',
    labelExternalSpaCostRegistrationNumShort: 'Reg Number',
    labelExternalSpaCostShort: 'SPA Purchase Cost',
    labelExternalSpaCostSource: 'SPA Cost Source',
    labelExternalSpaCostSourceName: 'SPA Cost Source Name',
    labelExternalSpaCostSourceNameShort: 'Source Name',
    labelExternalSpaCostSourceShort: 'Source',
    labelExternalStatus: 'External Status',
    labelExternalUom: 'External UOM',
    labelExternalUserId: 'External User ID',
    labelExternalVendorId: 'External Vendor ID',
    labelExternalVendorName: 'External Vendor Name',
    labelExtractorId: 'Extractor ID',
    // The grid footer builds `label${entityType}s` off the table's entityType.
    labelExtractorVendorMappings: 'Mappings',
    labelFailed: 'Failed',
    labelFailureReasonWithCount: '{{count}} \u00d7 {{message}}',
    labelFamilies: 'Families',
    labelFamilyAttributes: 'Family attributes',
    labelFamilyCost: 'Family Cost',
    labelFamilyParts: 'Parts',
    labelFamilys: 'Families',
    labelFamilySpecificAttributes: 'Family-specific attributes',
    labelFamilySpecificAttributesHint: 'Attributes unique to this Family, in addition to those inherited from its Product Type.',
    labelFieldsWithValue_one: '{{ count }} field',
    labelFieldsWithValue_other: '{{ count }} fields',
    labelFiltered: 'Filtered',
    labelFilters: 'Filters',
    labelFindQuote: 'Find {{entityType}}',
    labelFirstName: 'First Name',
    labelFixed: 'Fixed',
    labelFixedFreightPrice: 'Fixed Freight Price',
    labelFixedPrice: 'Fixed Price',
    labelFloorPrice: 'Floor Price',
    labelFonts: 'Fonts',
    labelForgotPassword: 'Recover Password',
    labelFormatting: 'Formatting',
    labelFreight: 'Freight',
    labelFreightCost: 'Freight Cost',
    labelFreightEnabled: 'Freight',
    labelFreightMargin: 'Freight Margin',
    labelFreightNote: 'Freight Note',
    labelFreightPercentage: 'Freight Percentage',
    labelFreightPrepaidAndCharge: 'Prepaid & Charge',
    labelFreightPrice: 'Freight Price',
    labelFreightSpread: 'Included',
    labelFreightTerm: 'Freight Term',
    labelFreightType: 'Freight Type',
    labelGeneralSettings: 'General Settings',
    labelGoToImageNumber: 'Go to image {{number}}',
    labelGreaterThan: 'Greater Than',
    labelGreaterThanOrEqual: 'Greater Than or Equal',
    labelGrossProfitMargin: 'Gross Profit Margin',
    labelGroup: 'Group',
    labelGroupBy: 'Group By',
    labelGroupName: 'Group Name',
    labelGuardsBypassed_one: 'Guards bypassed ({{count}} row)',
    labelGuardsBypassed_other: 'Guards bypassed ({{count}} rows)',
    labelGuidedSearch: 'Guided Search',
    labelHistory: 'History',
    labelHome: 'Home',
    labelHomeOld: 'Home (Old)',
    labelHrs: 'hrs',
    labelIgnoreEmptyQuantities: 'Ignore Empty Quantities',
    labelImage: 'Image',
    labelImages: 'Images',
    labelImpersonate: 'Impersonate',
    labelImportedVendorQuotes: 'Imported Vendor Quotes',
    labelImportExport: 'Import / Export',
    labelImportLogTrace: 'Log trace',
    labelImportNotPersisted: 'Import not persisted',
    labelInactive: 'Inactive',
    labelIncrement: 'Increment',
    labelIncrementValue: '(Increment {{increment}})',
    labelIncrWithValue: '<contentWrapper>INCR: <valueWrapper>{{value}}</valueWrapper></contentWrapper>',
    labelInfo: 'Info',
    labelInformation: 'Information',
    labelInheritedAttributes: 'Inherited attributes',
    labelInheritedAttributesCannotBeRemoved: 'Inherited attributes cannot be removed',
    labelInProgress: 'In Progress',
    labelInStock: 'In stock',
    labelIntegrations: 'Integrations',
    labelInUse: 'In use',
    labelInventory: 'Inventory',
    labelInventoryFieldMapping: 'Inventory Field Mapping',
    labelInventoryItems: 'Locations with Inventory',
    labelInventoryLog: 'Inventory Log',
    labelInventoryMyLocation: 'Inventory My Location',
    labelInventoryStatusAvailable: 'In Stock',
    labelInventoryStatusCompanyAvailable: 'Available',
    labelInventoryStatusInsufficient: 'Insufficient',
    labelIsCustomer: 'Customer',
    labelIsrEmployee: 'ISR',
    labelIsVendor: 'Vendor',
    labelItemsToCopy: 'Items to Copy',
    labelJob: 'Job',
    labelJobAttachments: 'Job Attachments',
    labelJobDescription: 'Job Description',
    labelJobDetails: 'Job Details',
    labelJobExportFieldMapping: 'Job Export Field Mapping',
    labelJobId: 'Job #',
    labelJobName: 'Job Name',
    labelJobNumber: 'Job #',
    labelJobOwnerUser: 'Owner',
    labelJobPartList: 'Materials',
    labelJobPriceDecimals: 'BOM Price Decimals',
    labelJobs: 'Jobs',
    labelJobStatus: 'Job Status',
    labelJobStatusSP: 'Job Status(es)',
    labelLaborRates: 'Labor Rates',
    labelLastName: 'Last Name',
    labelLastUpdate: 'Last Update: {{date}}',
    labelLastUpdated: 'Last Updated',
    labelLatestPrice: 'Latest Price',
    labelLeadTime: 'Lead Time',
    labelLegacyVendorNumbers: 'Legacy Vendor Numbers',
    labelLegacyVersionType: 'Classic',
    labelLessThan: 'Less Than',
    labelLessThanOrEqual: 'Less Than or Equal',
    labelLineNotes: 'Line Notes',
    labelLineNumber: 'Line Number',
    labelLines: 'Lines',
    labelLinesByPart: 'Lines by Part',
    labelLineStatus: 'Line Status',
    labelLineTypeBaseCode: 'Base Code',
    labelLineTypeConfigured: 'Configured',
    labelLineTypeDiscountCode: 'Discount Code',
    labelLineTypeUnverified: 'Unverified',
    labelLineTypeVerified: 'Verified',
    labelLineTypeWildcard: 'Wildcard',
    labelListPrice: 'List Price',
    labelLocation: 'Location',
    labelLocationId: 'Location ID',
    labelLocationName: 'Location Name',
    labelLocations: 'Locations',
    labelLocked: 'Locked',
    labelLocks: 'Locks',
    labelLogList: 'Time Logs',
    labelLogos: 'Logos',
    labelLowestCost: 'Lowest Cost',
    labelMainDetails: 'Main Details',
    labelMakeAsDefault: 'Make as Default',
    labelMakeVendorDefault: 'Make Vendor as Default',
    labelManageCache: 'Manage Cache',
    labelManageConsumers: 'Manage Consumers',
    labelManual: 'Manual',
    labelManualFloorPrice: 'Manual Floor Price',
    labelManualListPrice: 'Manual List Price',
    labelManuallyEnteredPrice: 'Manually entered price',
    labelManuallyUploaded: 'Manually uploaded',
    labelManufacturer: 'Manufacturer',
    labelManufacturerAliases: 'Manufacturer Aliases',
    labelManufacturerPartStatus: 'Manufacturer Part Status',
    labelManufacturers: 'Manufacturers',
    labelManufacturerStatus: 'Manufacturer Status',
    labelMargin: 'Margin',
    labelMarginOnFreight: 'Margin on Freight',
    labelMarginRange: 'Margin Range',
    labelMarginWithValue: 'Margin: {{value}}',
    labelMax: 'Max',
    labelMaxQty: 'Max QTY',
    labelMedia: 'Media',
    labelMergeContactGroup: 'Merge Company Name',
    labelMergeDuplicates: 'Merge Duplicates',
    labelMergeNotes: 'Merge Notes',
    labelMessage: 'Message',
    labelMessages: 'Messages',
    labelMetadata: 'Metadata',
    labelMfgPartStatus: 'Mfg Part Status',
    labelMin: 'Min',
    labelMinQty: 'Min QTY',
    labelMissing: 'Missing',
    labelMobilePhoneNumber: 'Mobile Phone Number',
    labelMOQ: 'MOQ',
    labelMoqWithValue: '<contentWrapper>MOQ: <valueWrapper>{{value}}</valueWrapper></contentWrapper>',
    labelMore: '+ more',
    labelMoreActions: 'More actions',
    labelMoreBillToCustomerLocations_one: '+ {{ count }} more bill to customer location',
    labelMoreBillToCustomerLocations_other: '+ {{ count }} more bill to customer locations',
    labelMoreBillToCustomers_one: '+ {{ count }} more bill to customer',
    labelMoreBillToCustomers_other: '+ {{ count }} more bill to customers',
    labelMoreCategories_one: '+ {{ count }} more category',
    labelMoreCategories_other: '+ {{ count }} more categories',
    labelMoreCount: '+ {{ count }} more',
    labelMoreCountTyped: '+ {{ count }} more {{ type }}',
    labelMoreCustomerLocations_one: '+ {{ count }} more customer location',
    labelMoreCustomerLocations_other: '+ {{ count }} more customer locations',
    labelMoreCustomers_one: '+ {{ count }} more customer',
    labelMoreCustomers_other: '+ {{ count }} more customers',
    labelMoreInfo: 'More info',
    labelMostRecent: 'Most Recent',
    labelMultiplier: 'Multiplier',
    labelMyJobs: 'My Jobs',
    labelMyLocation: 'My Location',
    labelMyProfile: 'My Profile',
    labelName: 'Name',
    labelNameValueList: 'Name Value List',
    labelNewPartBomChoice: 'Create from scratch',
    labelNewQty: 'New Qty',
    labelNewVersion: 'New Version',
    labelNo: 'No',
    labelNoBaseUom: 'No Base UOM',
    labelNoChanges: 'No changes',
    labelNoCorporatePart: 'No Corporate Part',
    labelNoDefaultPricingSet: 'No default pricing set',
    labelNoErrorMessage: 'No error message',
    labelNoExtractedUom: 'No Extracted UOM',
    labelNoFiltersSavedForThisTable: 'There are no filter sets saved for this table. Create one using the current filters to get started.',
    labelNoImportLogEntries: 'No log entries were recorded for this import on this instance.',
    labelNoImportProblems_one: 'No problems in this range — the one upload imported cleanly. Clear "Problems only" above to see it.',
    labelNoImportProblems_other: 'No problems in this range — all {{count}} uploads imported cleanly. Clear "Problems only" above to see them.',
    labelNoLongerUsesList: 'No longer uses the “{{name}}” list',
    labelNoManufacturerReceived: 'No manufacturer received',
    labelNonEmpty: 'Not blank',
    labelNonEmptyDiscipline: 'Has Discipline',
    labelNoPartsImported: 'Nothing imported',
    labelNoPrice: 'No Price',
    labelNoPriceAvailable: 'No price available',
    labelNoPublishedVersions: 'No published versions yet',
    labelNoQuote: 'No Quote',
    labelNoResponse: 'No Response',
    labelNoResults: 'No Results',
    labelNoSpecificDates: 'No Specific Dates',
    labelNoStatus: 'No Status',
    labelNotAssigned: 'Not Assigned',
    labelNote: 'Note',
    labelNoteContent: 'Note Content',
    labelNotEquals: 'Not Equals',
    labelNotes: 'Notes',
    labelNoteTypeBuyer: 'Buyer',
    labelNoteTypeDefault: 'Default',
    labelNoteTypeLeadTime: 'Lead Time',
    labelNoteTypePicker: 'Picker',
    labelNoteTypeSupship: 'Supplier PO Shipping',
    labelNoteTypeUndiscardableItem: 'Undiscardable Item',
    labelNotFound: 'Not Found',
    labelNotificationExternalStatusIs: 'External status is',
    labelNotifications: 'Notifications',
    labelNotificationsEmpty: 'You\u2019re all caught up',
    labelNotificationsLoadFailed: 'Notifications could not be loaded.',
    labelNotInUse: 'Not in use',
    labelNotPublishedYet: 'Not published yet',
    labelNotReady: 'Not Ready',
    labelNotSentToFileNet: 'Not Sent',
    labelNotValid: 'Not Valid',
    labelNowUsesList: 'Now uses the “{{name}}” list',
    labelOfficePhoneNumber: 'Office Phone Number',
    labelOldVersion: 'Old Version',
    labelOmitted: 'Omitted',
    labelOperation: 'Operation',
    labelOr: 'or',
    labelOrder: 'Order',
    labelOrderIncrement: 'Order Increment',
    labelOrderingNumber: 'Ordering Number',
    labelOrderLocation: 'Sales Location',
    labelOrderParts: 'Order Parts',
    labelOrders: 'Orders',
    labelOrderStepAwaitingResponse: 'Awaiting response',
    labelOrderStepOrderCreated: 'Order Created',
    labelOrderStepOrderFailed: 'Order Failed',
    labelOrderStepOrdering: 'Ordering',
    labelOrderType: 'Order Type',
    labelOrderTypeBillable: 'Billable',
    labelOrderTypeBillAndHold: 'Bill and Hold',
    labelOrderTypeHoldForRelease: 'Hold For Release',
    labelOrderTypeSampleOrder: 'Sample Order',
    labelOrderValue: 'Order Value',
    labelOsrEmployee: 'OSR',
    labelOther: 'Other',
    labelOverrideNote: 'Override Note',
    labelOverwritePurchaseCost: 'Overwrite Purchase Cost',
    labelOverwriteQuoteCost: 'Overwrite Quoted Cost',
    labelOverwriteReplacementCost: 'Overwrite Replacement Cost',
    labelOwner: 'Owner',
    labelOwnerWithValue: 'Owner: {{value}}',
    labelPackage: 'Package',
    labelPackageQuantity: 'Package Quantity',
    labelPackageType: 'Package Type',
    labelPackageUom: 'Package UOM',
    labelPackWithValue: '<contentWrapper>Pack: <valueWrapper>{{value}}</valueWrapper></contentWrapper>',
    labelPart: 'Part #',
    labelPartBaseCode: 'Part Base Code',
    labelPartBom: 'Part BoM',
    labelPartBomCreateType: 'Create from scratch or copy existing',
    labelPartBomDescription: 'Description',
    labelPartBomItemList: 'Materials',
    labelPartBomNoParts: 'No Parts',
    labelPartBomNumber: 'Part BoM Number',
    labelPartBomPartDetails: 'Part Details',
    labelPartBomParts: 'Parts',
    labelPartBomQuantity: 'Quantity',
    labelPartBomType: 'Part BoM Type',
    labelPartBomUom: 'UOM',
    labelPartDetails: 'Part Details',
    labelPartDiscountApplyToNote: 'part {{ applyTo }} discount',
    labelPartEngineeringNumber: 'Part Engineering Number',
    labelPartExternalUom: 'External/Erp UOM',
    labelPartField: 'Part Field',
    labelPartFinder: 'Part Finder',
    labelPartFinderAssets: 'Assets',
    labelPartFinderAssetsCount_one: '{{count, number}} asset',
    labelPartFinderAssetsCount_other: '{{count, number}} assets',
    labelPartFinderAttributeCreated_one: 'Created with 1 value',
    labelPartFinderAttributeCreated_other: 'Created with {{count}} values',
    labelPartFinderAttributePublished: 'Published',
    labelPartFinderAttributeRenamed: "Renamed '{{from}}' → '{{to}}'",
    labelPartFinderAttributes: 'Value List',
    labelPartFinderAttributeValuesAdded_one: 'Added 1 value: {{values}}',
    labelPartFinderAttributeValuesAdded_other: 'Added {{count}} values: {{values}}',
    labelPartFinderAttributeValuesChanged_one: 'Changed 1 value: {{values}}',
    labelPartFinderAttributeValuesChanged_other: 'Changed {{count}} values: {{values}}',
    labelPartFinderAttributeValuesRemoved_one: 'Removed 1 value: {{values}}',
    labelPartFinderAttributeValuesRemoved_other: 'Removed {{count}} values: {{values}}',
    labelPartFinderAttributeValuesReordered: 'Reordered the values',
    labelPartFinderFamilies: 'Part Finder Family',
    labelPartFinderFamilyAttributeGrouped: "Moved '{{name}}' into the group '{{to}}'",
    labelPartFinderFamilyAttributeRegrouped: "Moved '{{name}}' from the group '{{from}}' to '{{to}}'",
    labelPartFinderFamilyAttributesUnused_one: 'Stopped using 1 attribute: {{names}}',
    labelPartFinderFamilyAttributesUnused_other: 'Stopped using {{count}} attributes: {{names}}',
    labelPartFinderFamilyAttributesUsed_one: 'Started using 1 attribute: {{names}}',
    labelPartFinderFamilyAttributesUsed_other: 'Started using {{count}} attributes: {{names}}',
    labelPartFinderFamilyAttributeUngrouped: "Took '{{name}}' out of the group '{{from}}'",
    labelPartFinderFamilyCategoryChanged: "Category '{{from}}' → '{{to}}'",
    labelPartFinderFamilyPartsAdded_one: 'Added 1 part: {{names}}',
    labelPartFinderFamilyPartsAdded_other: 'Added {{count}} parts: {{names}}',
    labelPartFinderFamilyPartsRemoved_one: 'Removed 1 part: {{names}}',
    labelPartFinderFamilyPartsRemoved_other: 'Removed {{count}} parts: {{names}}',
    labelPartFinderFamilyPartValuesChanged_one: 'Changed the values of 1 part',
    labelPartFinderFamilyPartValuesChanged_other: 'Changed the values of {{count}} parts',
    labelPartFinderFamilyProductTypeChanged: "Product type '{{from}}' → '{{to}}'",
    labelPartFinderFamilyRepublished: 'Published again',
    labelPartFinderFamilySyncedList: 'Synced with the “{{name}}” list v{{number}}',
    labelPartFinderFamilySyncedProductType: 'Synced with the “{{name}}” product type v{{number}}',
    labelPartFinderFamilyUnpublished: 'Unpublished',
    labelPartFinderPartsAvailable_one: '{{count, number}} part number is available',
    labelPartFinderPartsAvailable_other: '{{count, number}} part numbers are available',
    labelPartFinderPartsList: 'Parts List',
    labelPartFinderProductTypeAttributeRenamed: "Renamed attribute '{{from}}' → '{{to}}'",
    labelPartFinderProductTypeAttributesAdded_one: 'Added 1 attribute: {{names}}',
    labelPartFinderProductTypeAttributesAdded_other: 'Added {{count}} attributes: {{names}}',
    labelPartFinderProductTypeAttributesChanged_one: 'Changed 1 attribute: {{names}}',
    labelPartFinderProductTypeAttributesChanged_other: 'Changed {{count}} attributes: {{names}}',
    labelPartFinderProductTypeAttributesHint: 'Inherited by every family on this type. Each attribute carries its own name, type and possible values.',
    labelPartFinderProductTypeAttributesRemoved_one: 'Removed 1 attribute: {{names}}',
    labelPartFinderProductTypeAttributesRemoved_other: 'Removed {{count}} attributes: {{names}}',
    labelPartFinderProductTypeAttributesReordered: 'Reordered the attributes',
    labelPartFinderProductTypeCreated_one: 'Created with 1 attribute',
    labelPartFinderProductTypeCreated_other: 'Created with {{count}} attributes',
    labelPartFinderProductTypes: 'Product Type',
    labelPartFinderProductTypeSynced: 'Synced with the “{{list}}” list v{{number}}',
    labelPartFinderReelX: 'Reel {{reelId}}',
    labelPartFinderSource: 'Part Finder',
    labelPartNumber: 'Part Number',
    labelPartNumberBased: 'Part Number Based',
    labelPartNumbers: 'Part Numbers',
    labelPartOrderingNumber: 'Part Ordering Number',
    labelParts: 'Parts',
    labelPartsImportedRatio: '{{imported}} of {{staged}} imported',
    labelPartSpecificationCriteria: 'Part Specification Criteria',
    labelPartStatus: 'Part Status',
    labelPassword: 'Password',
    labelPeople: 'People',
    labelPercentageOnFreight: 'Percentage of the Total Price',
    labelPhone: 'Phone',
    labelPickColor: 'Pick a color',
    labelPkgUnits: 'Pkg Units',
    labelPoll: 'Poll',
    labelPollDefused: 'Poll defused',
    labelPostalCode: 'ZIP/Postal Code',
    labelPreviewCsv: 'Preview CSV',
    labelPreviewPdf: 'Preview PDF',
    labelPreviousYearCases: 'Previous Year Cases',
    labelPreviousYearLines: 'Previous Year Lines',
    labelPrice: 'Price',
    labelPriceBasedOn: 'Price Based On',
    labelPriceCost: 'Price / Cost',
    labelPriceDecimals: 'Price Decimals',
    labelPriceItems: 'Price Items',
    labelPriceQuantityDiscountsApplied: 'Qty Discounts',
    labelPrices: 'Prices',
    labelPriceSource: 'Price Source',
    labelPriceValue: '<wrapper><labelWrapper>Price:</labelWrapper> <valueWrapper>{{value}}</valueWrapper></wrapper>',
    labelPricing: 'Pricing',
    labelPricingDate: 'Pricing Date',
    labelPricingDates: 'Pricing Dates',
    labelPricingEditAllowed: 'Edit Pricing',
    labelPricingGroup: 'Pricing Group',
    labelPricingGroup1: 'Group 1',
    labelPricingGroup2: 'Group 2',
    labelPricingGroup3: 'Group 3',
    labelPricingGroup4: 'Group 4',
    labelPricingGroup5: 'Group 5',
    labelPricingGroupCode1: 'Pricing Group 1 Code',
    labelPricingGroupCode2: 'Pricing Group 2 Code',
    labelPricingGroupCode3: 'Pricing Group 3 Code',
    labelPricingGroupCode4: 'Pricing Group 4 Code',
    labelPricingGroupCode5: 'Pricing Group 5 Code',
    labelPricingGroupDescription1: 'Pricing Group 1 Description',
    labelPricingGroupDescription2: 'Pricing Group 2 Description',
    labelPricingGroupDescription3: 'Pricing Group 3 Description',
    labelPricingGroupDescription4: 'Pricing Group 4 Description',
    labelPricingGroupDescription5: 'Pricing Group 5 Description',
    labelPricingGroupDiscountApplyToNote: 'pricing group {{ applyTo }} discount',
    labelPricingGroups: 'Pricing Groups',
    labelPricingGuidance: 'Pricing Guidance',
    labelPricingMargin: 'Pricing margin',
    labelPricingProfile: 'Pricing Profile',
    labelPricingProfileRemoved: 'pricing profile removed',
    labelPricingProfiles: 'Pricing Profiles',
    labelPricingSourceDiscountTypeBaseCode: 'base code',
    labelPricingSourceDiscountTypeDiscount: 'discount',
    labelPricingSourceDiscountTypeFixed: 'fixed',
    labelPricingSourceDiscountTypeMargin: 'margin',
    labelPricingSourceDiscountTypeVendorQuotePart: 'vendor quote part',
    labelPricingSourceDiscountTypeVendorQuotePartDiscount: 'part discount',
    labelPricingSourceDiscountTypeVendorQuotePricingGroupDiscount: 'pricing group discount',
    labelPricingSourceTypeCustom: 'manually entered',
    labelPricingSourceTypeCustomerCorporate: 'customer corporate',
    labelPricingSourceTypeCustomerQuote: 'customer quote',
    labelPricingSourceTypeDefault: 'company default pricing',
    labelPricingSourceTypeExternal: 'external',
    labelPricingSourceTypeFloorPrice: 'floor price',
    labelPricingSourceTypeListPrice: 'list price',
    labelPricingSourceTypeProject: 'project pricing',
    labelPricingSourceTypeVendorQuote: 'vendor quote',
    labelPricingStrategy: 'Pricing Strategy',
    labelPricingStrategyExternal: 'Default',
    labelPricingStrategyPricingProfile: 'Pricing Profile',
    labelPrioritizeLegacyCost: 'Prioritize Vendor Quote',
    labelPrivate: 'Private',
    labelProblemsOnly: 'Problems only ({{count}})',
    labelProblemsSolved_one: '{{ prefix }} Solved Problem: <valueWrapper>{{ value }}</valueWrapper>',
    labelProblemsSolved_other: '{{ prefix }} Solved Problems: <valueWrapper>{{ value }}</valueWrapper>',
    labelProblemsUnsolved_one: '{{ prefix }} Unsolved Problem: <valueWrapper>{{ value }}</valueWrapper>',
    labelProblemsUnsolved_other: '{{ prefix }} Unsolved Problems: <valueWrapper>{{ value }}</valueWrapper>',
    labelProcessedElsewhere: 'Other instance',
    labelProductSearch: 'Product Search',
    labelProductType: 'Product Type',
    labelProductTypes: 'Product Types',
    labelProfilePrice: 'Profile price',
    labelProgramNumber: 'Program Number',
    labelProgramNumberShort: 'Program #',
    labelProject: 'Project',
    labelProjectCost: 'Project Cost',
    labelProjectCustomers: 'Project Customers',
    labelProjectDetails: 'Project Details',
    labelProjectJobs: 'Jobs in this Project',
    labelProjectJobsCount: 'Jobs in this Project ({{jobsCount}})',
    labelProjectName: 'Project Name',
    labelProjectNumber: 'Project Number',
    labelProjectNumberShort: 'Project #',
    labelProjectOrEndUserName: 'Project Name or End User Name',
    labelProjects: 'Projects',
    labelProprietary: 'Proprietary',
    labelProspect: 'Prospect',
    labelPublic: 'Public',
    labelPurchase: 'Purchase',
    labelPurchaseCost: 'Purchase Cost',
    labelPurchaseCostWithValue: 'PURCHASED {{value}}',
    labelPurchaseOrderNumber: 'Purchase Order Number',
    labelPurchaseOrders: 'Purchase Orders',
    labelPurchaseUom: 'Purchase UOM',
    labelPush: 'Push',
    labelQuantities: 'Quantities',
    labelQuantity: 'Quantity',
    labelQuantityDiscounts: 'QTY DISCOUNTS',
    labelQuantityPerElement: 'Quantity/Element',
    labelQuantityShort: 'Qty',
    labelQuantityUOM: 'Quantity/UOM',
    labelQuickSearch: 'Quick Search',
    labelQuote: 'Quote',
    labelQuoteContact: 'Quote Contact',
    labelQuoteCustomerNote: 'Customer Note',
    labelQuoteCustomerNotes: '{{entityType}} Customer Notes',
    labelQuotedCost: 'Quoted Cost',
    labelQuoteDecimals: 'Quote Decimals',
    labelQuoteDocuments: 'Added to the <quoteTitleWrapper>{{quoteTitle}}</quoteTitleWrapper> {{entityType}}',
    labelQuoteExportMapping: 'Quote Export Mapping',
    labelQuoteFileSourceBomImport: 'BOM Import',
    labelQuoteFileSourceOutlookImport: 'Outlook Import',
    labelQuoteFileSourceQuoteDownload: '{{quoteType}} {{entityType}} Download',
    labelQuoteFileSourceQuoteUpload: '{{quoteType}} {{entityType}} Upload',
    labelQuoteFileSourceVendorQuoteImport: 'Vendor Quote Import',
    labelQuoteHistory: 'Quote History',
    labelQuoteInternalNote: 'Internal Note',
    labelQuoteInternalNotes: '{{entityType}} Internal Notes',
    labelQuoteLocation: 'Quoted Location',
    labelQuoteNote: 'Note',
    labelQuoteParts: 'Quote Parts',
    labelQuotePriceDecimals: 'Quote Price Decimals',
    labelQuoteRevision: 'Quote Revision',
    labelQuotes: 'Quotes',
    labelQuotesDashboard: 'Sales Dashboard',
    labelQuotesVsOrders: 'Quotes vs Orders',
    labelQuoteVendorNote: 'Vendor Note',
    labelQuoteVersion: 'Quote Version',
    labelRangeFromProductType: 'Range comes from the product type: {{range}}',
    labelRank: 'Rank',
    labelReasonQuoteLose: 'Reason for losing Quote',
    labelRecentlyUsedQuotes: 'Recently Used {{entityType}}s',
    labelRecommendedPrice: 'Recommended Price',
    labelReels: 'Reels',
    labelRegion: 'Region',
    labelRelativeLast30Days: 'Last 30 Days',
    labelRelativeLast7Days: 'Last 7 Days',
    labelRelativeLast90Days: 'Last 90 Days',
    labelRelativeToday: 'Today',
    labelRelativeYesterday: 'Yesterday',
    labelReleaseValue: 'Release Value',
    labelRemoveActivePartCost: 'Remove Active Cost',
    labelRemoveActivePartPrice: 'Remove Active Price',
    labelRemoveAssignedCompany: 'Remove Assigned Company',
    labelRemoveNote: 'Remove Note',
    labelRemovePart: 'Remove Part',
    labelRemoveParts: 'Remove Parts',
    labelRemoveRank: 'Remove Rank',
    labelRemoveUomConversion: 'Remove UOM Conversion',
    labelRenameJob: 'Rename Job',
    labelReplacement: 'Replacement',
    labelReplacementCost: 'Replacement Cost',
    labelReplacementCostNumber: 'Agreement Number',
    labelReplacementPart: 'Replacement Part',
    labelReports: 'Reports',
    labelRequestedBy: 'Requested By',
    labelRequestedByUser: 'Requested By User',
    labelRequestedByUserBusinessUnit: 'Requested By User - Business Unit',
    labelRequestedByUserEmployeeId: 'Requested By User - Employee ID',
    labelRequestedByUserLocation: 'Requested By User - Location',
    labelRequestedDate: 'Requested Date',
    labelRequestId: 'Request #',
    labelRequests: 'Requests',
    labelRequestUrl: 'Request URL',
    labelRequiredOnSiteDate: 'Required On Site Date',
    labelRequirements: 'Requirements',
    labelResetCost: 'Reset Cost',
    labelResetCostAndPrice: 'Reset Cost & Price',
    labelResetPrice: 'Reset Price',
    labelResults_one: '{{ count }} result',
    labelResults_other: '{{ count }} results',
    labelRevisionWithValue: 'Revision: {{value}}',
    labelRoles: 'Roles',
    labelRows: 'Rows',
    labelRowsSkipped_one: 'Line skipped ({{count}})',
    labelRowsSkipped_other: 'Lines skipped ({{count}})',
    labelRuleBased: 'Rule Based',
    labelRules: 'Rules',
    labelSales: 'Sales',
    labelSalesHistory: 'Sales History',
    labelSalesLocation: 'Sales Location',
    labelSalesLocations: 'Sales Locations',
    labelSalesMinimumOrderQuantity: 'Sales Minimum Order Quantity',
    labelSalesMoq: 'Sales MOQ',
    labelSalesOrderIncrements: 'Sales Order Increments',
    labelSalesOrders: 'Sales Orders',
    labelSalesUom: 'Sales UOM',
    labelSameAsBase: 'Same as Base',
    labelSaveAsCustomerNumber: 'Save as {{typeLabel}} Customer Number',
    labelSaveValuesAsList: 'Save the values as a list',
    labelScopeParts: 'Parts',
    labelScopeVendors: 'Vendors',
    labelSearch: 'Search',
    labelSearchDocument: 'Search Document',
    labelSelectAGroup: 'Select a group',
    labelSelectAll: 'Select All',
    labelSelectAllJobs: 'Select all jobs',
    labelSelected: 'Selected',
    labelSelectedParts: 'Selected Parts',
    labelSelectedSpaAppliedLines: 'Applied ({{count}})',
    labelSelectedSpaApplyLine: 'Line {{line}}',
    labelSelectedSpaApplyOptionKept: 'kept',
    labelSelectedSpaApplyOptionReplaced: 'replaced',
    labelSelectedSpaApplyReplaceManualCosts: 'Also replace manually entered costs ({{count}})',
    labelSelectedSpaApplyReplaceSelectedSpas: 'Also replace lines that already have a selected SPA ({{count}})',
    labelSelectedSpaCost: 'Selected SPA Cost',
    labelSelectedSpaSkippedLines: 'Skipped ({{count}})',
    labelSelectFieldsToUpdate: 'Select at least one field to update',
    labelSelectionCount_one: '{{ count }} {{ type }} selected',
    labelSelectionCount_other: '{{ count }} {{ type }}s selected',
    labelSelectJob: 'Select job {{name}}',
    labelSelectManufacturer: 'Select Manufacturer',
    labelSelectNewOwner: 'Select New Owner',
    labelSelectNoteTypesToRemove: 'Select at least one note type to remove',
    labelSelectPart: 'Select Part',
    labelSelectSpa: 'Select SPA {{code}}',
    labelSelectStatus: 'Select Status',
    labelSelectSupportRequestLevel: 'Select Level',
    labelSelectValue: 'Value',
    labelSellingPrice: 'Selling Price',
    labelSendInvitation: 'Send Invitation',
    labelSentAsSpa: 'Sent as SPA',
    labelSentAsSpaStatus: 'Sent as {{status}}',
    labelSentAsSpaVersionStatus: 'Sent as v{{version}} - {{status}}',
    labelSentBy: 'Sent by',
    labelSentToFileNet: 'Sent to FileNet',
    labelSetBillToAsDefaultForContact: 'Set as default Bill To for Contact',
    labelSetEqualTimeForAllDays: 'Set equal time for all days',
    labelSetShipToAsDefaultForContact: 'Set as default Ship To for Contact',
    labelSettings: 'Settings',
    labelSetUp: 'Set Up',
    labelSetUpNewPassword: 'Set Up New Password',
    labelSetUpPart: 'Set Up Part',
    labelShared: 'Shared',
    labelSharedEnvironments: 'Shared environments',
    labelShipmentType: 'Shipment Type',
    labelShippingLocation: 'Shipping Location',
    labelShippingLocations: 'Shipping Locations',
    labelShippingMethod: 'Shipping Method',
    labelShipSelection: 'Ship Selection',
    labelShipSelectionDeliveryAfter: 'Delivery After',
    labelShipSelectionDeliveryBy: 'Delivery By',
    labelShipSelectionDeliveryOn: 'Delivery On',
    labelShipSelectionDeliveryWithin: 'Delivery Within',
    labelShipSelectionNoDeliveryDate: 'No Delivery Date',
    labelShipTo: 'Ship To',
    labelShipToLocation: 'Ship To Location',
    labelShow: 'Show',
    labelShowAllLines: 'Show all {{ count }} lines',
    labelShowInventory: 'Inventory Visibility',
    labelShowLess: 'Show less',
    labelSignIn: 'Sign In',
    labelSignInWithSso: 'Sign In with SSO',
    labelSignOut: 'Sign Out',
    labelSince: 'Since',
    labelSinceDate: 'Since {{date}}',
    labelSkippedLogLines: 'Skipped log lines: {{value}}',
    labelSku: 'SKU',
    labelSkuUom: 'SKU UOM',
    labelSoldTo: 'Sold To',
    labelSource: 'Source',
    labelSourceName: 'Source Name',
    labelSourceQuoteNumber: 'Source Quote Number',
    labelSpaCost: 'SPA Cost',
    labelSpaCostDetails: 'SPA Cost Details',
    labelSpaCostEndDate: 'End Date',
    labelSpaCostRegistrationNum: 'Reg Number',
    labelSpaCostSource: 'SPA Cost Source',
    labelSpaCostSourceId: 'SPA Cost Source Id',
    labelSpaCostStartDate: 'Start Date',
    labelSpaCostWithRegNumber: 'SPA Cost (Reg Number {{regNumber}})',
    labelSpaDefault: 'Default',
    labelSpaDefaultInUse: 'Default, in use',
    labelSpaPriority: 'SPA Priority',
    labelSpaPriority1: 'SPA Priority 1',
    labelSpaPriority2: 'SPA Priority 2',
    labelSpaPriority3: 'SPA Priority 3',
    labelSpaPriorityValue: 'SPA Priority {{tier}}',
    labelSpaQuantityRemaining: 'Remaining',
    labelSpaQuantityUsage: 'Usage',
    labelSpaStatus: 'Send SPA as',
    labelSpaStatusLive: 'Live',
    labelSpaStatusPlanning: 'Planning',
    labelSpecifications: 'Specifications',
    labelSpecificMargin: 'Specific Margin',
    labelStale: 'Stale',
    labelStandard: 'Standard',
    labelStandardCost: 'Standard Cost',
    labelStandardCostMoq: 'Standard (STD) Cost (@ MOQ)',
    labelStartDate: 'Start Date',
    labelStartedAt: 'Started At',
    labelState: 'State',
    labelStatus: 'Status',
    labelStreetAddress: 'Street Address',
    labelStuck: 'Stuck',
    labelSubCategory1: 'Sub-category 1',
    labelSubCategory2: 'Sub-category 2',
    labelSubmissions: 'Submissions',
    labelSubmitOrderLog: 'Submit Order Payload Log',
    labelSuccess: 'Success',
    labelSuccessful: 'Successful',
    labelSuggestions: 'Suggestions',
    labelSupplier: 'Supplier',
    labelSupplierName: 'Supplier Name',
    labelSupplierNumber: 'Supplier Number',
    labelSupportCompletedDate: 'Support Completed Date',
    labelSupportRequest: 'Support Request',
    labelSupportRequestCustomerCompanyName: 'Customer',
    labelSupportRequestCustomerContactName: 'Contact',
    labelSupportRequestDefaultType: 'Standard',
    labelSupportRequestId: 'Support Request #',
    labelSupportRequestJobDescription: 'Description/Requests/Notes',
    labelSupportRequestLevel: 'Level',
    labelSupportRequestLevelSP: 'Request Level(s)',
    labelSupportRequests: 'Support Requests',
    labelSupportRequestStatus: 'Status',
    labelSupportRequestStatusSP: 'Request Status(es)',
    labelSupportRequestType: 'Type',
    labelSupportUser: 'Support User',
    labelSupportUserAssigned: 'Support User Assigned',
    labelSupportUserAssignedEmployeeId: 'Support User Assigned - Employee ID',
    labelSupportUserAssignedLocation: 'Support User Assigned - Location',
    labelSwitchAccount: 'Switch Account',
    labelSwitchUsers: 'Switch Users',
    labelSwitchUserVersionType: 'Change to {{ versionType }}',
    labelSystemSettings: 'System Settings',
    labelTaaStatus: 'TAA Status',
    labelTask: 'Task',
    labelTaxonomy: 'Taxonomy',
    labelTheatre: 'Theatre',
    labelTheCustomer: 'the customer',
    labelTheVendor: 'the vendor',
    labelTimeLogCalendar: 'Add Activity Time (in hours) by date',
    labelTimeLogs: 'Time Logs',
    labelTimeValueHours: '{{value}} hours',
    labelTitle: 'Title',
    labelToCustomer: 'To Customer',
    labelTotal: 'Total',
    labelTotalCost: 'Total cost',
    labelTotalFreight: 'Total Freight',
    labelTotalInventory: 'Total Inventory',
    labelTotalLines: 'Total Lines',
    labelTotalPrice: 'Total price',
    labelTotalQuantity: 'Total quantity',
    labelTotals: 'Totals',
    labelTotalTime: 'Total time',
    labelTotalUnitPrice: 'Total Unit Price',
    labelTotalUnitStandardCost: 'Total Unit Standard Cost',
    labelTotalUploads: 'Total Uploads',
    labelTotalWithType: 'Total {{ entityType }}',
    labelTradeAgreementOwner: 'SPA Owner',
    labelTradeAgreements: 'Trade Agreements',
    labelTradeAgreementSentVersion: 'Sent version v{{version}}',
    labelTradeAgreementStartDate: 'SPA Start Date',
    labelTradeAgreementStatus: 'Send as SPA Status',
    labelTrendingCases: 'Trending Cases',
    labelTrendingCustomersInteractions: 'Trending Customers Interactions',
    labelTrueMargin: 'True margin',
    labelTssDashboard: 'TSS Dashboard',
    labelType: 'Type',
    labelTypeEnvironmentToConfirm: 'Confirm environment name',
    labelTypeValuesHere: 'Type values here',
    labelUnblockUser: 'Unblock User',
    labelUnblockUserIp: 'Unblock User IP',
    labelUnifiedPartInactive: 'Unified Part Inactive',
    labelUniqueUsers: 'Unique Users',
    labelUnit: 'Unit',
    labelUnitCost: 'Unit Cost',
    labelUnitMargin: 'Unit Margin',
    labelUnitPurchaseCost: 'Total Unit Purchase Cost',
    labelUnknown: 'Unknown',
    labelUnknownUom: 'Unknown UOM',
    labelUnlocked: 'Unlocked',
    labelUnread: 'Unread',
    labelUnreadNotification: 'Unread',
    labelUnsavedChanged: 'Changed',
    labelUnsavedChanges: 'Unsaved changes',
    labelUnsavedNew: 'New',
    labelUntil: 'Until',
    labelUntilDate: 'Until {{date}}',
    labelUom: 'UOM',
    labelUomConversionAudit: 'UOM Conversion Audit',
    labelUomConversions: 'UOM Conversions',
    labelUomMismatch: 'UOM Mismatch',
    labelUoms: 'UOMs',
    labelUpdateCompanyPart: 'Update Company Part',
    labelUpdatedAt: 'Updated At',
    labelUpdateJob: 'Update Job',
    labelUpdateListWithNewValue: 'Update the list with the new value?',
    labelUpdateMargin: 'Update Margin',
    labelUpdateMatchingQuoteLines: 'Update matching quote lines',
    labelUpdatePart: 'Update Part',
    labelUpdatePartCost: 'Update Part Cost',
    labelUpdatePartPrice: 'Update Part Price',
    labelUpdateProductTypeWithNewValue: 'Update the product type with the new values?',
    labelUpdateSupportRequest: 'Update Request',
    labelUpdateUomConversion: 'Update UOM Conversion',
    labelUpdateUserRanks: 'Update User Ranks',
    labelUpdateUserSettings: 'Update User Settings',
    labelUploaded: 'Uploaded',
    labelUploadedDate: 'Uploaded: {{date}}',
    labelUploadFile: 'Upload File',
    labelUploadFiles: 'Upload Files',
    labelUploads: 'Uploads',
    labelUrl: 'URL',
    labelUseElementTemplate: 'Use Element Template',
    labelUseForThisOrderOnly: 'Use for this order only',
    labelUseLatestPrice: 'I want to use the latest price',
    labelUseQuotedCostToCalculatePrice: 'Use Quoted Cost to calculate price',
    labelUser: 'User',
    labelUseReplacementCostToCalculatePrice: 'Use Replacement Cost to calculate price',
    labelUsers: 'Users',
    labelUseThisCost: 'Use this Cost',
    labelUseValueList: 'Use a value list',
    labelValid: 'Valid',
    labelValidDates: 'Valid Dates',
    labelValidityDates: 'Validity Dates',
    labelValidSince: 'Valid Since',
    labelValidUntil: 'Valid Until',
    labelValue: 'Value',
    labelValueAvailable: '{{value}} available',
    labelValueList: 'Value List',
    labelValueListOption: '{{name}} ({{type}} Type)',
    labelValueLists: 'Value Lists',
    labelValues: 'Values',
    labelValuesAdded: 'Added ({{count}})',
    labelValuesChanged: 'Changed ({{count}})',
    labelValuesFromList: 'Values from {{name}} list',
    labelValuesFromProductType: 'Values from {{name}} product type',
    labelValuesRemoved: 'Removed ({{count}})',
    labelValuesReordered: 'Values reordered',
    labelValueUomAvailable: '{{value}} {{uom}} available',
    labelVariance: 'Variance',
    labelVariations: 'Variations',
    labelVendor: 'Vendor',
    labelVendorContact: 'Vendor Contact',
    labelVendorContacts: 'Vendors',
    labelVendorCost: 'Vendor Cost',
    labelVendorId: 'Vendor ID',
    labelVendorLocation: 'Vendor Location',
    labelVendorMinimumOrderQuantity: 'Vendor Minimum Order Quantity',
    labelVendorMoq: 'Vendor MOQ',
    labelVendorName: 'Vendor Name',
    labelVendorNumbers: 'Vendor Numbers',
    labelVendorOrderContact: 'Vendor Order Contact',
    labelVendorOrderIncrements: 'Vendor Order Increments',
    labelVendorOrders: 'Vendor Orders',
    labelVendorPrimaryContactEmail: 'Email',
    labelVendorPrimaryContactName: 'Name',
    labelVendorPrimaryContactPhone: 'Phone',
    labelVendorPrimaryContactShippingLocation: 'Shipping Location',
    labelVendorProjectName: 'Vendor Project Name',
    labelVendorPurchasingAttributeDirectShip: 'Direct Ship',
    labelVendorPurchasingAttributeDirectShipFee: 'Direct Ship Fee',
    labelVendorPurchasingAttributeDSBuyer: 'DS Buyer',
    labelVendorPurchasingAttributeDSFreightTerms: 'DS Freight Terms',
    labelVendorPurchasingAttributeFOB: 'FOB',
    labelVendorPurchasingAttributeFreightTerms: 'Freight Terms',
    labelVendorPurchasingAttributeMinOrderAmount: 'Min Order Amount',
    labelVendorPurchasingAttributeMinOrderFee: 'Min Order Fee',
    labelVendorPurchasingAttributeMinOrderQuantity: 'Min Order Quantity',
    labelVendorPurchasingAttributeMinOrderWeight: 'Min Order Weight',
    labelVendorPurchasingAttributeMinTransactionAmount: 'Min Transaction Amount',
    labelVendorPurchasingAttributeMinTransactionWeight: 'Min Transaction Weight',
    labelVendorPurchasingAttributeNonStockBuyer: 'Non Stock Buyer',
    labelVendorPurchasingAttributeNotes: 'Notes',
    labelVendorPurchasingAttributeShipMethod: 'Ship Method',
    labelVendorPurchasingAttributeStockBuyer: 'Stock Buyer',
    labelVendorQuoteContact: 'Vendor {{entityType}} Contact',
    labelVendorQuoteLog: 'Vendor Quote Import Log',
    labelVendorQuoteNumber: 'Vendor Quote Number',
    labelVendorQuoteNumberShort: 'Vendor {{entityType}} #',
    labelVendorQuoteRevision: 'Vendor Quote Revision',
    labelVendorQuotes: 'Vendor Quotes',
    labelVendorQuotesAndOrders: 'Vendor Quotes and Orders',
    labelVendorQuoteWithId: 'Vendor Quote #{{id}}',
    // Per-quote blocker reasons in the bulk Send as SPA dialog. Keyed by SpaSendBlockReason.
    labelVendorQuoteWithIdAllCustomers: 'Not allowed with all customers',
    labelVendorQuoteWithIdAllCustomersAllSalesLocations:
      'Not allowed with all customers and all locations',
    labelVendorQuoteWithIdInvalidTradeAgreementDates:
      'SPA Start Date is after Valid Until',
    labelVendorQuoteWithIdMissingRequiredAttributes: 'Missing required attributes',
    labelVendorQuoteWithIdProgram: 'Not allowed for a program',
    labelVersion: 'Version 2.0',
    labelVersionAndDate: 'v{{number}} · {{date}}',
    labelVersionHistory: 'Version History',
    labelVersionNumber: 'v{{number}}',
    labelVerticalMarket: 'Vertical Market',
    labelViaPollPush: 'via poll {{poll}} / push {{push}}',
    labelVideo: 'Video',
    labelVideos: 'Videos',
    labelViewByCompanies: 'View By Companies',
    labelViewByContacts: 'View By Contacts',
    labelViewByLocations: 'View By Locations',
    labelWarningInactiveBillToProjectLink: 'Bill-To location not linked to the project',
    labelWarningInactiveShipToProjectLink: 'Ship-To location not linked to the project',
    labelWarningMissingIsrEmployee: 'ISR not assigned',
    labelWarningMissingOsrEmployee: 'OSR not assigned',
    labelWarnings: 'Warnings',
    labelWatch: 'Watch',
    labelWebsite: 'Website',
    labelWorkEmail: 'Work Email',
    labelYes: 'Yes',
    labelYou: 'You',
    labelYoutubeLink: 'YouTube Link',

    // Messages
    messageAccessDenied: 'You are not authorized to access this page.',
    messageActionLoading: '{{action}} {{subject}}...',
    messageActionSuccess: '{{subject}} has been successfully {{action}}.',
    messageAddContactGroupByEmailOtherTypeFound: 'This email is already associated with a {{contactGroupType}} Company <strong>{{contactGroupName}}</strong>. You can change the email, or click \'Add Vendor\' to continue.',
    messageAddNewContact: "Didn't find the right contact?",
    messageAddNewLocation: "Didn't find the right location?",
    messageAddNewPartNumber: "Didn't find the right number?",
    messageAddNewSalesRepresentative: 'Add New Sales Representative',
    messageAgreeToPolicy: 'I agree to the <0>Privacy Policy</0>.',
    messageAgreeToTerms: 'I agree to the <0>Terms of Service</0>.',
    messageAlertRemoveDefaultApprovedVendor: 'You cannot remove the default approved vendor. Please set another default approved vendor first.',
    messageAllowQuoteReleaseWithoutSendingEmail: 'Allow Quote Release Without Sending Email',
    messageArNumberRequiredForOrder: 'Account Number required for order submission.',
    messageAtLeastOneChecked: 'You must check at least one item.',
    messageAtLeastOneCostItemRequired: 'At least one cost quantity is required.',
    messageAtLeastOnePriceItemRequired: 'At least one price quantity is required.',
    messageAttributesSaveSuccess: 'Attributes saved.',
    messageAttributesSavingInProgress: 'Saving attributes.',
    messageChangePriceHint: 'You can change Price manually or leave it unchanged',
    messageChangePricingToCalculated:
      'Are you sure you want to change pricing to <strong>"Calculated"</strong>?',
    messageChooseDisciplineSP: 'Choose all that apply (at least one)',
    messageChoosePartNumber: 'Choose Part Number',
    messageClickToCreateRequest: '<0>Hey</0>, click here to create a new support request.',
    messageCliJobFinished: 'CLI job finished.',
    messageCliJobInterrupted: 'Action interrupted: {{description}}',
    messageCliJobLostTrack:
      'We lost track of the action. The latest data is shown; check it before trying again.',
    messageComponentPartNumberEditable: 'Click to choose a part number.',
    messageComponentPartNumberMissing: 'No part number.',
    messageComponentWithoutPart: 'Please click the edit icon to choose a part number.',
    messageConfirmApplySelectedSpaToLines: 'Apply <strong>{{agreementCode}}</strong> to all eligible lines?',
    messageConfirmArchiveQuote_one: 'Are you sure you want to archive the selected {{entityType}}?',
    messageConfirmArchiveQuote_other: 'Are you sure you want to archive the selected {{entityType}}s?',
    messageConfirmAttachContactGroupDomain: 'The domain <strong>{{domain}}</strong> will be added to <strong>{{contactGroupName}}</strong>. Future contacts with this domain will automatically match this company.',
    messageConfirmBlockUnblockUser: 'Are you sure you want to {{action}} the user {{userName}}?',
    messageConfirmBlockUnblockUserIP: "Are you sure you want to {{action}} the user's {{userName}} IP?",
    messageConfirmBlockUnblockUserIPs: 'Are you sure you want to {{action}} the IPs for {{userLength}} users?',
    messageConfirmBlockUnblockUsers: 'Are you sure you want to {{action}} {{userLength}} users?',
    messageConfirmDetachVendorQuotes_one: 'Are you sure you want to detach this vendor quote?',
    messageConfirmDetachVendorQuotes_other: 'Are you sure you want to detach {{count}} vendor quotes?',
    messageConfirmDetachVendorQuotesFromProject_one: 'Are you sure you want to detach this vendor quote from the project?',
    messageConfirmDetachVendorQuotesFromProject_other: 'Are you sure you want to detach {{count}} vendor quotes from the project?',
    messageConfirmDuplicateLine_one: 'You are about to create a copy of <strong>{{partNumber}}</strong> at the bottom of the quote. Are you sure you want to continue?',
    messageConfirmDuplicateLinePrefix: 'You are about to create copies of the selected <strong>{{count}} parts</strong> at the bottom of the quote:',
    messageConfirmDuplicateLineSuffix: 'Are you sure you want to continue?',
    messageConfirmExistingContactGroup: 'Please confirm this is the company you want to add the customer to.',
    messageConfirmExistingVendorQuote: '<wrapper>This vendor quote already exists. You can see it <linkWrapper>here</linkWrapper></wrapper>.',
    messageConfirmMergeContactGroups: 'Are you sure you want to merge the following <countWrapper>{{count}}</countWrapper> companies into <nameWrapper>{{mainCompany}}</nameWrapper>?',
    messageConfirmMergeContactGroupsNote: 'Merging companies will move all contacts and locations from the selected companies into the main company. This action is permanent and cannot be undone.',
    messageConfirmOrder: 'Are you sure you want to create an order?',
    messageConfirmOrderLinesWithoutPricing: 'Order will include lines with no cost. Please confirm that you want to create the order.\nLines without cost: <strong>{{linesWithoutPricing}}</strong>.',
    messageConfirmOrderTotalAmountBelowMinimum: 'The total amount is below the company minimum order threshold of {{minimum}}. Are you sure you want to create an order?',
    messageConfirmRemoveAssignedCompanyForSelectedUsers: 'Are you sure you want to remove the assigned company for the selected users?',
    messageConfirmRemoveAssignedCompanyForUser: 'Are you sure you want to remove the assigned company for the user {{userName}}?',
    messageConfirmRemoveComponent: 'Are you sure you want to remove the component <strong>{{componentName}}</strong> from the part <strong>{{partNumber}}</strong>?',
    messageConfirmRemoveContact_one: 'Are you sure you want to remove the selected contact?',
    messageConfirmRemoveContact_other: 'Are you sure you want to remove the selected {{count}} contacts?',
    messageConfirmRemoveCostingCalculations_one: 'Are you sure you want to remove the costing calculation?',
    messageConfirmRemoveCostingCalculations_other: 'Are you sure you want to remove {{count}} costing calculations?',
    messageConfirmRemoveCostingProfiles_one: 'Are you sure you want to remove the costing profile?',
    messageConfirmRemoveCostingProfiles_other: 'Are you sure you want to remove {{count}} costing profiles?',
    messageConfirmRemoveCustomers_one: 'Are you sure you want to remove {{customerName}} from this job?',
    messageConfirmRemoveCustomers_other: 'Are you sure you want to remove {{count}} customers from this job?',
    messageConfirmRemoveDocument: 'Are you sure you want to remove "{{fileName}}"?',
    messageConfirmRemoveDocumentWithDescription:
      'Are you sure you want to remove "{{description}}" ({{fileName}})?',
    messageConfirmRemoveElementTemplateParts_one: 'Are you sure you want to remove the part <strong>{{number}}</strong>?',
    messageConfirmRemoveElementTemplateParts_other: 'Are you sure you want to remove <strong>{{count}} parts</strong>?',
    messageConfirmRemoveElementTemplates_one: 'Are you sure you want to remove the element template?',
    messageConfirmRemoveElementTemplates_other: 'Are you sure you want to remove {{count}} element templates?',
    messageConfirmRemoveJobComponents_one: 'Are you sure you want to remove the component <strong>{{name}}</strong>?',
    messageConfirmRemoveJobComponents_other: 'Are you sure you want to remove <strong>{{count}} components?</strong>',
    messageConfirmRemoveJobParts_one: 'Are you sure you want to remove the part <strong>{{number}}</strong>?',
    messageConfirmRemoveJobParts_other: 'Are you sure you want to remove <strong>{{count}} parts?</strong>',
    messageConfirmRemoveJobPartsAndComponents: 'Are you sure you want to remove <strong>{{partsText}}</strong> and <strong>{{componentsText}}?</strong>',
    messageConfirmRemoveJobPartsAndComponentsComponent_one: '{{count}} component',
    messageConfirmRemoveJobPartsAndComponentsComponent_other: '{{count}} components',
    messageConfirmRemoveJobPartsAndComponentsPart_one: '{{count}} part',
    messageConfirmRemoveJobPartsAndComponentsPart_other: '{{count}} parts',
    messageConfirmRemoveLineNotes_one:
      'Are you sure you want to remove the following note types from <strong>the selected line</strong>?',
    messageConfirmRemoveLineNotes_other:
      'Are you sure you want to remove the following note types from <strong>{{count}} lines</strong>?',
    messageConfirmRemoveLines_one: 'Are you sure you want to remove the line?',
    messageConfirmRemoveLines_other: 'Are you sure you want to remove {{count}} lines?',
    messageConfirmRemoveLinesWithPricingGroupDiscount_one: 'Are you sure you want to remove {{partsCount}} lines? One of them is pricing group discount!',
    messageConfirmRemoveLinesWithPricingGroupDiscount_other: 'Are you sure you want to remove {{partsCount}} lines? {{count}} of them are pricing group discounts!',
    messageConfirmRemoveLocation: 'Are you sure you want to remove location <strong>{{locationName}}</strong>?',
    messageConfirmRemoveLogs_one: 'Are you sure you want to remove the time log?',
    messageConfirmRemoveLogs_other: 'Are you sure you want to remove <strong>{{count}}</strong> time logs?',
    messageConfirmRemovePartBom: 'Are you sure you want to remove the Part BoM <strong>{{partBomNumber}}</strong>?',
    messageConfirmRemovePartBomItems_one: 'Are you sure you want to remove the <strong>{{number}}</strong> line?',
    messageConfirmRemovePartBomItems_other: 'Are you sure you want to remove {{count}} lines?',
    messageConfirmRemovePartCosts_one: 'Are you sure you want to remove the part cost?',
    messageConfirmRemovePartCosts_other: 'Are you sure you want to remove {{count}} part costs?',
    messageConfirmRemovePartFinderAttributes_one: "'{{name}}' will be removed. Wherever it is used, its values will be converted to family-specific attributes.",
    messageConfirmRemovePartFinderAttributes_other: '{{count}} value lists will be removed. Wherever they are used, their values will be converted to family-specific attributes.',
    messageConfirmRemovePartFinderFamilies_one: 'Remove the family "{{name}}"? It leaves the list and the finder.',
    messageConfirmRemovePartFinderFamilies_other: 'Remove {{count}} families? They leave the list and the finder.',
    messageConfirmRemovePartFinderProductTypes_one:
      "'{{name}}' will be removed. Families on this type will have their inherited attributes converted to family-specific attributes.",
    messageConfirmRemovePartFinderProductTypes_other:
      '{{count}} product types will be removed. Families on these types will have their inherited attributes converted to family-specific attributes.',
    messageConfirmRemovePartPrices_one: 'Are you sure you want to remove the part price?',
    messageConfirmRemovePartPrices_other: 'Are you sure you want to remove {{count}} part prices?',
    messageConfirmRemovePricingGroupDiscount_one: 'Are you sure you want to remove the pricing group discount?',
    messageConfirmRemovePricingGroupDiscount_other: 'Are you sure you want to remove the {{count}} pricing group discounts?',
    messageConfirmRemovePricingProfileAccess_one: 'Are you sure you want to remove the access?',
    messageConfirmRemovePricingProfileAccess_other: 'Are you sure you want to remove {{count}} accesses?',
    messageConfirmRemovePricingProfileAdminUser_one: 'Are you sure you want to remove the user: {{userName}}?',
    messageConfirmRemovePricingProfileAdminUser_other: 'Are you sure you want to remove {{count}} admin users?',
    messageConfirmRemovePricingProfilePartNumbers_one: 'Are you sure you want to remove the fixed price?',
    messageConfirmRemovePricingProfilePartNumbers_other: 'Are you sure you want to remove {{count}} fixed prices?',
    messageConfirmRemovePricingProfileRules_one: 'Are you sure you want to remove the pricing profile rule?',
    messageConfirmRemovePricingProfileRules_other: 'Are you sure you want to remove {{count}} pricing profile rules?',
    messageConfirmRemovePricingProfiles_one: 'Are you sure you want to remove the pricing profile?',
    messageConfirmRemovePricingProfiles_other: 'Are you sure you want to remove {{count}} pricing profiles?',
    messageConfirmRemoveProjectCustomer: 'Are you sure you want to remove <strong>{{name}}</strong> from this pricing profile?',
    messageConfirmRemoveProjectPricingProfile_one: 'Are you sure you want to remove <strong>{{name}}</strong> from the project?',
    messageConfirmRemoveProjectPricingProfile_other: 'Are you sure you want to remove {{count}} pricing profiles from the project?',
    messageConfirmRemoveProjectUsers_one: 'Are you sure you want to remove the user: {{userName}}?',
    messageConfirmRemoveProjectUsers_other: 'Are you sure you want to remove {{count}} users?',
    messageConfirmRemoveRank: 'Are you sure you want to remove the rank: {{rankName}}?',
    messageConfirmRemoveRow: 'Are you sure you want to remove the row?',
    messageConfirmRemoveUomConversion: 'Are you sure you want to remove the UOM conversion?',
    messageConfirmRemoveVendors_one: 'Are you sure you want to remove {{vendorName}} from this job?',
    messageConfirmRemoveVendors_other: 'Are you sure you want to remove {{count}} vendors from this job?',
    messageConfirmRemoveVideo: 'Are you sure you want to remove the video <strong>{{name}}</strong>?',
    messageConfirmReplaceSelectedSpa: 'This replaces the selected SPA <strong>{{agreementCode}}</strong> on this line.',
    messageConfirmResetQuoteDraftVersion: 'If you reset, your draft will go back to the latest released version and your recent changes will be lost. Are you sure you want to continue?',
    messageConfirmResetQuotePartExpiredCosting: 'The costs on this {{quoteEntityType}} are more than 24 hours old. Would you like to update the costs?',
    messageConfirmRestoreDeletedContact: 'A contact was already set up for <strong>{{contactEmail}}</strong> but is currently deleted. Do you want to restore it?',
    messageConfirmRestoreQuote_one: 'Are you sure you want to restore the selected {{entityType}}?',
    messageConfirmRestoreQuote_other: 'Are you sure you want to restore the selected {{entityType}}s?',
    messageConfirmSubmitOrder: 'Please confirm that you want to submit the order.',
    messageConfirmSubmitOrderLinesWithoutPartNumberAndManufacturerAssigned: 'All lines must have a part number and a manufacturer assigned to submit an order. Click cancel to return and assign part numbers and manufacturers or click confirm to submit an order and omit lines without part numbers or manufacturers.\nLines without part number or manufacturer: <strong>{{linesWithoutPartNumberAndManufacturer}}</strong>.',
    messageConfirmSubmitOrderLinesWithoutPartNumberAssigned: 'All lines must have a part number assigned to submit an order. Click cancel to return and assign part numbers or click confirm to submit an order and omit lines without part numbers.\nLines without part number: <strong>{{linesWithoutPartNumber}}</strong>.',
    messageConfirmSubmitOrderLinesWithoutPricing: 'The order contains parts with no cost. Please confirm that you want to submit the order.\nLines without cost: <strong>{{linesWithoutPricing}}</strong>.',
    messageConfirmSubmitOrderTotalAmountBelowMinimum: 'The total amount is below the company minimum order threshold of {{minimum}}. Are you sure you want to submit the order?',
    messageConfirmUnpublishPartFinderFamilies_one: 'Unpublish the family "{{name}}"? It leaves the finder until it is published again. Its versions stay.',
    messageConfirmUnpublishPartFinderFamilies_other: 'Unpublish {{count}} families? They leave the finder until they are published again. Their versions stay.',
    messageContactEmailDomainNotMatchGroupDomains: 'Contact email domain <strong>{{email}}</strong> doesn\'t match company domains: <strong>{{groupDomains}}</strong>.',
    messageContactGroupDomainMismatch: "This domain doesn't match <strong>{{contactGroupName}}</strong>. Users with the <strong>{{domain}}</strong> email domain will be able to see this company's information.",
    messageContactsAssociatedWithContactGroup: 'Contacts associated with <contactGroupWrapper>{{contactGroupName}}</contactGroupWrapper>',
    messageContactsAssociatedWithOtherContactGroups: 'Contacts associated with other companies',
    messageCopyPartsWithStatusAbandoned: 'There are parts selected that have been abandoned and will not be copied.\nLines: <strong>{{linesWithStatusAbandoned}}</strong>.',
    messageCopyQuoteNoteWarning: '<wrapper>{{noteType}} Note to copy:<noteWrapper>{{sourceNote}}</noteWrapper>Existing {{noteType}} Note on the target quote:<noteWrapper>{{targetNote}}</noteWrapper>Please choose whether to merge or override the existing note.</wrapper>',
    messageCostingCustom: 'I want to override the Quoted Cost provided by the system',
    messageCostingReplacementCustom: 'I want to enter the Replacement Cost',
    messageCreateContactGroupForGenericEmail: 'The company will be created without an email domain, because generic domains cannot be linked to a company.',
    messageCreditHoldConfirmation: 'The project {{projectName}} is on credit hold. The order will be submitted and placed on credit hold. Do you want to continue?',
    messageCustomerCreatedSuccess: 'Customer has been successfully created.',
    messageCustomerCreateInProgress: 'Creating customer...',
    messageCustomerNumberOrProspect: 'Please enter a customer number or check prospect, if no customer number.',
    messageCustomersRemovedSuccess_one: 'Customer has been successfully removed.',
    messageCustomersRemovedSuccess_other: '{{count}} customers have been successfully removed.',
    messageCustomersRemoveInProgress_one: 'Removing customer...',
    messageCustomersRemoveInProgress_other: 'Removing customers...',
    messageCustomerUpdatedSuccess: 'Customer updated successfully',
    messageCustomerUpdateInProgress: 'Updating customer...',
    messageDontKnowFullPartNumber: "Don't know the full part number?",
    messageDragAndDropColumnHeader: 'Drag labels to the appropriate cell to make column headers.',
    messageDragAndDropFiles: 'Drag and drop files here, or click to select files.',
    messageDragFiles_one: 'Add or Drag file here',
    messageDragFiles_other: 'Add or Drag files here',
    messageDropFiles_one: 'Drop file here',
    messageDropFiles_other: 'Drop files here',
    messageDropFilesReject: 'Files not supported.',
    messageDropFilesZone: 'Drop the files here ...',
    messageEditLinesWithCostLocked: 'There are quote parts selected with cost "Locked by Contract".\nLines: <strong>{{linesWithCostLocked}}</strong>.',
    messageEditLinesWithPriceLocked: 'There are quote parts selected with price "Locked".\nLines: <strong>{{linesWithPriceLocked}}</strong>.',
    messageEndActivePartCost: 'Are you sure you want to end the active part cost?',
    messageEndActivePartPrice: 'Are you sure you want to end the active part price?',
    messageEndDateMustBeAfterStartDate: 'End Date must be after Start Date.',
    messageExtractorVendorMappingContactUnresolved: 'This contact can no longer be used on a quote. Please select another one.',
    messageExtractorVendorMappingRemoveConfirmation_one: 'Are you sure you want to delete this mapping? The next import from this extractor will ask for a vendor again.',
    messageExtractorVendorMappingRemoveConfirmation_other: 'Are you sure you want to delete these mappings? The next import from these extractors will ask for a vendor again.',
    messageFindCustomerNoSelectedContact: 'No contact selected. Please select an existing contact or add a new one.',
    messageFindQuoteHint: "You can type the {{entityType}} number, the client's name, or the project name",
    messageForgotPassword: 'Forgot password?',
    messageForgotPasswordInfo: 'If this is a valid account, you’ll get the password recovery link in your inbox right away.',
    messageHelloUser: '<0>Hey{{name}}</0>, check out some of the powerful features now available in our latest release.',
    messageImportFailedRows_one: 'Import complete — {{ count }} row could not be imported and was skipped. All other rows were imported successfully.',
    messageImportFailedRows_other: 'Import complete — {{ count }} rows could not be imported and were skipped. All other rows were imported successfully.',
    messageImportNoHeaderRow: 'There is no header row in this table',
    messageInactiveBillToProjectLink: 'No longer linked to the selected project. Select a different Bill-To location or project.',
    messageInactiveShipToProjectLink: 'No longer linked to the selected project. Select a different Ship-To location or project.',
    messageInventoryLoadError:
      'The inventory failed to load. Please try again later.',
    messageLocationsAssociatedWithContactGroup: 'Locations associated with <contactGroupWrapper>{{contactGroupName}}</contactGroupWrapper>',
    messageLocationsAssociatedWithOtherContactGroups: 'Locations associated with other companies',
    messageManufacturersValidated: 'All manufacturers have been identified.',
    messageManufacturersValidating: 'Validating manufacturers.',
    messageNoCost: 'No Cost',
    messageNoCustomersAssigned: 'No customers assigned.',
    messageNoExtractorVendorMappings: 'No mappings found.',
    messageNoFilesAttached: 'No files attached.',
    messageNoItemsFound: 'No logs available.',
    messageNoJobsAddedToSupportRequest: 'No jobs added yet. Select a discipline to add a job.',
    messageNoJobsFound: 'No jobs found.',
    messageNoManufacturer: 'No manufacturer information available for this part.',
    messageNoMatchingFiles: 'No matching files found.',
    messageNoMedia: 'No media available for this part.',
    messageNoOptions: 'No options',
    messageNoOptionsAvailable: 'No options available',
    messageNoPartNotes: 'There are no notes for this part. Click the button to add a note.',
    messageNoPrice: 'No Price',
    messageNoRecentImpersonatedUsers: 'No recent impersonated users.',
    messageNoSpaInformation: 'No SPA information available.',
    messageNoSpecifications: 'No specifications data available for this part.',
    messageNoSubmitOrderLogEntries: 'No order submissions in this window',
    messageNoSubmitOrderPayload: 'No request payload was captured for this submission.',
    messageNoSubmitOrderResponse: 'No response body was captured for this submission.',
    messageNoSupportRequestFound: 'No requests found.',
    messageNotFound: "The page you were looking for can't be found or does not exist.",
    messageNoTradeAgreementsAvailable: 'No SPA costs are available for this line.',
    messageNoUsersFound: 'No users found.',
    messagePartAlreadyAddedToPricingProfile: 'Fixed price/cost already exists for the following parts: {{partNumbers}}. Do you want to update them?',
    messagePartBomNoParts: 'There is nothing here yet, to get started you need to add a part first.',
    messagePartFinderAttributeValuesLiveOnAttribute_one: 'This value lives only on this attribute. Save it as a value list so other attributes can use the same one.',
    messagePartFinderAttributeValuesLiveOnAttribute_other: 'These {{count}} values live only on this attribute. Save them as a value list so other attributes can use the same ones.',
    messagePartFinderFamilyDetachAttributes_one: 'Changing the Product Type will detach 1 inherited attribute from this Family. Choose what happens to it.',
    messagePartFinderFamilyDetachAttributes_other: 'Changing the Product Type will detach {{count}} inherited attributes from this Family. Choose what happens to them.',
    messagePartFinderFamilyNoParts: 'There is nothing here yet, to get started you need to add a Part Numbers',
    messagePartFinderFamilyProductTypeChange: 'If you decide to change the product type, inherited attributes may be converted to family-specific attributes or deleted',
    messagePartFinderNoAttributes: 'There is nothing here yet, to get started you need to add a Value List',
    messagePartFinderNoFamilies: 'There is nothing here yet, to get started you need to create a Part Finder Family',
    messagePartFinderNoProductTypes: 'There is nothing here yet, to get started you need to create a Product Type',
    messagePartsValidated: 'All parts have valid manufacturers.',
    messagePartsValidating: 'Validating parts manufacturers.',
    messagePartUnverified: 'Unverified!',
    messagePartVerified: 'Verified!',
    messagePhoneNumber10Digits: '{{type}} phone number must be exactly 10 digits',
    messagePriceBasedOnPurchaseCost: 'Based on {{costLabel}} {{cost}}',
    messagePriceBasedOnReplacementCost: 'Based on Replacement Cost {{cost}}',
    messagePricingProfilePartNumberUomChanged: 'UOM will be changed from <strong>{{from}}</strong> to <strong>{{to}}</strong>. Please update the price/margin accordingly.',
    messagePricingProfileShareAccess: 'Share pricing profile within the company',
    messagePurchaseCostExceedsStandardCost: 'Entering a cost higher than the standard cost will be ignored',
    messagePurchaseCostExceedsStandardCostTooltip: 'The cost is higher than the standard cost and will be ignored',
    messageQuoteSendToFileNetAlreadyInProgress: 'This quote file is already being sent to FileNet. Please wait for it to finish.',
    messageReleaseDraftVerison: 'Are you sure you want to release the draft?',
    messageRemoveActivePartCost: 'Are you sure you want to remove the active part cost?',
    messageRemoveActivePartPrice: 'Are you sure you want to remove the active part price?',
    messageRemoveNote: 'Are you sure you want to remove the note?',
    messageRemovePart: 'Are you sure you want to remove this part?',
    messageRemoveParts: 'Are you sure you want to remove {{partsLength}} parts?',
    messageRemoveUomConversion: 'Are you sure you want to remove the UOM conversion?',
    messageReplacementCostInfoRequired: 'Replacement Cost Info is required',
    messageReplacementStandardCostDeferred:
      'This value will be calculated when "Use Replacement Cost to calculate price" is selected.',
    messageResendAsSpaConfirmation:
      'Send the updated vendor quote as SPA? The agreement sent as v{{version}} will be replaced by the current quote.',
    messageResendAsSpaConfirmationNoVersion:
      'Send the updated vendor quote as SPA? The agreement sent before will be replaced by the current quote.',
    messageResendAsSpaInProgress: 'Sending the update as SPA.',
    messageResendAsSpaSuccess: 'You have successfully sent the update as SPA.',
    messageResendEmail: 'Resend email verification link',
    messageResendEmailInfo: 'If this is an account that needs verification, you’ll get the link in your inbox right away.',
    messageReusePriceConfirmation: 'Apply <strong>{{price}}</strong> as the unit price for this part?',
    messageReusePriceDisabled: 'You are currently in release mode. To reuse a price, switch to draft mode in order to edit.',
    messageReviewPricingProfileAccess: 'Would you like to review or add customer access to this pricing profile?',
    messageSalesHistoryLoadError:
      'The sales history failed to load. Please try again later.',
    messageSearchByCharsLength: 'Please enter at least {{length}} characters...',
    messageSearchingQuote: 'Searching for quote.',
    messageSearchPartNumber: 'Search for a Part Number',
    messageSelectCompanyNameToMerge: 'Please select the company name to merge with.',
    messageSelectContactGroup: 'Please select a company',
    messageSelectedSpaAppliedCost: 'Quoted Cost from <strong>{{previousCost}}</strong> to <strong>{{newCost}}</strong>',
    messageSelectedSpaApplyInProgress: 'Checking which lines can take <strong>{{agreementCode}}</strong>. This can take a while on large quotes.',
    messageSelectedSpaApplyInterrupted:
      'Action interrupted: {{description}} Some lines may already have been updated — reload the quote before editing them.',
    messageSelectedSpaApplyJobExpired: 'The job expired before it finished.',
    messageSelectedSpaApplyJobPending: 'A selected SPA is still being applied on this quote. Wait for it to finish before applying another.',
    messageSelectedSpaApplyJobPendingProgress_one: 'A selected SPA is still being applied on this quote ({{processed}} of {{count}} line done). Wait for it to finish before applying another.',
    messageSelectedSpaApplyJobPendingProgress_other: 'A selected SPA is still being applied on this quote ({{processed}} of {{count}} lines done). Wait for it to finish before applying another.',
    messageSelectedSpaApplyKeepsCosts: 'If you untick an option, those lines keep their current cost.',
    messageSelectedSpaApplyLostTrack: 'We lost track of the job. Check the lines to see which ones were updated.',
    messageSelectedSpaApplyNothingApplied: 'Nothing was applied: no other line could take <strong>{{agreementCode}}</strong>.',
    messageSelectedSpaApplyNothingAppliedLineError:
      'Nothing was applied: the SPA list could not be checked for some lines. Try again later.',
    messageSelectedSpaApplyNothingAppliedSaveFailed: 'Nothing was applied: the SPA could not be saved on some lines. Try again.',
    messageSelectedSpaApplyOptionManualCosts: 'Manually entered costs: <strong>{{outcome}}</strong>',
    messageSelectedSpaApplyOptionSelectedSpas: 'Existing selected SPAs: <strong>{{outcome}}</strong>',
    messageSelectedSpaApplyProgress_one: 'Applying <strong>{{agreementCode}}</strong>: {{processed}} of {{count}} line — {{applied}} applied, {{skipped}} skipped.',
    messageSelectedSpaApplyProgress_other: 'Applying <strong>{{agreementCode}}</strong>: {{processed}} of {{count}} lines — {{applied}} applied, {{skipped}} skipped.',
    messageSelectedSpaApplyRunsInBackground: 'This runs in the background and can take a while on large quotes; the result shows when it finishes.',
    messageSelectedSpaApplyStartFailed: '<strong>{{agreementCode}}</strong> could not be applied to the eligible lines.',
    messageSelectedSpaApplyStoppedNothingApplied:
      'The job stopped before <strong>{{agreementCode}}</strong> was applied to any line.',
    messageSelectedSpaApplyStoppedSummary_one:
      'The job stopped after applying <strong>{{agreementCode}}</strong> to {{count}} line.',
    messageSelectedSpaApplyStoppedSummary_other:
      'The job stopped after applying <strong>{{agreementCode}}</strong> to {{count}} lines.',
    messageSelectedSpaApplySummary_one: '<strong>{{agreementCode}}</strong> was applied to {{applied}} of {{count}} line, {{skipped}} skipped.',
    messageSelectedSpaApplySummary_other: '<strong>{{agreementCode}}</strong> was applied to {{applied}} of {{count}} lines, {{skipped}} skipped.',
    messageSelectedSpaExpired: 'The selected SPA expired on {{date}}.',
    messageSelectedSpaNoLongerOffered: 'The SPA in use ({{agreementCode}}) is no longer offered for this line.',
    messageSelectedSpaNoLongerOfferedWithCost: 'The SPA in use ({{agreementCode}}, {{cost}}) is no longer offered for this line.',
    messageSelectedSpaSkippedAlreadySelected: 'Already costed from a selected SPA.',
    messageSelectedSpaSkippedAlreadyThisSpa: 'Already uses this SPA.',
    messageSelectedSpaSkippedCostLocked: 'Cost locked by the pricing engine.',
    messageSelectedSpaSkippedDiscountLine: 'Discount line, not costed from a trade agreement.',
    messageSelectedSpaSkippedLineError: 'The SPA list could not be checked for this line. Try again later.',
    messageSelectedSpaSkippedLocked: 'Locked.',
    messageSelectedSpaSkippedManualCost: 'Manually entered cost.',
    messageSelectedSpaSkippedNoEntityCode: 'The customer on this quote has no account code with the vendor.',
    messageSelectedSpaSkippedNoSelectionAvailable: 'No SPAs are available for this line.',
    messageSelectedSpaSkippedNoSkuUom: 'No vendor SKU, unit of measure or vendor pricing available for this line.',
    messageSelectedSpaSkippedNotAlternate: 'Not on an alternate version quote.',
    messageSelectedSpaSkippedNotEligible: 'Not eligible for a selected SPA.',
    messageSelectedSpaSkippedNotInList: 'This SPA is not offered for this line.',
    messageSelectedSpaSkippedOmitted: 'Omitted from the quote.',
    messageSelectedSpaSkippedOther: 'Skipped for another reason.',
    messageSelectedSpaSkippedSaveFailed: 'The SPA could not be saved on this line. Try again.',
    messageSelectedSpaSkippedSelectionUnknown: 'No SPA selection known yet. Re-price the line first.',
    messageSelectedSpaSkippedSubstituted: 'Substituted by an alternate.',
    messageSelectedSpaUomCheckFailed: 'The SPA costs could not be checked for the new UOM. The selected SPA is kept.',
    messageSelectedSpaUseInProgress: 'Applying <strong>{{agreementCode}}</strong>.',
    messageSelectPart: 'Select a part',
    messageSendAsSpaBlockersInvalidDates:
      'This vendor quote has an SPA Start Date after its Valid Until date and cannot be sent as SPA.',
    messageSendAsSpaBlockersMissingAttributes:
      'This vendor quote is missing required attributes and must be completed before it can be sent as SPA.',
    messageSendAsSpaError: 'Failed to send as SPA. Please try again.',
    messageSendAsSpaErrorAtStep: 'Failed to send as SPA at the {{step}} step. Please try again.',
    messageSendAsSpaInProgress: 'Sending as SPA.',
    messageSendAsSpaLockFailed:
      'Another send of this vendor quote as SPA is in progress. Please try again shortly.',
    messageSendAsSpaPastValidUntil:
      'The Valid Until date of this quote, <strong>{{date}}</strong>, is in the past. Send it as SPA anyway?',
    messageSendAsSpaSkippedByOtherSend: 'Skipped: already sent by another send.',
    messageSendAsSpaSpaStatus: 'The agreement is sent as SPA with the status <strong>{{status}}</strong>.',
    messageSendAsSpaStatusWriteFailed:
      'Sent as SPA, but the vendor quote status could not be saved. Do not send it again; please contact support.',
    messageSendAsSpaSuccess: 'You have successfully sent as SPA.',
    messageShippingFieldsChangeWarning: 'The cost and price could be changed by the shipment type/shipping location changes. Please verify the current cost and price for accuracy.',
    messageSignIn: 'Already have an account? <0>Log in.</0>',
    messageSignUp: 'Don’t have an account yet? <0>Sign up.</0>',
    messageSingleManufacturerImport: 'Is this a single manufacturer import?',
    messageSpaCustomersFromProject: 'The customers of the selected project are used and cannot be changed.',
    messageSpaProgramNotPermitted: 'You are not allowed to send this vendor quote as SPA for a program. Choose a project or a specific customer.',
    messageSpaProgramSentToAllCustomers: 'A program is sent to all customers.',
    messageSpaProjectHasNoCustomers: 'The selected project has no customer in Partfiniti. Choose another project or specific customers.',
    messageStartDateMustBeTodayOrFuture: 'Start Date must be today or in the future.',
    messageSubmitOrderAlreadySubmittedExternal: 'This order was already submitted to the external order system as <strong>{{externalOrderNumber}}</strong>. Submitting it again would create a duplicate.',
    messageSubmitOrderLogReportError:
      'The submit order payload log for the selected date range could not be read. Retry, or pick another range.',
    messageSubmitOrderNotAllowedDifferentVersion: 'The order was created in the <strong>{{versionType}}</strong> version. You will need to create a copy of the order to submit it.',
    messageSubmitOrderOrderingInProgress: 'The order has been sent for processing. This page will update automatically.',
    messageSubmitOrderPayloadError:
      'The request payload for this submission could not be read. Retry, or copy it from the row instead.',
    messageSubmitOrderSubmissionTimedOut:
      'The submission to the external order system timed out. The order cannot be re-submitted until the external order system reports back; if no update arrives, check the order in the external system.',
    messageSupportedFileTypes: 'Supported file types {{types}}.',
    messageToggleAllCustomersInProgress: 'Updating customer settings.',
    messageToggleAllCustomersSuccess: 'Customer settings have been updated.',
    messageTradeAgreementExpired: 'This agreement ended on {{date}}.',
    messageTradeAgreementsLoadError: 'The pricing provider could not list the SPAs for this line. Refresh the list to try again.',
    messageTradeAgreementsReasonCostLocked: 'The cost on this line is locked by the pricing engine.',
    messageTradeAgreementsReasonDiscountLine: 'Discount lines are not costed from a trade agreement.',
    messageTradeAgreementsReasonLocked: 'This line is locked.',
    messageTradeAgreementsReasonNoEntityCode: 'The customer on this quote has no account code with the vendor.',
    messageTradeAgreementsReasonNoSelectionAvailable: 'The pricing provider offers no SPAs for this line.',
    messageTradeAgreementsReasonNoSkuUom: 'No vendor SKU, unit of measure or vendor pricing is available for this line.',
    messageTradeAgreementsReasonNotAlternate: 'SPA costs can only be selected on an alternate version quote.',
    messageTradeAgreementsReasonOmitted: 'This line is omitted from the quote.',
    messageTradeAgreementsReasonSelectionUnknown: 'No SPA selection is known for this line yet. Re-price it first.',
    messageTradeAgreementsReasonSubstituted: 'This line has been substituted by an alternate.',
    messageTrySomethingNew: 'Try something new!',
    messageVendorCreatedSuccess: 'Vendor has been successfully created.',
    messageVendorCreateInProgress: 'Creating vendor.',
    messageVendorQuoteImportNumber: 'The vendor quote number could not be read from the file.',
    messageVendorQuoteImportVendor: 'Select the vendor this quote came from.',
    messageVendorQuoteImportVendorMapped: 'Set by the vendor mapping for this document type.',
    messageVendorQuoteImportVendorRemembered: 'It will be remembered for the next import of the same document type.',
    messageVendorQuoteNumberRequired: 'Vendor Quote Number is required',
    messageVendorsRemovedSuccess_one: 'Vendor has been successfully removed.',
    messageVendorsRemovedSuccess_other: '{{count}} vendors have been successfully removed.',
    messageVendorsRemoveInProgress_one: 'Removing vendor.',
    messageVendorsRemoveInProgress_other: 'Removing vendors.',
    messageVendorUpdatedSuccess: 'Vendor updated successfully',
    messageVendorUpdateInProgress: 'Updating vendor.',

    // Prefixes
    prefixCostNote: 'Cost Note:',

    // Success Messages
    messageAccessCreateSuccess: 'Access has been successfully created.',
    messageAccessRemoveSuccess_one: 'Access has been successfully removed.',
    messageAccessRemoveSuccess_other: '{{count}} accesses have been successfully removed.',
    messageAccessUpdateSuccess: 'Access has been successfully updated.',
    messageAddPnbVariationsSuccess: 'PNB variations have been successfully added.',
    messageAddressCreateSuccess: 'Address has been successfully created.',
    messageAddressUpdateSuccess: 'Address has been successfully updated.',
    messageAdminUserCreateSuccess: 'Admin user has been successfully created.',
    messageAdminUserRemoveSuccess_one: 'Admin user has been successfully removed.',
    messageAdminUserRemoveSuccess_other: '{{count}} admin users have been successfully removed.',
    messageAdminUserUpdateSuccess: 'Admin user has been successfully updated.',
    messageApplyCostDiscountSuccess: 'Cost discount has been successfully applied.',
    messageApprovedVendorRemoveSuccess: 'Approved vendor association has been successfully removed.',
    messageApprovedVendorUpdateSuccess: 'Approved vendor association has been successfully updated.',
    messageCalculatePricingSuccess: 'Cost and price have been successfully calculated.',
    messageCompanyPartUpdateSuccess: 'Company part has been successfully updated.',
    messageComponentCreateSuccess: 'Component has been successfully created.',
    messageComponentsCreateSuccess_one: 'Component has been successfully created.',
    messageComponentsCreateSuccess_other: 'Components have been successfully created.',
    messageComponentsUpdateSuccess_one: 'Component has been successfully updated.',
    messageComponentsUpdateSuccess_other: 'Components have been successfully updated.',
    messageComponentTemplateCreateSuccess: 'Component template line has been successfully created.',
    messageComponentTemplatesRemoveSuccess_one: 'Component template line has been successfully removed.',
    messageComponentTemplatesRemoveSuccess_other: '{{count}} component template lines have been successfully removed.',
    messageComponentTemplateUpdateSuccess: 'Component template line has been successfully updated.',
    messageComponentUpdateSuccess: 'Component has been successfully updated.',
    messageContactCreateSuccess: 'Contact has been successfully created.',
    messageContactGroupAddressMergeSuccess: 'Locations have been successfully merged.',
    messageContactGroupAddressRemoveSuccess: 'Location has been successfully removed.',
    messageContactGroupAddressSaveSuccess: 'Location has been successfully saved.',
    messageContactGroupAddressUpdateSuccess: 'Location has been successfully updated.',
    messageContactGroupCreateSuccess: 'Company has been successfully created.',
    messageContactGroupDefaultPricingUpdateInProgress: 'Updating default pricing.',
    messageContactGroupDefaultPricingUpdateSuccess: 'Default pricing has been successfully updated.',
    messageContactGroupMergeSuccess: 'Companies have been successfully merged.',
    messageContactGroupUpdateSuccess: 'Company has been successfully updated.',
    messageContactOwnerUpdateSuccess: 'Contact owner has been successfully updated.',
    messageContactRemoveSuccess: 'Contact has been successfully removed.',
    messageContactRestoreSuccess: 'Contact has been successfully restored.',
    messageContactUpdateSuccess: 'Contact has been successfully updated.',
    messageCorporateUserVersionChangeSuccess: 'The version has been successfully saved.',
    messageCostingCalculationCreateSuccess: 'Costing calculation has been successfully created.',
    messageCostingCalculationsRemoveSuccess_one: 'Costing calculation has been successfully removed.',
    messageCostingCalculationsRemoveSuccess_other: 'Costing calculations have been successfully removed.',
    messageCostingCalculationUpdateSuccess: 'Costing calculation has been successfully updated.',
    messageCostingCalculationUpsertSuccess: 'Costing calculation has been successfully saved.',
    messageCostingProfileCreateSuccess: 'Costing profile has been successfully created.',
    messageCostingProfilesRemoveSuccess_one: 'Costing profile has been successfully removed.',
    messageCostingProfilesRemoveSuccess_other: 'Costing profiles have been successfully removed.',
    messageCostingProfilesUpdateSuccess: 'Costing profiles have been successfully updated.',
    messageCostingProfileUpdateSuccess: 'Costing profile has been successfully updated.',
    messageCreatePasswordSuccess: 'Password successfully set up.',
    messageCustomTableFilterCreateSuccess: 'Custom filter set has been successfully created.',
    messageCustomTableFilterRemoveSuccess: 'Custom filter set has been successfully removed.',
    messageCustomTableFilterUpdateSuccess: 'Custom filter set has been successfully updated.',
    messageCustomTableLayoutCreateSuccess: 'Custom table layout has been successfully created.',
    messageCustomTableLayoutRemoveSuccess: 'Custom layout successfully removed.',
    messageCustomTableLayoutUpdateSuccess: 'Custom table layout has been successfully updated.',
    messageDataImportSuccess: 'Data has been successfully imported.',
    messageDefaultDatasheetUpdateSuccess: 'Default datasheet has been successfully updated.',
    messageDefaultImageUpdateSuccess: 'Default image has been successfully updated.',
    messageDetachVendorQuoteFromProjectSuccess_one: 'Quote has been successfully detached from project.',
    messageDetachVendorQuoteFromProjectSuccess_other: 'Quotes have been successfully detached from project.',
    messageDetachVendorQuoteSuccess_one: 'Quote has been successfully detached.',
    messageDetachVendorQuoteSuccess_other: 'Quotes have been successfully detached.',
    messageDiscountedPartsFetchSuccess: 'Discounted parts have been successfully fetched.',
    messageElementComponentNoteCreateSuccess: 'Element component note has been successfully created.',
    messageElementComponentNotesCreateSuccess_one: 'Element component note has been successfully created.',
    messageElementComponentNotesCreateSuccess_other: 'Element component notes have been successfully created.',
    messageElementComponentNotesRemoveSuccess_one: 'Element component note has been successfully removed.',
    messageElementComponentNotesRemoveSuccess_other: 'Element component notes have been successfully removed.',
    messageElementComponentNotesUpdateSuccess_one: 'Element component note has been successfully updated.',
    messageElementComponentNotesUpdateSuccess_other: 'Element component notes have been successfully updated.',
    messageElementComponentNoteUpdateSuccess: 'Element component note has been successfully updated.',
    messageElementCreateSuccess: 'Element has been successfully created.',
    messageElementSaveAsTemplateSuccess: 'Element was successfully saved as template: <strong>{{templateDescription}}</strong>.',
    messageElementTemplateAddToJobSuccess: 'Element template has been successfully added to job.',
    messageElementTemplateCreateSuccess: 'Element template has been successfully created.',
    messageElementTemplatesRemoveInProgress_one: 'Removing element template...',
    messageElementTemplatesRemoveInProgress_other: 'Removing {{count}} element templates...',
    messageElementTemplatesRemoveSuccess_one: 'Element template removed successfully.',
    messageElementTemplatesRemoveSuccess_other: '{{count}} element templates removed successfully.',
    messageElementTemplateUpdateSuccess: 'Element template has been successfully updated.',
    messageElementUpdateSuccess: 'Element has been successfully updated.',
    messageExtractorVendorMappingCreateSuccess: 'Mapping has been successfully created.',
    messageExtractorVendorMappingRemoveSuccess_one: 'Mapping has been successfully removed.',
    messageExtractorVendorMappingRemoveSuccess_other: 'Mappings have been successfully removed.',
    messageExtractorVendorMappingUpdateSuccess: 'Mapping has been successfully updated.',
    messageGenerateExportFileSuccess: 'Export file successfully generated.',
    messageGenerateExportFileTypeSuccess: '{{fileType}} file successfully generated.',
    messageGenerateExportSkuPartsSuccess: 'Export SKU Parts file successfully generated.',
    messageGenerateExportSuccess: 'Export successfully generated.',
    messageGenerateJobLogExportSuccess: 'Time log export file successfully generated.',
    messageGeneratePartExportSuccess: '{{fileType}} file successfully generated.',
    messageGeneratePartsDatasheetArchiveSuccess: 'Datasheet archive successfully generated.',
    messageImpersonateUserSuccess: 'Successfully impersonated as {{name}}.',
    messageImportPartsStatusSuccess_one: '{{ count }} part has been successfully imported.',
    messageImportPartsStatusSuccess_other: '{{ count }} parts have been successfully imported.',
    messageInvitationRevokedSuccess: 'Access has been successfully revoked.',
    messageInvitationSentSuccess: 'Invitation has been successfully sent.',
    messageJobCreateSuccess: 'Job has been successfully created.',
    messageJobNameUpdateSuccess: 'Job name has been successfully updated.',
    messageJobPartComponentAddSuccess: 'Component name has been successfully added.',
    messageJobPartComponentRemoveSuccess: 'Component name has been successfully removed.',
    messageJobPartComponentUpdateSuccess: 'Component name has been successfully updated.',
    messageJobPartLineCreateSuccess: 'Line has been successfully created.',
    messageJobPartLinesRemoveSuccess_one: 'Line has been successfully removed.',
    messageJobPartLinesRemoveSuccess_other: 'Lines have been successfully removed.',
    messageJobPartLinesRestoreSuccess_one: 'Line has been successfully restored.',
    messageJobPartLinesRestoreSuccess_other: 'Lines have been successfully restored.',
    messageJobPartLineUpdateSuccess: 'Line has been successfully updated.',
    messageJobPartNoteCreateSuccess: 'Note has been successfully created.',
    messageJobPartNotesCreateSuccess: 'Notes have been successfully created.',
    messageJobPartNotesRemoveSuccess_one: 'Note has been successfully removed.',
    messageJobPartNotesRemoveSuccess_other: '{{count}} notes have been successfully removed.',
    messageJobPartNoteUpdateSuccess: 'Note has been successfully updated.',
    messageJobPartsAddToJobSuccess_one: 'Part have been successfully added to job <strong>{{jobName}}</strong>.',
    messageJobPartsAddToJobSuccess_other: 'Parts have been successfully added to job <strong>{{jobName}}</strong>.',
    messageJobPartsImportSuccess_one: '{{count}} part has been successfully imported.',
    messageJobPartsImportSuccess_other: '{{count}} parts have been successfully imported.',
    messageJobUpdateSuccess_one: 'Job has been successfully updated.',
    messageJobUpdateSuccess_other: 'Jobs have been successfully updated.',
    messageLineChangeSuccess: 'Line has been successfully changed.',
    messageLineCreatingSuccess: 'Line has been successfully created.',
    messageLineDuplicateSuccess_one: 'Line has been successfully duplicated.',
    messageLineDuplicateSuccess_other: 'Lines have been successfully duplicated.',
    messageLineNoteCreateSuccess: 'Line note has been successfully created.',
    messageLineNoteRemoveSuccess: 'Line note has been successfully removed.',
    messageLineNotesCreateSuccess_one: 'Line note has been successfully created.',
    messageLineNotesCreateSuccess_other: 'Line notes have been successfully created.',
    messageLineNotesRemoveNoMatch: 'No matching line notes found.',
    messageLineNotesRemoveSuccess_one: 'Line note has been successfully removed.',
    messageLineNotesRemoveSuccess_other: '{{count}} line notes have been successfully removed.',
    messageLineNoteUpdateSuccess: 'Line note has been successfully updated.',
    messageLinesMoveToSuccess_one: 'Line has been successfully moved.',
    messageLinesMoveToSuccess_other: 'Lines have been successfully moved.',
    messageLinesRemoveSucces_one: 'Line has been successfully removed.',
    messageLinesRemoveSucces_other: 'Lines have been successfully removed.',
    messageLinesReorderSuccess: 'Lines have been successfully reordered.',
    messageLinesUpdateSuccess_one: 'Line has been successfully updated.',
    messageLinesUpdateSuccess_other: 'Lines have been successfully updated.',
    messageLogCreateSuccess: 'Log time has been successfully created.',
    messageLogsCreateSuccess_one: 'Log time has been successfully created.',
    messageLogsCreateSuccess_other: 'Log times have been successfully created.',
    messageLogsRemoveSuccess_one: 'Log time has been successfully removed.',
    messageLogsRemoveSuccess_other: 'Log times have been successfully removed.',
    messageLogsUpdateSuccess_one: 'Log time has been successfully updated.',
    messageLogsUpdateSuccess_other: 'Log times have been successfully updated.',
    messageLogUpdateSuccess: 'Log time has been successfully updated.',
    messageMaxLineNumber: 'Max line number: {{maxLineNumber}}.',
    messageMaxQtyGreaterThanMinQty: 'Max quantity must be greater than min quantity.',
    messageNoteSaveSuccess: 'Note successfully added.',
    messageOrderCreateSuccess: 'Order has been successfully created.',
    messageOrderSubmitSuccess: 'Order has been successfully submitted.',
    messageOrderSubmitSuccessExternal: 'Order has been successfully submitted.',
    messageOrderSubmitSuccessExternalWithExternalOrderNumber: 'Order has been successfully submitted. External order number: <strong>{{externalOrderNumber}}</strong>.',
    messagePartBomCreateSuccess: 'Part BOM has been successfully created.',
    messagePartBomItemCreateSuccess: 'Part BOM line has been successfully created.',
    messagePartBomItemNoteCreateSuccess: 'Part BOM line note has been successfully created.',
    messagePartBomItemNotesRemoveSuccess_one: 'Part BOM line note has been successfully removed.',
    messagePartBomItemNotesRemoveSuccess_other: 'Part BOM line notes have been successfully removed.',
    messagePartBomItemNoteUpdateSuccess: 'Part BOM line note has been successfully updated.',
    messagePartBomItemUpdateSuccess: 'Part BOM line has been successfully updated.',
    messagePartBomRemoveSuccess: 'Part BOM has been successfully removed.',
    messagePartBomUpdateSuccess: 'Part BOM has been successfully updated.',
    messagePartCopySuccess: 'Part has been successfully copyed.',
    messagePartCostCreateSuccess: 'Part cost has been successfully created.',
    messagePartCostsRemoveSuccess_one: 'Part cost has been successfully removed.',
    messagePartCostsRemoveSuccess_other: 'Part costs have been successfully removed.',
    messagePartCostUpdateSuccess: 'Part cost has been successfully updated.',
    messagePartFinderAttributeDraftDiscarded:
      'The value list matches its published version, so no draft was kept.',
    messagePartFinderAttributePublishSuccess: 'Value list published.',
    messagePartFinderAttributeSaveSuccess: 'Value list saved as draft.',
    messagePartFinderAttributesRemoveSuccess_one: 'Value list removed.',
    messagePartFinderAttributesRemoveSuccess_other: '{{count}} value lists removed.',
    messagePartFinderFamiliesPublishSuccess_one: 'Family published.',
    messagePartFinderFamiliesPublishSuccess_other: '{{count}} families published.',
    messagePartFinderFamiliesRemoveSuccess_one: 'Family removed.',
    messagePartFinderFamiliesRemoveSuccess_other: '{{count}} families removed.',
    messagePartFinderFamiliesUnpublishSuccess_one: 'Family unpublished.',
    messagePartFinderFamiliesUnpublishSuccess_other: '{{count}} families unpublished.',
    messagePartFinderFamilyPublishSuccess: 'Family published.',
    messagePartFinderFamilySaveSuccess: 'Family saved as draft.',
    messagePartFinderProductTypePublishSuccess: 'Product type published.',
    messagePartFinderProductTypeSaveSuccess: 'Product type saved as draft.',
    messagePartFinderProductTypesRemoveSuccess_one: 'Product type removed.',
    messagePartFinderProductTypesRemoveSuccess_other: '{{count}} product types removed.',
    messagePartMediaFileDescriptionUpdateSuccess:
      'File description has been successfully updated.',
    messagePartMediaFileRemoveSuccess: 'File has been successfully removed.',
    messagePartMoveSuccess: 'Part has been successfully moved.',
    messagePartNumbersRemoveSuccess_one: 'Fixed price has been successfully removed.',
    messagePartNumbersRemoveSuccess_other: 'Fixed prices have been successfully removed.',
    messagePartNumbersUpsertSuccess: 'Fixed price has been successfully saved.',
    messagePartParticularsSaveSuccess: 'Part particulars have been successfully saved.',
    messagePartPriceCreateSuccess: 'Part price has been successfully created.',
    messagePartPricesRemoveSuccess_one: 'Part price has been successfully removed.',
    messagePartPricesRemoveSuccess_other: 'Part prices have been successfully removed.',
    messagePartPriceUpdateSuccess: 'Part price has been successfully updated.',
    messagePartsAddingSuccess_one: 'Part has been successfully added.',
    messagePartsAddingSuccess_other: 'Parts have been successfully added.',
    messagePartSaveSuccess: 'Part has been successfully saved.',
    messagePartVideoRemoveSuccess: 'Video has been successfully removed.',
    messagePartVideoSaveSuccess: 'Video has been successfully saved.',
    messagePricingProfileCreateInProgress: 'Creating pricing profile.',
    messagePricingProfileCreateSuccess: 'Pricing profile has been successfully created.',
    messagePricingProfileDocumentRemoveSuccess: 'Pricing profile document has been successfully removed.',
    messagePricingProfileDocumentSaveSuccess: 'Pricing profile document has been successfully uploaded.',
    messagePricingProfileRuleCreateSuccess: 'Pricing profile rule has been successfully created.',
    messagePricingProfileRulesRemoveSuccess_one: 'Pricing profile rule has been successfully removed.',
    messagePricingProfileRulesRemoveSuccess_other: 'Pricing profile rules have been successfully removed.',
    messagePricingProfileRuleUpdateSuccess: 'Pricing profile rule has been successfully updated.',
    messagePricingProfileRuleUpsertSuccess: 'Pricing profile rule has been successfully saved.',
    messagePricingProfilesRemoveSuccess_one: 'Pricing profile has been successfully removed.',
    messagePricingProfilesRemoveSuccess_other: 'Pricing profiles have been successfully removed.',
    messagePricingProfilesUpdateInProgress: 'Updating pricing profiles.',
    messagePricingProfilesUpdateSuccess: 'Pricing profiles have been successfully updated.',
    messagePricingProfileUpdateInProgress: 'Updating pricing profile.',
    messagePricingProfileUpdateSuccess: 'Pricing profile has been successfully updated.',
    messagePricingResetRequired: 'Detaching vendor quotes from the project may impact the pricing of parts within the related quotes. We recommend resetting the pricing to ensure accurate cost calculations.',
    messagePrioritizeLegacyCostOff:
      'Click to Prioritize Vendor Quote — your entered cost will be used for pricing instead of the external standard cost',
    messagePrioritizeLegacyCostOn:
      'Vendor Quote cost is prioritized — click to revert to external standard cost',
    messageProjectCreateSuccess: 'Project has been successfully created.',
    messageProjectCustomerAddInProgress: 'Adding customer to pricing profile.',
    messageProjectCustomerAddSuccess: 'Customer has been successfully added.',
    messageProjectCustomerRemoveInProgress: 'Removing customer from pricing profile.',
    messageProjectCustomerRemoveSuccess: 'Customer has been successfully removed.',
    messageProjectPricingProfileAddInProgress: 'Adding pricing profile to project.',
    messageProjectPricingProfileAddSuccess: 'Pricing profile has been successfully added to project.',
    messageProjectPricingProfileCreateInProgress: 'Creating pricing profile.',
    messageProjectPricingProfileCreateSuccess: 'Pricing profile has been successfully created and added to project.',
    messageProjectPricingProfileRemoveInProgress_one: 'Removing pricing profile from project.',
    messageProjectPricingProfileRemoveInProgress_other: 'Removing pricing profiles from project.',
    messageProjectPricingProfileRemoveSuccess_one: 'Pricing profile has been successfully removed from project.',
    messageProjectPricingProfileRemoveSuccess_other: 'Pricing profiles have been successfully removed from project.',
    messageProjectUpdateSuccess: 'Project has been successfully updated.',
    messageProjectUserSaveSuccess: 'User has been successfully created.',
    messageProjectUsersRemoveSuccess_one: 'User has been successfully removed.',
    messageProjectUsersRemoveSuccess_other: 'Users have been successfully removed.',
    messageProjectUserUpdateSuccess: 'User has been successfully updated.',
    messageQuoteCreateSuccess: '{{entityType}} has been successfully created.',
    messageQuoteFileAttachSuccess: '{{entityType}} file has been successfully attached.',
    messageQuoteFileDetachSuccess: '{{entityType}} file has been successfully detached.',
    messageQuoteFound: 'Quote found.',
    messageQuoteNoteCreateSuccess: '{{entityType}} note has been successfully created.',
    messageQuoteNoteSaveSuccess: '{{entityType}} note has been successfully saved.',
    messageQuoteNoteUpdateSuccess: '{{entityType}} note has been successfully updated.',
    messageQuotePartAddToPricingProfileSuccess_one: '{{entityType}} part has been successfully added to the pricing profile.',
    messageQuotePartAddToPricingProfileSuccess_other: '{{entityType}} parts have been successfully added to the pricing profile.',
    messageQuotesArchiveSuccess_one: '{{entityType}} has been successfully archived.',
    messageQuotesArchiveSuccess_other: '{{entityType}}s have been successfully archived.',
    messageQuotesCreateSuccess: '{{entityType}}s have been successfully created.',
    messageQuoteSendToFileNetSuccess: 'Quote has been successfully sent to FileNet.',
    messageQuoteSendToVendorSuccess: 'Quote has been successfully sent to Vendor.',
    messageQuotesReassignSuccess_one: '{{entityType}} has been successfully reassigned.',
    messageQuotesReassignSuccess_other: '{{entityType}}s have been successfully reassigned.',
    messageQuotesRestoreSuccess_one: '{{entityType}} has been successfully restored.',
    messageQuotesRestoreSuccess_other: '{{entityType}}s have been successfully restored.',
    messageQuotesUpdateSuccess_one: '{{entityType}} has been successfully updated.',
    messageQuotesUpdateSuccess_other: '{{entityType}}s have been successfully updated.',
    messageQuoteToProjectAttachSuccess: 'Quote has been successfully attached to project.',
    messageQuoteToQuoteAttachSuccess_one: 'Quote has been successfully attached.',
    messageQuoteToQuoteAttachSuccess_other: 'Quotes have been successfully attached.',
    messageQuoteUpdateSuccess: '{{entityType}} has been successfully updated.',
    messageQuoteVersionDataCreateSuccess: '{{entityType}} freight has been successfully created.',
    messageQuoteVersionDataSaveSuccess: '{{entityType}} freight has been successfully saved.',
    messageQuoteVersionDataUpdateSuccess: '{{entityType}} freight has been successfully updated.',
    messageReattachVendorQuoteSuccess_one: 'Quote has been successfully reattached.',
    messageReattachVendorQuoteSuccess_other: 'Quotes have been successfully reattached.',
    messageResetPricingTypeSuccess_one: '{{type}} has been successfully reset.',
    messageResetPricingTypeSuccess_other: '{{type}} have been successfully reset.',
    messageSetUpAccountSuccess: 'Account successfully set up.',
    messageUomConversionAuditBulkSetUpSuccess_one: '{{count}} company part created, {{updated}} updated.',
    messageUomConversionAuditBulkSetUpSuccess_other: '{{count}} company parts created, {{updated}} updated.',
    messageUomConversionAuditBulkSetUpSuccessWithSkipped_one:
      '{{count}} company part created, {{updated}} updated. {{skipped}} skipped — no manufacturer.',
    messageUomConversionAuditBulkSetUpSuccessWithSkipped_other:
      '{{count}} company parts created, {{updated}} updated. {{skipped}} skipped — no manufacturer.',
    messageUomConversionAuditBulkUpdateSuccess_one: '{{count}} part updated.',
    messageUomConversionAuditBulkUpdateSuccess_other: '{{count}} parts updated.',
    messageUomConversionAuditBulkUpdateSuccessWithSkipped_one:
      '{{count}} part updated. {{skipped}} skipped — no company catalogue entry to assign UOMs to.',
    messageUomConversionAuditBulkUpdateSuccessWithSkipped_other:
      '{{count}} parts updated. {{skipped}} skipped — no company catalogue entry to assign UOMs to.',
    messageUomConversionCreatingSuccess: 'UOM conversion has been successfully created.',
    messageUomConversionsRemovingSuccess: 'UOM conversions have been successfully removed.',
    messageUomConversionUpdatingSuccess: 'UOM conversion has been successfully updated.',
    messageUserSettingSaveSuccess: 'User setting has been successfully saved.',
    messageVendorQuoteDetailsUpdateSuccess: 'Quote details have been successfully updated.',
    messageVendorQuoteImportSuccess: 'Vendor Quote has been successfully imported.',
    messageVendorQuotesAttachSuccess_one: 'Vendor quote has been successfully attached.',
    messageVendorQuotesAttachSuccess_other: '{{count}} vendor quotes have been successfully attached.',
    messageVendorQuotesDetachSuccess_one: 'Vendor quote has been successfully detached.',
    messageVendorQuotesDetachSuccess_other: '{{count}} vendor quotes have been successfully detached.',

    // Notes
    noteImportCostsDiffered: 'costs differed — kept {{kept}}',
    noteImportPricesDiffered: 'prices differed — kept {{kept}}',
    noteImportQuoteLineMatch: 'Will update line {{targetLine}}.',
    noteImportQuoteLineMatches:
      'This part exists on lines {{lines}} and {{lastLine}}; line {{targetLine}} will be updated, the others left unchanged.',
    noteImportRowsCombined: '{{rowCount}} rows combined',

    // Titles
    titleAddAdminUser: 'Add Admin User',
    titleAddAlternateLine: 'Add Alternate Line',
    titleAddComponent: 'Add Component',
    titleAddComponentName: 'Add Component Name',
    titleAddContact: 'Add Contact',
    titleAddContactGroupByEmailOtherTypeFound: '{{contactGroupType}} Company Found',
    titleAddCostingCalculation: 'Add Costing Calculation',
    titleAddCustomer: 'Add Customer',
    titleAddDiscountRule: 'Add Discount Rule',
    titleAddElement: 'Add Element',
    titleAddElementTemplate: 'Add Element Template',
    titleAddElementTemplateToJob: 'Add Element Template to Job',
    titleAddElementViewByPartInfo: 'Change the "View By" to see added elements.',
    titleAddExtractorVendorMapping: 'Add Mapping',
    titleAddFilter: 'Add Filter Set',
    titleAddJobs: 'Add Jobs',
    titleAddLine: 'Add Line',
    titleAddLocation: 'Add Location',
    titleAddLog: 'Log Time',
    titleAddManufacturer: 'Add Manufacturer',
    titleAddMarginRule: 'Add Margin Rule',
    titleAddNote: 'Add Note',
    titleAddPart: 'Add Part',
    titleAddPartBom: 'Add Part BoM',
    titleAddPartBomDetails: 'Details',
    titleAddPartBomItem: 'Add Line to Part BoM',
    titleAddPartBomTaxonomy: 'Taxonomy',
    titleAddPartCost: 'Create Part Cost',
    titleAddPartFinderAttribute: 'Add Value List',
    titleAddPartFinderFamily: 'Add Part Finder Family',
    titleAddPartNumber: 'Add Part Number',
    titleAddPartPrice: 'Create Part Price',
    titleAddParts: 'Add Parts',
    titleAddPartsToPartBom: 'Add Parts',
    titleAddPricingProfileAccess: 'Add Access',
    titleAddPricingProfilePartNumber: 'Add Fixed Price',
    titleAddProjectPricingProfile: 'Add Pricing Profile',
    titleAddProjectUser: 'Add User',
    titleAddToJob: 'Add to Job',
    titleAddToPricingProfile: 'Add to Pricing Profile',
    titleAddToQuote: 'Add to {{quoteType}} {{entityType}}',
    titleAddToVendorQuote: 'Add to Vendor Quote',
    titleAddUomConversion: 'Add UOM Conversion',
    titleAddVariations: 'Add Variations',
    titleAddVendor: 'Add Vendor',
    titleAlertRemoveDefaultApprovedVendor: 'Unable to Remove the Default Approved Vendor',
    titleAllowedDecimals: 'Allowed decimals: {{decimals}}.',
    titleApplyCostDiscount: 'Apply Cost Discount',
    titleApplySelectedSpaToLines: 'Apply to all eligible lines?',
    titleApprovedVendors: 'Approved Vendors',
    titleArchiveQuote_one: 'Archive {{entityType}}',
    titleArchiveQuote_other: 'Archive {{entityType}}s',
    titleAssignManufacturer: 'Assign Manufacturer',
    titleAssignManufacturers: 'Assign Manufacturers',
    titleAssignVendor: 'Assign Vendor',
    titleAttachContactGroupDomain: 'Add Domain to Company?',
    titleAttachExistingVendorQuote: 'Attach Existing Vendor Quote',
    titleAttributes: 'Attributes',
    titleBaseInformation: 'Base Information',
    titleBellNotificationExternalOrderStatusChanged: 'Order #{{displayNumber}} external status changed',
    titleBellNotificationGeneric: 'New notification',
    titleBellNotificationOrderSubmissionFailed: 'Order #{{displayNumber}} failed to submit',
    titleBellNotificationOrderSubmissionTimedOut: 'Order #{{displayNumber}} submission timed out',
    titleBellNotificationOrderSubmitted: 'Order #{{displayNumber}} was submitted',
    titleBellNotificationOrderSubmitting: 'Order #{{displayNumber}} is being submitted',
    titleBellNotificationOrderUpdated: 'Order #{{displayNumber}} was updated',
    titleBellNotificationOrderUpdateReceived: 'Order #{{displayNumber}} update received',
    titleBillOfMaterials: 'Bill of Materials, Job #{{jobId}}',
    titleBillTo: 'Bill To',
    titleBulkExportSkuParts: 'Export SKU Parts',
    titleBulkExportSkuPartsBlockers: 'Must Fix Before Export',
    titleBulkExportSkuPartsOmits: 'Will Be Skipped',
    titleBulkSendAsSpa: 'Send as SPA',
    titleBulkSendAsSpaAlreadySent: 'Already Sent',
    titleBulkSendAsSpaBlockers: 'Must Fix Before Sending',
    titleBulkSendAsSpaOmits: 'Will Be Skipped',
    titleBulkSendAsSpaResends: 'Will Be Resent',
    titleBulkSetUpCompanyParts: 'Edit Company Part Details',
    titleBulkUomConversions: 'Add UOM Conversions',
    titleBulkUpdateUoms: 'Update UOMs',
    titleCacheGroup_apcu: 'In-memory — every environment on this web server',
    titleCacheGroup_file: 'Cache files — this environment only',
    titleCacheGroup_integration: 'External systems — every environment',
    titleCacheGroup_redis: 'Redis — every environment',
    titleCacheGroupFileWithEnvironment: 'Cache files — this environment only ({{environment}})',
    titleCalculateConfiguredPricing: 'Calculate Configured Pricing',
    titleCalculatePricing: 'Calculate Pricing',
    titleCancelConsumerJobsConfirm: 'Cancel jobs?',
    titleChangeContactGrouping: 'Change Contact Group',
    titleChangeOwner: 'Change Owner',
    titleChangePricingToManual: 'Change Pricing to "Manual"',
    titleChangeSupportRequestLevel: 'Change Support Request Level',
    titleClearCacheConfirm: 'Clear cache?',
    titleCompanies: 'Companies',
    titleCompareView: 'Compare view',
    titleConfigureTheAttributes: 'Configure the Attributes',
    titleConsumerRestartConfirm: 'Restart consumers?',
    titleConsumerRestartJobs: 'Queued & Running CLI Jobs',
    titleConsumerRestartTargets: 'Consumer Environments',
    titleContact: 'Contact',
    titleContactDetailsWithName: '{{name}} Details',
    titleContactEmail: 'Contact Email',
    titleContactGroupAlreadyExists: 'This company already exists.',
    titleContactGroupDetails: 'Company Details',
    titleContactGroupDetailsWithName: '{{name}} Details',
    titleContactGroupDomainMismatch: 'Domain Mismatch',
    titleContacts: 'Contacts',
    titleCopyMoveNotAllowed: 'Copy or Move Not Allowed',
    titleCopyMoveToElement: 'Copy or Move to Element',
    titleCopyOrMoveToElement: 'Copy or Move to Element',
    titleCosting: 'Costing',
    titleCostingProfileDetails: 'Costing Profile - {{name}} Details',
    titleCostingProfiles: 'Costing Profiles',
    titleCosts: 'Costs',
    titleCreateCompanyPart: 'Create Company Part',
    titleCreateCostingProfile: 'Create Costing Profile',
    titleCreateCustomerQuote: 'Create New Customer {{entityType}}',
    titleCreatedAt: 'Created At: {{date}}',
    titleCreatedByUserName: 'Created By: {{name}}',
    titleCreateElementTemplate: 'Create Element Template',
    titleCreateJob: 'Create Job',
    titleCreateNameFamily: 'Create Name Family',
    titleCreateNewQuoteAndSelectItemsToCopy: 'Create New {{entityType}} and Select Items to Copy',
    titleCreateNote: 'Create Note',
    titleCreateOrder: 'Create Order',
    titleCreatePartFinderProductType: 'Create Product Type',
    titleCreatePassword: 'Create Your Password',
    titleCreatePricingProfile: 'Create Pricing Profile',
    titleCreateProject: 'Create Project',
    titleCreateProjectPricingProfile: 'Create Pricing Profile',
    titleCreateVendorQuote: 'Create New Vendor {{entityType}}',
    titleCreditHoldConfirmation: 'Credit hold',
    titleCustomerContacts: 'Customer Contacts',
    titleCustomerOrderParts: 'Order #{{quoteId}} - Parts',
    titleCustomerOrders: 'Customer Orders',
    titleCustomerPartNumber: 'C: {{customerPartNumber}}',
    titleCustomerQuote: 'Customer {{entityType}} #{{id}} - v{{version}}',
    titleCustomerQuotes: 'Customer Quotes',
    titleCustomers: 'Customers',
    titleDashboard: 'Dashboard',
    titleDefaultLocations: 'Default Locations',
    titleDefineAttributesOrder: 'Define Attributes Order',
    titleDefineValuesOrder: 'Define Values Order',
    titleDetachVendorQuotes_one: 'Detach Vendor Quote',
    titleDetachVendorQuotes_other: 'Detach Vendor Quotes',
    titleDetails: 'Details',
    titleDocuments: 'Documents',
    titleDownloadBomPartsXLS: 'Download BoM Parts XLS',
    titleDuplicateLine_one: 'Copy Line',
    titleDuplicateLine_other: 'Copy Lines',
    titleDuplicateQuote: 'Duplicate {{entityType}} #{{id}}',
    titleDuration: 'Duration',
    titleEditAttribute: 'Edit Attribute',
    titleEditBillToAddress: 'Edit Bill To Address',
    titleEditComponentName: 'Edit Component Name',
    titleEditContact: 'Edit Contact',
    titleEditContactGroup: 'Edit Contact Group',
    titleEditContactGroupAddress: 'Edit Contact Address',
    titleEditCustomer: 'Edit Customer',
    titleEditCustomerQuote: 'Update Customer {{entityType}}',
    titleEditDefaultPricing: 'Edit Default Pricing',
    titleEditExtractorVendorMapping: 'Edit Mapping',
    titleEditFilter: 'Edit Filter Set',
    titleEditGroup: 'Edit Group',
    titleEditJobBaseInformation: 'Edit Job Base Information',
    titleEditJobs: 'Edit Jobs',
    titleEditLocation: 'Edit Location',
    titleEditNote: 'Edit Note',
    titleEditPartBom: 'Update Part BoM',
    titleEditPartBomItem: 'Update Line',
    titleEditPartCost: 'Edit Part Cost',
    titleEditParticulars: 'Edit Particulars',
    titleEditPartPrice: 'Edit Part Price',
    titleEditProjectUser: 'Edit User',
    titleEditSettings: 'Edit Settings',
    titleEditShipToAddress: 'Edit Ship To Address',
    titleEditSoldToAddress: 'Edit Sold To Address',
    titleEditVendor: 'Edit Vendor',
    titleEditVendorQuoteDetails: 'Edit Quote Details',
    titleElementTemplateDetails: 'Element Template Details',
    titleElementTemplateDetailsWithName: 'Element Template - {{name}}',
    titleElementTemplates: 'Element Templates',
    titleEmployeeWarning: 'ISR/OSR Warning',
    titleEndActivePartCost: 'End Active Cost',
    titleEndActivePartPrice: 'End Active Price',
    titleError: 'An error occurred',
    titleExportSkuParts: 'Export SKU Parts',
    titleExportSkuPartsPreviewStep: 'Preview',
    titleExtractorVendorMapping: 'Extractor - Vendor Mapping',
    titleFileUploaded: 'File has been uploaded',
    titleFindAPartBom: 'Find a Part BoM',
    titleFindAPartNumber: 'Find a part number',
    titleGenericEmail: 'Generic Email entered',
    titleGlobalSearch: 'Search',
    titleGroupAttributes: 'Group Attributes',
    titleHint: 'Hint',
    titleHistory: 'History',
    titleHoldOnAMoment: 'Hold on a moment!',
    titleIdentifyManufacturers: 'Identify Manufacturers',
    titleImportBillOfMaterials: 'Import Bill of Materials',
    titleImportDetails: 'Import {{importId}}',
    titleImportFailedRows: 'Import Complete',
    titleImportFile: 'Import File',
    titleImportVendorQuote: 'Import Vendor Quote',
    titleInfo: 'Info',
    titleInformation: 'Information',
    titleInsideSalesRepresentative: 'Inside Sales Representative',
    titleInventory: 'Inventory',
    titleJobDetails: 'Job Details',
    titleJobDetailsDrawer: '{{name}} Details',
    titleJobDetailsWithName: '{{name}} - Job Details',
    titleJobId: 'Job #{{id}}',
    titleJobMaterials: '{{jobName}} - Materials',
    titleJobs: 'Jobs',
    titleLineDetails: 'Line Details',
    titleLineWarnings: 'Line Warnings',
    titleLocation: 'Location',
    titleLocations: 'Locations',
    titleLogTime: 'Log Time',
    titleMainInfo: 'Main Info',
    titleManageAttributes: 'Manage Attributes',
    titleManageCache: 'Manage Cache',
    titleManageConsumers: 'Manage Consumers',
    titleManageElements: 'Manage Elements',
    titleManageEmailDomains: 'Manage Email Domains',
    titleManageFreight: 'Manage Freight',
    titleManufacturer: 'Manufacturer',
    titleMapping: 'Mapping',
    titleMeasureConflict: 'Measure Conflict',
    titleMedia: 'Media',
    titleMergeContactGroups: 'Merge Companies',
    titleMergeLocations: 'Merge Locations',
    titleMoveTo: 'Move to',
    titleMoveToGroup: 'Move to Group',
    titleMultipleManufacturers: 'Multiple Manufacturers',
    titleNewAttribute: 'New Attribute',
    titleNotes: 'Notes',
    titleOrderFailedDetails: 'Order Failed Details',
    titleOrderPartValidationFailed: 'Validation Failed!',
    titleOrderStatusUpdate: 'Order Status Update',
    titleOrderWarnings: 'Order Warnings',
    titleOutsideSalesRepresentative: 'Outside Sales Representative',
    titleParentJob: 'Parent Job',
    titlePartBomDetails: '<strong>{{partBomNumber}}</strong> Details',
    titlePartBomList: 'All Part BoMs',
    titlePartDetails: '<strong>{{partNumber}}</strong> Details',
    titlePartEngineeringNumber: 'ENGINEERING: {{partEngineeringNumber}}',
    titlePartFamilyDetails: 'Part Family Details',
    titlePartFinderAttributes: 'Value List',
    titlePartFinderCatalog: 'Guided Search',
    titlePartFinderFamilies: 'Part Finder Family',
    titlePartFinderFilters: 'Filters',
    titlePartFinderProductTypes: 'Product Type',
    titlePartList: 'All Parts',
    titlePartOrderingNumber: 'ORDERING: {{partOrderingNumber}}',
    titlePartSetup: 'Part Setup',
    titlePayload: 'Payload',
    titlePersonalInformation: 'Personal Information',
    titlePipelineInformation: 'Pipeline Information',
    titlePreviewImport: 'Preview before Import',
    titlePrice: 'Price',
    titlePrices: 'Prices',
    titlePricingProfile: 'Pricing Profile',
    titlePricingProfileDetails: 'Pricing Profile - {{name}} Details',
    titlePricingProfiles: 'Pricing Profiles',
    titlePricingResetRequired: 'Pricing Reset Required',
    titleProjectDetails: 'Project Details',
    titleProjectDetailsDrawer: '{{name}} Details',
    titleProjectDetailsWithName: '{{name}} - Project Details',
    titleProjectName: 'Project: {{projectName}}',
    titleProjects: 'Projects',
    titleProspectQuote: 'Create Prospect Quote',
    titlePurchaseOrders: 'Purchase Orders',
    titleQuantity: 'Quantity: {{quantity}}',
    titleQuote: '{{quoteType}} {{entityType}} #{{id}} - v{{version}}',
    titleQuotedBy: 'Quoted By',
    titleQuoteDetails: '{{entityType}} #{{id}} - v{{version}} Details',
    titleQuotedTo: 'Quoted To',
    titleQuoteNoteAlreadyExists: 'The target quote {{noteType}} note already exists.',
    titleQuotePartExpiredCostingWarning: 'Your costs may be outdated.',
    titleQuoteParts: 'Quote #{{quoteId}} - Parts',
    titleReassignQuote_one: 'Reassign {{entityType}}',
    titleReassignQuote_other: 'Reassign {{entityType}}s',
    titleRecentCustomerOrders: 'Recent Customer Orders',
    titleRecentCustomerQuotes: 'Recent Customer Quotes',
    titleRecentVendorOrders: 'Recent Vendor Orders',
    titleRecentVendorQuotes: 'Recent Vendor Quotes',
    titleReleaseVersion: 'Release Version',
    titleRemoveComponent: 'Remove Component',
    titleRemoveContact_one: 'Remove Contact',
    titleRemoveContact_other: 'Remove Contacts',
    titleRemoveCostingCalculations_one: 'Remove Costing Calculation',
    titleRemoveCostingCalculations_other: 'Remove Costing Calculations',
    titleRemoveCostingProfiles_one: 'Remove Costing Profile',
    titleRemoveCostingProfiles_other: 'Remove Costing Profiles',
    titleRemoveCustomer_one: 'Remove Customer',
    titleRemoveCustomer_other: 'Remove Customers',
    titleRemoveDocument: 'Remove Document',
    titleRemoveElementTemplateParts_one: 'Remove Part',
    titleRemoveElementTemplateParts_other: 'Remove Parts',
    titleRemoveElementTemplates_one: 'Remove Element Template',
    titleRemoveElementTemplates_other: 'Remove Element Templates',
    titleRemoveExtractorVendorMapping_one: 'Remove Mapping',
    titleRemoveExtractorVendorMapping_other: 'Remove Mappings',
    titleRemoveLines_one: 'Remove Line',
    titleRemoveLines_other: 'Remove Lines',
    titleRemoveLocation: 'Remove Location {{locationName}}',
    titleRemoveLogs_one: 'Remove Log',
    titleRemoveLogs_other: 'Remove Logs',
    titleRemoveNotes: 'Remove Notes',
    titleRemovePartBom: 'Remove Part BoM',
    titleRemovePartBomItems_one: 'Remove line',
    titleRemovePartBomItems_other: 'Remove lines',
    titleRemovePartCosts_one: 'Remove Part Cost',
    titleRemovePartCosts_other: 'Remove Part Costs',
    titleRemovePartFinderAttributes_one: 'Remove Value List?',
    titleRemovePartFinderAttributes_other: 'Remove {{count}} Value Lists?',
    titleRemovePartFinderFamilies_one: 'Remove Family',
    titleRemovePartFinderFamilies_other: 'Remove Families',
    titleRemovePartFinderProductTypes_one: 'Remove Product Type?',
    titleRemovePartFinderProductTypes_other: 'Remove {{count}} Product Types?',
    titleRemovePartPrices_one: 'Remove Part Price',
    titleRemovePartPrices_other: 'Remove Part Prices',
    titleRemovePricingProfileAccess_one: 'Remove Access',
    titleRemovePricingProfileAccess_other: 'Remove Accesses',
    titleRemovePricingProfileAdminUser_one: 'Remove Admin User',
    titleRemovePricingProfileAdminUser_other: 'Remove Admin Users',
    titleRemovePricingProfilePartNumbers_one: 'Remove Fixed Price',
    titleRemovePricingProfilePartNumbers_other: 'Remove Fixed Prices',
    titleRemovePricingProfileRules_one: 'Remove Pricing Profile Rule',
    titleRemovePricingProfileRules_other: 'Remove Pricing Profile Rules',
    titleRemovePricingProfiles_one: 'Remove Pricing Profile',
    titleRemovePricingProfiles_other: 'Remove Pricing Profiles',
    titleRemoveProjectPricingProfile_one: 'Remove Pricing Profile',
    titleRemoveProjectPricingProfile_other: 'Remove Pricing Profiles',
    titleRemoveProjectUsers_one: 'Remove User',
    titleRemoveProjectUsers_other: 'Remove Users',
    titleRemoveRow: 'Remove Row',
    titleRemoveUomConversion: 'Remove UOM Conversion',
    titleRemoveVendor_one: 'Remove Vendor',
    titleRemoveVendor_other: 'Remove Vendors',
    titleRemoveVideo: 'Remove Video',
    titleReplaceSelectedSpa: 'Replace the selected SPA?',
    titleRequest: 'Request',
    titleRequirements: 'Requirements',
    titleResendAsSpa: 'Resend as SPA',
    titleResendEmailVerificationLink: 'Resend Email Verification Link',
    titleResetPricing: 'Reset Cost/Price',
    titleResetVersion: 'Start Over With Latest Released Version',
    titleResponse: 'Response',
    titleRestoreLines_one: 'Restore line',
    titleRestoreLines_other: 'Restore lines',
    titleRestoreQuote_one: 'Restore {{entityType}}',
    titleRestoreQuote_other: 'Restore {{entityType}}s',
    titleReusePriceConfirmation: 'Reuse price',
    titleSalesHistory: 'Sales History',
    titleSalesOrdersAllocated: 'Sales Orders Allocated',
    titleSalesOrdersBackOrdered: 'Sales Orders Back Ordered',
    titleSalesRepresentatives: 'Sales Representatives',
    titleSearchVendors: 'Search Vendors',
    titleSelectContact: 'Select {{contactType}}',
    titleSelectedSpaApplyDone: 'Apply to all eligible lines: done',
    titleSelectedSpaApplyResult: 'Apply to all eligible lines: results',
    titleSelectedSpaApplyStopped: 'Apply to all eligible lines: interrupted',
    titleSelectHeaderRow: 'Select Header Row',
    titleSelectItemsToCopy: 'Select Items to Copy',
    titleSelectPartsForBaseCode: 'Select Part Number(s) for Base Code <strong>{{number}}</strong>',
    titleSelectPartsForPricingGroup: 'Select Part Number(s) for Pricing Group <strong>{{number}}</strong>',
    titleSelectQuote: 'Select {{quoteType}} {{entityType}}',
    titleSelectSpaCost: 'Select SPA Cost',
    titleSendAsSpa: 'Send as SPA',
    titleSendAsSpaSuccess: 'Congratulations!',
    titleSetUp: 'Set Up',
    titleSetUpAccount: 'Set Up Your Account',
    titleShippingFieldsChangeWarning: 'Shipping Location/Shipment Type Warning',
    titleShipTo: 'Ship To',
    titleSignIn: 'Sign In',
    titleSignUp: 'Create Your Free Account',
    titleSoldTo: 'Sold To',
    titleSolveProblems: 'Solve Problems',
    titleSpecifications: 'Specifications',
    titleStatus: 'Status',
    titleStep: 'Step {{stepIndex}} <countWrapper>of {{stepsCount}}</countWrapper>: {{stepTitle}}',
    titleSubmissionTimedOutDetails: 'Submission Timed Out Details',
    titleSubmitOrder: 'Submit Order',
    titleSubmitOrderLog: 'Submit Order Payload Log',
    titleSuccess: 'Success',
    titleSupportRequestAddJobs: 'Support Request - Add Jobs',
    titleSupportRequestEditJob: 'Support Request #{{id}} - Edit Jobs',
    titleSupportRequestId: 'Support Request #{{id}}',
    titleSystemSettingsUsersPage: 'System Settings - Users',
    titleTaxonomy: 'Taxonomy',
    titleTopBlockLeftSupportRequest: 'Project: {{projectName}}',
    titleTopBlockRightSupportRequest: 'Opportunity for: {{customerCompanyName}} ({{customerName}})',
    titleTotalCost: 'Total <priceWrapper><price /></priceWrapper>',
    titleTotalPrice: '{{label}}: <priceWrapper><price /></priceWrapper>',
    titleTotalValue: '{{label}}: <valueWrapper>{{ value }}</valueWrapper>',
    titleTryToCreateBom: 'Let\'s try to create a BoM',
    titleTssAtsSupportRequest: 'TSS/ATS<br />Support Request',
    titleTssAtsSupportRequestPlain: 'TSS/ATS Support Request',
    titleUnknownManufacturers: 'Unknown Manufacturers',
    titleUnpublishPartFinderFamilies_one: 'Unpublish Family',
    titleUnpublishPartFinderFamilies_other: 'Unpublish Families',
    titleUnsavedChanges: 'Unsaved Changes',
    titleUomConversionAudit: 'Vendor Quote UOM Conversion Audit',
    titleUoms: 'UOMs',
    titleUpdateAdminUser: 'Update Admin User',
    titleUpdateCompanyPart: 'Update Company Part',
    titleUpdateCostingCalculation: 'Update Costing Calculation',
    titleUpdateCostingProfile_one: 'Update Costing Profile',
    titleUpdateCostingProfile_other: 'Update Costing Profiles',
    titleUpdatedAt: 'Updated At: {{date}}',
    titleUpdateDiscountRule: 'Update Discount Rule',
    titleUpdateElement: 'Update Element',
    titleUpdateElementTemplate: 'Update Element Template',
    titleUpdateFile: 'Update File',
    titleUpdateJobDetails: 'Update Job Details',
    titleUpdateLine: 'Update Line',
    titleUpdateLog: 'Update Log',
    titleUpdateMarginRule: 'Update Margin Rule',
    titleUpdateOrderLocation: 'Update Sales Location',
    titleUpdatePricingProfile_one: 'Update Pricing Profile',
    titleUpdatePricingProfile_other: 'Update Pricing Profiles',
    titleUpdatePricingProfileAccess: 'Update Access',
    titleUpdatePricingProfilePartNumber: 'Update Fixed Price',
    titleUpdateProject: 'Update Project',
    titleUpdateQuote: 'Update Quote',
    titleUpdateQuoteLocation: 'Update Quoted Location',
    titleUpdateSelected: 'Update Selected',
    titleUpdateUomConversion: 'Update UOM Conversion',
    titleUpdateVideo: 'Update Video',
    titleUploadFile: 'Upload File',
    titleValidationError: 'Validation Error!',
    titleVendorContacts: 'Vendor Contacts',
    titleVendorCustomerPartNumber: 'V: {{vendorCustomerPartNumber}}',
    titleVendorInfoTooltipEditable: 'Click to see Vendor Information or change the Vendor.',
    titleVendorInfoTooltipNonEditable: 'Click to see Vendor Information.',
    titleVendorOrders: 'Vendor Orders',
    titleVendorPrimaryContact_other: 'Primary Contact',
    titleVendorPrimaryContact_zero: 'Primary Contact (-)',
    titleVendorPurchasingAttributes: 'Purchasing Attributes ({{lengthValue}})',
    titleVendorQuote: 'Vendor {{entityType}} #{{id}} - v{{version}}',
    titleVendorQuoteLog: 'Vendor Quote Import Log',
    titleVendorQuotes: 'Vendor Quotes',
    titleVendors: 'Vendors',
    titleVendorShippingLocation: 'Shipping Location: <strong>{{shippingLocation}}</strong>',
    titleWarning: 'Warning',
    tooltipAccountViaProject_one:
      'This account is not on the program itself. It is linked through project {{projectNumbers}}, which is part of this program.',
    tooltipAccountViaProject_other:
      'This account is not on the program itself. It is linked through projects {{projectNumbers}}, which are part of this program.',
    tooltipAddUomConversionsMixedUoms:
      'Select rows that share one Base UOM and one Extracted UOM — the same conversion is written to every selected part.',
    tooltipAddUomConversionsNoCorporatePart:
      'Deselect the "No Corporate Part" rows — they have no company part record for a conversion to apply to. Set those parts up first.',
    tooltipAddUomConversionsNoManufacturer:
      'Deselect the rows with no manufacturer — a conversion is identified by part number and manufacturer, so those cannot be saved.',
    tooltipAttributesEditBlocked: 'The Attributes of this quote cannot be edited.',
    tooltipBulkExportSkuPartsDisabled:
      'Select at least one imported alternate vendor quote to export.',
    tooltipBulkSendAsSpaAllAlreadySent:
      'Select at least one imported alternate vendor quote that has not been sent as SPA or has changed since it was sent.',
    tooltipBulkSendAsSpaBlockers: 'Fix the blockers listed above first.',
    tooltipBulkSendAsSpaDisabled:
      'Select at least one imported alternate vendor quote to send.',
    tooltipCacheDetails: 'Show what the {{cache}} cache holds',
    tooltipClearCache: 'Clear the {{cache}} cache',
    tooltipConsumerJobStale:
      'Marked running, but the consumer that was running it is gone. Canceling this only corrects the record.',
    tooltipConsumerJobStuck:
      'No change for over {{hours}} hours. A queued job this old was never picked up; a running one is almost certainly wedged.',
    tooltipCopyPartNumber: 'Copy part number',
    tooltipCopyPayload: 'Copy request payload',
    tooltipCopyShipToFromQuote: 'If checked, the exact Ship To address from the quote will be copied over to the order.',
    tooltipCopySku: 'Copy SKU',
    tooltipCopySpaCostRegistrationNum: 'Copy Reg Number',
    tooltipCopySpaCostSource: 'Copy SPA Cost Source',
    tooltipDoublePersist:
      'This extraction was persisted more than once (webhook + poll race). Before the #869egp3ff fix this duplicated quote parts; after it, rows were replaced silently.',
    tooltipDownloadImportFile: 'Download the uploaded document.',
    tooltipEditCompanyPartDetailsNoManufacturer:
      'Deselect the rows with no manufacturer — a company part is identified by part number and manufacturer, so those cannot be saved.',
    tooltipHeaderError:
      'What went wrong with the upload, followed by why its part rows failed to import. The row-level messages are recorded per row and appear nowhere else.',
    tooltipHeaderFileName: 'The document that was uploaded. Click a name to download it.',
    tooltipHeaderImportedParts: 'Staged part rows that imported into the quote.',
    tooltipHeaderPartsFromPayload: 'Line items the extraction reported.',
    tooltipInactiveAccountLink: 'Inactive: this account is no longer linked to the project.',
    tooltipInternalNoteInfo: 'Only visible to your team. The customer never sees internal notes.',
    tooltipManufacturerDiscountsOnly:
      'This upload staged only discount items, so it has no part item to take a manufacturer from.',
    tooltipManufacturerNoneReceived:
      'The extraction payload did not provide a manufacturer for this upload.',
    tooltipManufacturerNotPersisted:
      'The import failed before any part data was saved, so no manufacturer is available.',
    tooltipNoPartsImported:
      'Every staged part row failed to import, so this upload put nothing into the quote. A successful outcome here means the extraction finished, not that the parts landed.',
    tooltipOpenImportDetails: 'Open this upload\u2019s details and its raw log trace.',
    tooltipOrderAlreadySubmittedExternal: 'Already submitted to the external order system as {{externalOrderNumber}}.',
    tooltipOrderingInProgress: 'The order has been sent for processing. This page will update automatically.',
    tooltipOrderStatusDoNotRefresh: 'Please don\u2019t refresh the page.',
    tooltipOrderStatusFailedSubtitle: 'An error occurred while sending the order to the external system. Please review the details below and try again.',
    tooltipOrderStatusFailedTitle: 'Your order submission failed.',
    tooltipOrderStatusSubtitle: 'This may take up to 60 seconds while we send the order to an external system and wait for confirmation.',
    tooltipOrderStatusSuccessSubtitle: 'The order was successfully sent to the external system and confirmed.',
    tooltipOrderStatusSuccessTitle: 'Your order has been submitted.',
    tooltipOrderStatusTitle: 'Your order is being submitted.',
    tooltipPartsImportedRatio:
      'How many of the staged part rows actually imported into the quote.',
    tooltipPollDefused:
      'The poll loop exited because the data was already delivered. This is normal, healthy behavior.',
    tooltipPreviewImportFile: 'Preview the uploaded document.',
    tooltipPricingDate: 'Select a future date or leave empty to use the current date.',
    tooltipProcessedElsewhere:
      'The extraction was delivered to and processed by another instance, so this environment recorded no delivery method or result time for it.',
    tooltipRefreshConsumerJobs: 'Refresh the job list now',
    tooltipRefreshReport: 'Refresh',
    tooltipRestartConsumers: 'Restart the consumers for {{env}}',
    tooltipRestartConsumersBusy: 'Waiting for the {{env}} restart to finish',
    tooltipRestartConsumersCooldown: 'Just restarted — wait a moment before restarting again',
    tooltipRestartConsumersCurrent: 'Restart the consumers for {{env}} — the environment you are viewing',
    tooltipRowsSkipped_one:
      '{{count}} line item had no part number, so it was skipped instead of imported. The rest of the upload imported normally.',
    tooltipRowsSkipped_other:
      '{{count}} line items had no part number, so they were skipped instead of imported. The rest of the upload imported normally.',
    tooltipSendAsSpaAlreadySent: 'This vendor quote has already been sent as SPA.',
    tooltipSendAsSpaInProgress: 'A send as SPA is already in progress for this vendor quote.',
    tooltipSendAsSpaPreviewNotReady: 'Generate the preview first.',
    tooltipSendAsSpaPreviewSendInProgress: 'A send is in progress.',
    tooltipSendAsSpaSentUnchanged: 'Sent as v{{version}}; nothing changed since.',
    tooltipSendToFileNetAlreadySent: 'The quote file was already sent to FileNet.',
    tooltipSendToFileNetInProgress: 'A send to FileNet is already in progress for this quote file.',
    tooltipSendToFileNetIntegrationMissing: 'The FileNet integration is not set up for this company.',
    tooltipShowAllUploads: 'Show every upload in the range',
    tooltipShowProblemUploadsOnly: 'Show only uploads that need attention',
    tooltipSpaAlreadyInUse: 'This SPA is already used.',
    tooltipStaleRowsCleared_one:
      'A second delivery got past every persist-once guard and {{count}} staged row was replaced. This should never happen — the guards need investigation.',
    tooltipStaleRowsCleared_other:
      'A second delivery got past every persist-once guard and {{count}} staged rows were replaced. This should never happen — the guards need investigation.',
    tooltipSubmissionTimedOut:
      'Submission timed out — waiting for the external order system to report back.',
    tooltipTradeAgreementStartDate: 'The date the pricing first becomes active.',
    tooltipTradeAgreementUpdatedPostSent:
      'Changed since it was sent as SPA and not resent yet.',
    tooltipTradeAgreementUpdatedPostSentVersion:
      'Changed since v{{version}} was sent as SPA and not resent yet.',
    tooltipUpdateMatchingLinesRequiresCombine:
      'Updating existing lines requires one row per part in the file',
    tooltipUpdateUomsNoCorporatePart:
      'Deselect the "No Corporate Part" rows — they have no company part record to assign UOMs to.',
    tooltipViewPayload: 'View request payload',

    // Warnings
    warningAllComponentsBelongToElement: 'All the components/parts already belong to the selected element.',
    warningCharacterLimitExceeded: "You've entered {{count}} characters. The maximum allowed is {{max}}.",
    warningCustomerNoteTooLong: 'Customer Note exceeds 500 characters.',
    warningCustomerNoteTooLongAction: 'Edit the Customer Note to reduce its length.',
    warningMarginBelowMinimumThreshold: 'Margin is below the minimum margin threshold of {{minimum}}.',
    warningOrderPartValidationDisallowedManufacturer: 'Part number from a disallowed manufacturer',
    warningOrderPartValidationExternalPartStatusAbandoned: 'Abandoned part number cannot be used',
    warningOrderPartValidationInactiveBillToProjectLink: 'The Bill-To location is no longer linked to the selected project.',
    warningOrderPartValidationInactiveBillToProjectLinkAction: 'Select a different Bill-To location or project.',
    warningOrderPartValidationInactiveShipToProjectLink: 'The Ship-To location is no longer linked to the selected project.',
    warningOrderPartValidationInactiveShipToProjectLinkAction: 'Select a different Ship-To location or project.',
    warningOrderPartValidationInvalidQuantityDecimal: 'Quantity must be a whole number',
    warningOrderPartValidationMissingCost: 'Cost must be entered',
    warningOrderPartValidationMissingDescription: 'Part Description must be entered',
    warningOrderPartValidationMissingManufacturer: 'Manufacturer must be entered',
    warningOrderPartValidationMissingOneTimeSpaValidUntil: 'Valid until is required for a one-time SPA cost',
    warningOrderPartValidationMissingPrice: 'Price must be entered',
    warningOrderPartValidationMissingReplacementCost: 'Replacement Cost needs to be entered',
    warningOrderPartValidationMissingReplacementCostNumber: 'Replacement Cost Number must be entered',
    warningOrderPartValidationMissingShipmentType: 'Shipment Type must be entered',
    warningOrderPartValidationMissingShippingLocation: 'Shipping Location must be entered',
    warningOrderPartValidationMissingTaxonomy: 'Taxonomy selection is required',
    warningOrderPartValidationMissingVendor: 'Vendor must be entered',
    warningOrderPartValidationMissingVendorQuoteNumber: 'Vendor Quote number needs to be entered',
    warningOrderPartValidationNoArNumber: 'The Bill-To location has no valid AR number.',
    warningOrderPartValidationNoArNumberAction: 'Select a different Bill-To location with a valid AR number.',
    warningOrderPartValidationNoArNumberDescription: '(Or enable the location for billing in CPQ with the help of the Credit Team.)',
    warningOrderPartValidationNoIsrEmployee: 'An ISR must be assigned before submitting.',
    warningOrderPartValidationNoIsrEmployeeAction: 'You can assign an ISR in the Quoted By section.',
    warningOrderPartValidationNoOsrEmployee: 'An OSR must be assigned before submitting.',
    warningOrderPartValidationNoOsrEmployeeAction: 'You can assign an OSR in the Quoted By section.',
    warningOrderPartValidationNoteBuyerTooLong: 'Buyer Internal Note cannot exceed 500 characters',
    warningOrderPartValidationNotePickerTooLong: 'Packer Line Note cannot exceed 500 characters',
    warningOrderPartValidationNoteSupshipTooLong: 'Supplier PO Shipping Note cannot exceed 100 characters',
    warningOrderPartValidationOnLinesPrefix: '{{error}} on lines:',
    warningOrderPartValidationPartNumberTooLong: 'Part number exceeds {{max}} characters',
    warningOrderPartValidationPastOneTimeSpaValidUntil: 'Valid until is in the past',
    warningOrderPartValidationWrongShippingLocationType: 'Shipping Location is not valid',
    warningPartNotSetAtLocation: 'Part is not yet set up at this location.',
    warningPartNumberAbandoned: 'This part number has been abandoned and cannot be used.',
    warningPriceBelowFloorPrice: 'Price is less than floor price of {{floorPrice}}.',
    warningPricingDateExpired:
      'This pricing date has passed and will not be used. Clear it to use the current date, or change it to a future date.',
    warningPurchaseOrderNumberTooLong: 'Purchase Order Number cannot exceed {{max}} characters.',
    warningPurchaseOrderNumberTooLongAction: 'Edit the Purchase Order Number to reduce its length.',
    warningQuoteCustomerNoteSave: 'This message will be available for the customer. Are you sure you want to save it?',
    warningReplacementCostNonStock: 'Supplier is a Ship & Debit Vendor. Are you sure this is a buy quote? If you have a One Time Ship & Debit this is not the right place to enter it.',
    warningReplacementStandardCostUnavailable:
      'Replacement pricing is selected but the standard cost is not available.',
    warningSupportRequestLevelChange: 'Changing the support request level may result in a different user being assigned to all the jobs associated with this support request. Are you sure you want to continue?',

    // Subtitles
    subtitleAddElementTemplateToJob: 'Add element template <strong>{{template}}</strong> to a job',
    subtitleCopyMoveToElement_one: 'Part Number: <strong>{{partNumber}}</strong>.',
    subtitleCopyMoveToElement_other: '<strong>{{count}}</strong> parts.',
    subtitleForSelectedPart_one: '<wrapper>For Part Number: <valueWrapper>{{partNumber}}</valueWrapper>.</wrapper>',
    subtitleForSelectedPart_other: '<wrapper>For <valueWrapper>{{count}}</valueWrapper> parts.</wrapper>',
    subtitleForSelectedPartComponent: '<wrapper>For: <valueWrapper>{{componentName}}</valueWrapper>.</wrapper>',
    subtitleForSelectedPartsCount_one: 'For: <strong>{{count}}</strong> part.',
    subtitleForSelectedPartsCount_other: 'For: <strong>{{count}}</strong> parts.',
    subtitleJobPartsAddToJob_one: 'Selected part: <strong>{{number}}</strong>.',
    subtitleJobPartsAddToJob_other: 'Selected <strong>{{count}}</strong> parts.',
    subtitleLastUpdate: '<labelWrapper>Last Update:</labelWrapper> <valueWrapper>{{value}}</valueWrapper>',
    subtitleManageElementsComponent: 'Component: <strong>{{componentName}}</strong>',
    subtitleManageElementsPart: 'Part Number: <strong>{{partNumber}}</strong>',
    subtitleMergeContactGroups: 'Select which option will be applied to the new company.',
    subtitleMergeCustomerContactGroups: 'Are you sure you want to merge the <contactGroupWrapper>{{mainContactGroup}}</contactGroupWrapper> into the <contactGroupWrapper>{{otherContactGroup}}</contactGroupWrapper>?',
    subtitleMergeLocations: 'Select which option will be applied to the new location.',
    subtitleNotesLastUpdate_one: '<valueWrapper>{{ count }} note</valueWrapper>, <labelWrapper>Last Update:</labelWrapper> <valueWrapper>{{value}}</valueWrapper>',
    subtitleNotesLastUpdate_other: '<valueWrapper>{{ count }} notes</valueWrapper>, <labelWrapper>Last Update:</labelWrapper> <valueWrapper>{{value}}</valueWrapper>',
    subtitlePartFinderCatalog:
      'An interactive, step-by-step tool for quickly and accurately searching for and configuring parts using a system of smart filters.',
    subtitleVendorQuoteDetails: 'Vendor Project Name: <valueWrapper>{{projectName}}</valueWrapper>',

    // Stories translations
    alertGoToParts: 'Go to parts: {{value}}.',
    alertGoToPartsFromEnter: 'Enter Clicked! Go to parts: {{value}}.',
    alertGoToPartsFromIcon: 'Icon Clicked! Go to parts: {{value}}.',

    labelEmptyValue: 'empty value',

    // Placeholders
    placeholderAnyLocation: 'Any location',
    placeholderAskAI: 'Ask AI',
    placeholderChooseManufacturer: 'Choose Manufacturer',
    placeholderChooseUom: 'Choose UOM',
    placeholderContact: 'Select a Contact',
    placeholderElementQuantity: 'Quantity of element',
    placeholderEnterAlternateVendorId: 'Enter Alternate Vendor ID',
    placeholderEnterAlternateVendorName: 'Enter Alternate Vendor Name',
    placeholderEnterCustomerNumber: 'Enter Customer Number',
    placeholderEnterDigits: 'Enter {{count}} digits',
    placeholderEnterElementName: 'Enter Element Name',
    placeholderEnterVendorId: 'Enter Vendor ID',
    placeholderEnterVendorName: 'Enter Vendor Name',
    placeholderLocation: 'Select a Location',
    placeholderNote: 'Type your note here',
    placeholderNotes: 'Type your notes here',
    placeholderPartBomDescription: 'Add description',
    placeholderPartBomNewNumber: 'Enter the New Part Number',
    placeholderPartBomNumber: 'Select a Part Number',
    placeholderPartBomQuantity: 'Quantity',
    placeholderPartBomSource: 'Select a Part Number to copy',
    placeholderPartBomType: 'Select type',
    placeholderPartBomUom: 'UOM',
    placeholderPartFinderNumber: 'Type a number here ({{range}})',
    placeholderPricingDateCurrent: 'Current date',
    placeholderQuantity: 'Quantity',
    placeholderSearchCustomers: 'Search and add customers',
    placeholderSearchSalesLocations: 'Search and add sales locations',
    placeholderSearchShippingLocations: 'Search and add shipping locations',
    placeholderSelectColumnHeader: 'Select Column Header',
    placeholderSelectComponent: 'Select Component',
    placeholderSelectContactGrouping: 'Select Contact Group',
    placeholderSelectCustomer: 'Select Customer',
    placeholderSelectElement: 'Select Element',
    placeholderSelectElementName: 'Select Element Name',
    placeholderSelectElementTemplate: 'Select Element Template',
    placeholderSelectLocation: 'Select Location',
    placeholderSelectOption: 'Select an option',
    placeholderSelectPricingProfile: 'Select Pricing Profile',
    placeholderSelectProject: 'Select a project',
    placeholderSelectRegion: 'Select Region',
    placeholderSelectSpaPriority: 'Select a priority',
    placeholderSelectTask: 'Select Task',
    placeholderSelectTradeAgreementOwner: 'Select an SPA owner',
    placeholderSelectUser: 'Select User',
    placeholderSelectUsers: 'Select Users',
    placeholderSelectVendor: 'Select Vendor',
    placeholderUom: 'UOM',
    placeholderUpsertLineCorporateLocation: 'Sales Location',
    placeholderUpsertLineDescription: 'Add description',
    placeholderUpsertLineMargin: 'Margin',
    placeholderUpsertLinePartNumber: 'Type part number or description',
    placeholderUpsertLinePrice: 'Price',
    placeholderUpsertLinePriceDecimals: 'Enter decimals for pricing (max 5).',
    placeholderUpsertLineQuantity: 'Quantity',
    placeholderUpsertLineShipmentType: 'Shipment Type',
    placeholderUpsertLineUnitCost: 'Unit Cost',
    placeholderUpsertLineUom: 'UOM',
    placeholderValidUntilRequired: 'Valid Until *',
    placeholderValueName: 'Value name',
    placeholderVendor: 'Search for Vendor',
    placeholderVendorSearch: 'Vendor Search',

    // Table Headers
    changeUomTo: 'Change UOM to',
    headerAccess: 'Access',
    headerAccountNumber: 'Account Number',
    headerAccountsPayableId: 'Accts. Payable ID',
    headerActions: 'Actions',
    headerActivityDate: 'Activity Date',
    headerAdder: 'Adder',
    headerAddress: 'Address',
    headerAgreementId: 'Agreement ID',
    headerAlias: 'Alias',
    headerAllInventory: 'All Inventory',
    headerAllocated: 'Allocated',
    headerAlternate: 'Alternate',
    headerAlternateSalesUom: 'Alternate Sales UOM',
    headerAlternateUom: 'Alternate UOM',
    headerAnomalies: 'Anomalies',
    headerAPNumber: 'AP Number',
    headerApplyDiscountTo: 'Apply Discount To',
    headerARNumber: 'AR Number',
    headerAssignedTo: 'Assigned To',
    headerAssignManufacturer: 'Assign Manufacturer',
    headerAssignTo: 'Assign To',
    headerAssociationStatus: 'Association Status',
    headerAssociationTypes: 'Association Types',
    headerAttachedTo: 'Attached To',
    headerAttributes: 'Attributes',
    headerAvailable: 'Available',
    headerBackOrdered: 'Back Ordered',
    headerBase: 'Base',
    headerBaseUom: 'Base UOM',
    headerBillTo: 'Bill To',
    headerBillToAccount: 'Bill to Account',
    headerBillToAccountName: 'Bill to Account Name',
    headerBillToARNumber: 'Bill To AR Number',
    headerBuyQuantity: 'Buy Quantity',
    headerCategories: 'Categories',
    headerCategory: 'Category',
    headerCity: 'City',
    headerCloseConfidence: 'Close Confidence',
    headerCloseDate: 'Close Date',
    headerCompany: 'Company',
    headerCompanyId: 'Company ID',
    headerCompanyPartSpecificationCriteria: 'Company Part Specification Criteria',
    headerCompletedDate: 'Completed Date',
    headerComponentName: 'Component Name',
    headerContact: 'Contact',
    headerContactGrouping: 'Contact Group',
    headerContactGroups: 'Vendors',
    headerContactGroupWebsite: 'Vendor Site',
    headerCost: 'Cost',
    headerCostNote: 'Cost Note',
    headerCostPerHour: 'Cost Per Hour',
    headerCostPerUom: 'Cost Per UOM',
    headerCostSource: 'Cost Source',
    headerCountry: 'Country',
    headerCreated: 'Created',
    headerCreatedBy: 'Created By',
    headerCurrentQuantity: 'Current Quantity',
    headerCustomer: 'Customer',
    headerCustomerCompany: 'Customer Company',
    headerCustomerName: 'Customer Name',
    headerCustomerNumber: 'Customer Number',
    headerCustomerPartNumber: 'Customer Part Number',
    headerCustomerPoLineNumber: 'Customer PO Line #',
    headerCustomerQuoteIds: 'Customer Quote IDs',
    headerCustomers: 'Customers',
    headerDate: 'Date',
    headerDateTime: 'Date & Time',
    headerDefault: 'Default',
    headerDefaultBillTo: 'Default Bill To',
    headerDefaultShipTo: 'Default Ship To',
    headerDefaultSoldTo: 'Default Sold To',
    headerDeliveredVia: 'Delivered Via',
    headerDescription: 'Description',
    headerDiscipline: 'Discipline',
    headerDiscountIncrease: 'Discount Increase',
    headerDiscountItems: 'Discount Items',
    headerDocumentId: 'Document ID',
    headerDoNotAssignManufacturer: 'Do Not Assign Manufacturer',
    headerDropShipFreightTerms: 'Drop Ship Freight Terms',
    headerDuration: 'Duration',
    headerDurationHours: 'Time (hrs)',
    headerEditCustomers: 'Edit Customers',
    headerEditLine: 'Edit Line',
    headerEditPricing: 'Edit Pricing',
    headerEffectiveDate: 'Effective Date',
    headerElement: 'Element',
    headerElementQuantity: 'Element Quantity',
    headerElements: 'Elements',
    headerEmail: 'Email',
    headerEmailDomains: 'Email Domains',
    headerEndDate: 'End Date',
    headerError: 'Error',
    headerErrorDescription: 'Error Description',
    headerExistingManufacturer: 'Existing Manufacturer',
    headerExpectedShipmentDate: 'Expected shipment date',
    headerExpiryDate: 'Expiry Date',
    headerExtCost: 'Ext Cost',
    headerExternalCustomers: 'External Customers',
    headerExternalOrderNumber: 'External Order #',
    headerExternalPendingOrderNumber: 'External Pending Order #',
    headerExternalProgramNumber: 'External Program ID',
    headerExternalProjectNumber: 'External Project ID',
    headerExternalSpaCost: 'SPA Purchase Cost',
    headerExternalSpaCostEndDate: 'SPA Cost End Date',
    headerExternalSpaCostRegistrationNumber: 'SPA Cost Reg Number',
    headerExternalSpaCostSource: 'SPA Cost Source',
    headerExternalSpaCostSourceName: 'SPA Cost Source Name',
    headerExternalStatus: 'External Status',
    headerExternalUom: 'External UOM',
    headerExtPrice: 'Ext Price',
    headerExtPurchaseCost: 'Ext Purchase Cost',
    headerExtractedUom: 'Extracted UOM',
    headerExtractorId: 'Extractor ID',
    headerExtStandardCost: 'Ext Standard Cost',
    headerFamilies: 'Families',
    headerFileName: 'File Name',
    headerFilters: 'Filters',
    headerFixedPrice: 'Fixed Price',
    headerFloorPrice: 'Floor Price',
    headerFrequency: 'Frequency',
    headerGrossProfit: 'GP%',
    headerGroup: 'Group',
    headerGroupedColumn: '{{headerName}} Group',
    headerHttpStatus: 'HTTP Status',
    headerId: 'ID',
    headerIdentifier: 'Identifier',
    headerImage: 'Image',
    headerImportedManufacturer: 'Imported Manufacturer',
    headerImportedParts: 'Imported',
    headerImportId: 'Import ID',
    headerImportNotes: 'Import Notes',
    headerInventory: 'Inventory',
    headerInventoryStatus: 'Inventory Status',
    headerInventoryUom: 'Inventory UOM',
    headerIsr: 'ISR',
    headerIsrEmployees: 'ISRs',
    headerJob: 'Job',
    headerJobId: 'Job #',
    headerJobName: 'Job Name',
    headerLastUpdated: 'Last Updated',
    headerLeadTimeNote: 'Lead Time Note',
    headerLegacyVendorNumbers: 'Legacy Vendor Numbers',
    headerLength: 'Length',
    headerLineType: 'Line Type',
    headerListPrice: 'List Price',
    headerLocation: 'Location',
    headerLocationInventory: 'Location Inventory',
    headerLocationName: 'Location Name',
    headerLocations: 'Locations',
    headerLock: 'Lock',
    headerManufacturer: 'Manufacturer',
    headerManufacturers: 'Manufacturers',
    headerMargin: 'Margin',
    headerMarginReduction: 'Margin Reduction',
    headerMaxQty: 'Max QTY',
    headerMinimumOrderFee: 'Minimum Order Fee',
    headerMinQty: 'Min QTY',
    headerMultiplier: 'Multiplier',
    headerName: 'Name',
    headerNewQuantity: 'New Quantity',
    headerNote: 'Note',
    headerNotes: 'Notes',
    headerNotifications: 'Notifications',
    headerOmit: 'Omit',
    headerOnHand: 'On Hand',
    headerOnOrder: 'On Order',
    headerOrderId: 'Order #',
    headerOrderState: 'Order State',
    headerOrderValue: 'Order Value',
    headerOriginalQuantity: 'Original Quantity',
    headerOsr: 'OSR',
    headerOsrEmployees: 'OSRs',
    headerOwner: 'Owner',
    headerPackageUom: 'Package UOM',
    headerPackaging: 'Packaging',
    headerPartDataSheet: 'Data Sheet',
    headerPartfinitiManufacturer: 'Partfiniti Manufacturer',
    headerPartNumber: 'Part Number',
    headerParts: 'Parts',
    headerPartSpecificationCriteria: 'Part Specification Criteria',
    headerPayload: 'Payload',
    headerPhone: 'Phone',
    headerPoCreationDate: 'PO Creation Date',
    headerPolls: 'Polls',
    headerPoNumber: 'PO Number',
    headerPossibleManufacturers: 'Possible Manufacturers',
    headerPrice: 'Price',
    headerPricePerHour: 'Price Per Hour',
    headerPriceSource: 'Price Source',
    headerPricingDate: 'Pricing Date',
    headerPricingStrategy: 'Pricing Strategy',
    headerPricingType: 'Pricing Type',
    headerProductType: 'Product Type',
    headerProfile: 'Profile',
    headerProfileName: 'Profile Name',
    headerProfileType: 'Profile Type',
    headerProgramId: 'Program ID',
    headerProject: 'Project',
    headerProjectId: 'ID',
    headerProjectName: 'Name',
    headerProjectNames: 'Project Names',
    headerProjectNumbers: 'Project Numbers',
    headerPromiseDate: 'Promise Date',
    headerPurchaseCost: 'Purchase Cost',
    headerPurchaseCostUom: 'Purchase Cost UOM',
    headerPurchaseOrder: 'Purchase Order',
    headerPurchaseOrderNumber: 'Purchase Order #',
    headerQty: 'Qty',
    headerQuantity: 'Quantity',
    headerQuantityPerElement: 'Quantity/Element',
    headerQuoteCustomerId: 'Quote Customer #',
    headerQuotedBy: 'Quoted By',
    headerQuotedTo: 'Quoted To',
    headerQuoteId: 'Quote #',
    headerQuoteIds: 'Quote IDs',
    headerQuoteState: 'Quote State',
    headerReelId: 'Reel ID',
    headerReelLength: 'Reel length',
    headerReelType: 'Reel Type',
    headerRegion: 'Region',
    headerRegions: 'Regions',
    headerReleaseValue: 'Release Value',
    headerReplacementCost: 'Replacement Cost',
    headerRequested: 'Requested',
    headerRequestedBy: 'Requested By',
    headerRequestedDate: 'Requested Date',
    headerRestrictedAvailable: 'Restricted Available',
    headerResult: 'Result',
    headerRole: 'Role',
    headerSalesLocation: 'Sales Location',
    headerSalesOrder: 'Sales Order',
    headerSalesUom: 'Sales UOM',
    headerSellPrice: 'Sell Price',
    headerSentToFileNet: 'Sent to FileNet',
    headerShipDays: 'Ship Days',
    headerShipFromLocation: 'Ship From Location',
    headerShipmentType: 'Shipment Type',
    headerShippingLocation: 'Shipping Location',
    headerShipTo: 'Ship To',
    headerShipType: 'Ship Type',
    headerSizeKb: 'Size (KB)',
    headerSku: 'SKU',
    headerSkuUoms: 'SKU UOMs',
    headerSource: 'Source',
    headerSpaEnabled: 'SPA Enabled',
    headerSpecialCost: 'Special Cost',
    headerSpecialStdCost: 'Special Std Cost',
    headerStandardCost: 'Standard Cost',
    headerStartDate: 'Start Date',
    headerState: 'State',
    headerStatus: 'Status',
    headerSuggestedARNumber: 'Suggested AR Number',
    headerSupplierNumber: 'Supplier Number',
    headerSupportRequestId: 'Support Request #',
    headerTask: 'Task',
    headerTheatre: 'Theatre',
    headerTotalQuantity: 'Total Quantity',
    headerTradeAgreementOwner: 'SPA Owner',
    headerTradeAgreementStatus: 'Send as SPA Status',
    headerType: 'Type',
    headerUnifiedPartStatus: 'Unified Status',
    headerUnitCost: 'Unit Cost',
    headerUnitPrice: 'Unit Price',
    headerUom: 'UOM',
    headerUpdated: 'Updated',
    headerUpdatedAt: 'Updated At',
    headerUpdatedBy: 'Updated By',
    headerUpdatedOn: 'Updated On',
    headerUser: 'User',
    headerUsers: 'Users',
    headerValidity: 'Validity',
    headerValidityErrors: 'Validity Errors',
    headerValidSince: 'Valid Since',
    headerValidUntil: 'Valid Until',
    headerValue: 'Value',
    headerValues: 'Values',
    headerValueType: 'Value Type',
    headerVendor: 'Vendor',
    headerVendorCompany: 'Vendor Company',
    headerVendorContact: 'Vendor Contact',
    headerVendorLocation: 'Vendor Location',
    headerVendorName: 'Vendor',
    headerVendorNumbers: 'Vendor Numbers',
    headerVendorProject: 'Vendor Project',
    headerVendorQuote: "Vendor's Quote",
    headerVendorQuoteId: 'Vendor Quote ID',
    headerVendorQuoteNumber: "Vendor's Quote Number",
    headerVendors: 'Vendors',
    headerVersion: 'Version',
    headerVersionType: 'Type',
    headerVerticalMarket: 'Vertical Market',
    headerVisibility: 'Visibility',
    headerWebsite: 'Website',
    headerZip: 'Zip',

    // Input Helper Text
    helperTextMargin: 'Margin that you will make as profit based on the cost and the price',
  },
};
